import { useState as $e, useCallback as at, useEffect as Je, useRef as e0, useLayoutEffect as _9 } from "react";
function $5(t) {
  const { apiCall: e, onResponse: r, onError: n } = typeof t == "function" ? { apiCall: t } : t, [d, a] = $e(), [i, u] = $e(), [o, s] = $e(!1), [c, f] = $e(!1), [l, _] = $e(!1), [p, $] = $e(!1);
  return { submit: async (g) => {
    try {
      s(!0), $(!1), a(void 0), f(!1), _(!1);
      const A = await e(g);
      u(A), f(!0), r == null || r(A);
    } catch (A) {
      const R = { status: A.status, code: A.code, data: A.data };
      a(R), _(!0), n == null || n(R);
    } finally {
      s(!1), $(!0);
    }
  }, isApiLoading: o, apiResponse: i, apiError: d, isApiLoaded: p, isApiOk: c, isApiError: l };
}
const v5 = (t = !1) => {
  const [e, r] = $e(t), n = at(() => {
    r(!0);
  }, []), d = at(() => {
    r(!1);
  }, []), a = at(() => {
    r((i) => !i);
  }, []);
  return { value: e, set: n, unset: d, toggle: a };
};
function p5(t, e) {
  const [r, n] = $e(t);
  return Je(() => {
    const d = setTimeout(() => {
      n(t);
    }, e);
    return () => {
      clearTimeout(d);
    };
  }, [t, e]), r;
}
function B(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function I9(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var d = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, d.get ? d : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var be = {}, Me = {}, K = {}, j = {}, A0;
function pn() {
  if (A0) return j;
  A0 = 1, Object.defineProperty(j, "__esModule", { value: !0 }), j.PropValueProvider = j.IdentityProvider = j.ValueProvider = void 0, j.nullIfEmpty = t, j.trimBlank = e, j.trimStrings = r, j.nvl = n, j.isBlank = d, j.isBlankObject = a, j.isEmpty = i, j.omit = u, j.omitUntyped = o, j.pick = s, j.pickAndSkipUndefined = c, j.pickUntyped = f, j.isPrimitiveValue = l, j.mapObject = _, j.assignOwnProps = p, j.prop = $, j.deepSortObject = R;
  function t(y) {
    return y && Object.entries(y).find(([O, P]) => !d(P)) ? y : null;
  }
  function e(y) {
    if (d(y))
      return;
    if (typeof y != "object" || y instanceof Date)
      return y;
    if (Array.isArray(y))
      return y.map((b) => e(b)).filter((b) => !d(b));
    let S = !1, O = !1;
    const P = Object.entries(y).reduce((b, [I, E]) => {
      const T = e(E);
      return Array.isArray(T) ? (b[I] = T, T.length && (O = !0)) : d(T) || (b[I] = T, S = !0), b;
    }, {});
    return S || O ? P : void 0;
  }
  function r(y) {
    return typeof y == "string" ? y.trim() : typeof y == "object" ? Object.entries(y).reduce((S, [O, P]) => (S[O] = r(P), S), {}) : Array.isArray(y) ? y.map((S) => r(S)) : y;
  }
  function n(y, S) {
    return d(y) ? S : y;
  }
  function d(y) {
    return y == null;
  }
  function a(y) {
    return y == null ? !0 : !Object.entries(y).find(([O, P]) => !d(P));
  }
  function i(y) {
    return y == null || y === "";
  }
  function u(y, ...S) {
    const O = Object.assign({}, y);
    return S.forEach((P) => delete O[P]), O;
  }
  function o(y, ...S) {
    const O = Object.assign({}, y);
    return S.forEach((P) => delete O[P]), O;
  }
  function s(y, ...S) {
    return S.reduce((O, P) => (O[P] = y[P], O), {});
  }
  function c(y, ...S) {
    return S.reduce((O, P) => (y[P] !== void 0 && (O[P] = y[P]), O), {});
  }
  function f(y, ...S) {
    return S.reduce((O, P) => (O[P] = y[P], O), {});
  }
  function l(y) {
    const S = typeof y;
    return y == null || S === "string" || S === "number" || S === "boolean" || S === "undefined" || S === "bigint" || S === "symbol" || y instanceof Date;
  }
  function _(y, S) {
    return y && Object.fromEntries(Object.entries(y).map(S));
  }
  function p(y, S) {
    Object.getOwnPropertyNames(y).forEach((O) => {
      y[O] = S[O];
    });
  }
  function $(y, S) {
    if (d(y) || i(S))
      return y;
    let O = y;
    const P = S.split(".");
    for (const b of P)
      if (O = O[b.trim()], d(O))
        return O;
    return O;
  }
  class h {
    // noinspection TypeScriptAbstractClassConstructorCanBeMadeProtected
    constructor(S) {
      this.obj = S;
    }
  }
  j.ValueProvider = h;
  class g extends h {
    get value() {
      return "getId" in this.obj ? { id: this.obj.getId() } : { id: this.obj.id };
    }
  }
  j.IdentityProvider = g;
  class A extends h {
    constructor(S, O) {
      super(S), this.prop = O;
    }
    get value() {
      return $(this.obj, this.prop);
    }
  }
  j.PropValueProvider = A;
  function R(y) {
    const S = y;
    if (typeof S != "object" || S === null)
      return S;
    if (Array.isArray(S))
      return S.map(R);
    const O = Object.keys(S).sort(), P = {};
    return O.forEach((b) => {
      const I = S[b];
      P[b] = typeof I == "object" && I !== null && !(I instanceof Date) ? R(I) : I;
    }), P;
  }
  return j;
}
var Y = {}, S0;
function Xe() {
  if (S0) return Y;
  S0 = 1, Object.defineProperty(Y, "__esModule", { value: !0 }), Y.split = e, Y.camel2snake = r, Y.camel2spine = n, Y.pascal2camel = d, Y.pascal2snake = a, Y.pascal2spine = i, Y.toPascal = u, Y.toSpine = o, Y.toSnake = s, Y.toCamel = c, Y.circularDepsReplacer = f, Y.json = l, Y.jsonStable = _, Y.stringifySafe = p, Y.lpad = g, Y.rpad = A, Y.replaceAll = R, Y.randomString = y, Y.randomCode = S, Y.randomDigits = O, Y.reverse = P, Y.hashCode = b;
  const t = pn();
  function e(I, E) {
    return [I.slice(0, E), I.slice(E)];
  }
  function r(I) {
    return I.replace(/[A-Z]/g, (E) => "_" + E.toLowerCase());
  }
  function n(I) {
    return I.replace(/[A-Z]/g, (E) => "-" + E.toLowerCase());
  }
  function d(I) {
    return I.charAt(0).toLowerCase() + I.slice(1);
  }
  function a(I) {
    return I.charAt(0).toLowerCase() + r(I.slice(1));
  }
  function i(I) {
    return I.charAt(0).toLowerCase() + n(I.slice(1));
  }
  function u(I, E = !1) {
    let U = I.split(/([_-]\w)/g).map((Z) => Z.startsWith("_") || Z.startsWith("-") ? Z.slice(1).toUpperCase() : Z).join("");
    return E && (U = U.split(/([A-Z]+)/g).map((Z) => Z.length > 1 && Z.match(/[A-Z]+/) ? Z.charAt(0) + Z.slice(1).toLowerCase() : Z).join("")), U.charAt(0).toUpperCase() + U.slice(1);
  }
  function o(I) {
    return i(u(I, !0).replace(/ +/, "-"));
  }
  function s(I) {
    return a(u(I, !0).replace(/ +/, "_"));
  }
  function c(I) {
    return d(u(I, !0).replace(/ +/, ""));
  }
  function f() {
    const I = [];
    return function(E, T) {
      if (typeof T == "object" && T !== null) {
        if (I.indexOf(T) !== -1)
          return;
        I.push(T);
      }
      return typeof T == "bigint" ? "big:" + T.toString() : T;
    };
  }
  function l(I, E = " ", T) {
    return JSON.stringify(I, T ?? f(), E === !1 ? "" : E);
  }
  function _(I, E = !1, T) {
    return l((0, t.deepSortObject)(I), E, T);
  }
  function p(I, E, T = "*****") {
    return l($(I, E ?? [/password/gi, /secret/gi, /key/gi, /token/gi], T));
  }
  function $(I, E, T) {
    return (0, t.isPrimitiveValue)(I) ? I : Object.entries(I).reduce((U, [Z, H]) => (E.some((re) => re.test(Z)) && (0, t.isPrimitiveValue)(H) ? U[Z] = T : (0, t.isPrimitiveValue)(H) ? U[Z] = H : Array.isArray(H) ? U[Z] = H.map((re) => $(re, E, T)) : U[Z] = $(H, E, T), U), {});
  }
  function h(I, E) {
    return I > 0 ? E.repeat(I / E.length + 1).slice(0, I) : "";
  }
  function g(I, E, T = " ") {
    return h(E - `${I}`.length, T) + I;
  }
  function A(I, E, T = " ") {
    return I + h(E - `${I}`.length, T);
  }
  function R(I, E, T) {
    return I.replace(
      // eslint-disable-next-line security/detect-non-literal-regexp
      typeof E == "string" ? new RegExp(E, "g") : E,
      T
    );
  }
  function y(I, E = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789") {
    return new Array(I).fill(null).map(() => E.charAt(Math.floor(Math.random() * E.length))).join("");
  }
  function S(I, E = "ABCDEFGHIJKLMNPQRSTUVWXYZ123456789") {
    return y(I, E);
  }
  function O(I) {
    return y(I, "0123456789");
  }
  function P(I) {
    return I.split("").reverse().join("");
  }
  function b(I, E = Number.MAX_SAFE_INTEGER, T = !0) {
    I = T ? P(I) : I;
    const U = 37;
    let Z = 17;
    if (I.length === 0)
      return Z;
    for (let H = 0; H < I.length; H++) {
      const W = I.charCodeAt(H) + (7 ^ H);
      Z = U * Z + W;
    }
    return Math.abs(Z) % E;
  }
  return Y;
}
var b0;
function A9() {
  if (b0) return K;
  b0 = 1, Object.defineProperty(K, "__esModule", { value: !0 }), K.ConcurrentUpdateError = K.DataValidationError = K.ValidationError = K.NotFoundError = K.UnauthorizedImpersonationError = K.AuthorizationError = K.AuthenticationError = K.AppError = K.HttpError = K.TimeoutError = K.Exception = void 0;
  const t = pn(), e = Xe();
  class r extends Error {
    constructor(p, $) {
      var h, g, A, R;
      super(typeof p == "string" ? p : (h = p == null ? void 0 : p.message) !== null && h !== void 0 ? h : (0, e.json)(p, !1)), this.body = p, this.root = $, this.stack = ((g = this.stack) !== null && g !== void 0 ? g : "") + ($ ? `
Root: ` + ((R = (A = $.stack) !== null && A !== void 0 ? A : $.message) !== null && R !== void 0 ? R : $) : ""), Object.setPrototypeOf(this, r.prototype);
    }
  }
  K.Exception = r;
  class n extends r {
    constructor(p, $) {
      super(p ?? "Timeout happened", $), Object.setPrototypeOf(this, n.prototype);
    }
  }
  K.TimeoutError = n;
  class d extends r {
    constructor(p, $, h = 400) {
      super(p, $), this.status = h, Object.setPrototypeOf(this, d.prototype);
    }
  }
  K.HttpError = d;
  class a extends d {
    constructor(p, $, h, g, A = 409) {
      super({ message: p, code: $, args: g }, h, A), this.message = p, this.code = $, this.args = g, Object.setPrototypeOf(this, a.prototype);
    }
  }
  K.AppError = a;
  class i extends a {
    constructor(p, $, h) {
      super(p ?? "Authentication failed.", $ ?? "authentication-failed", h, void 0, 401), Object.setPrototypeOf(this, i.prototype);
    }
  }
  K.AuthenticationError = i;
  class u extends a {
    constructor(p, $, h) {
      super(p ?? "Authorization failed.", $ ?? "unauthorized", h, void 0, 403), Object.setPrototypeOf(this, u.prototype);
    }
  }
  K.AuthorizationError = u;
  class o extends u {
    constructor(p, $, h) {
      super(p ?? "Unauthorized impersonation.", $ ?? "unauthorized-impersonation", h), Object.setPrototypeOf(this, o.prototype);
    }
  }
  K.UnauthorizedImpersonationError = o;
  class s extends d {
    constructor(p, $) {
      super((0, t.nullIfEmpty)({ message: p }), $, 404), Object.setPrototypeOf(this, s.prototype);
    }
  }
  K.NotFoundError = s;
  class c extends d {
    constructor(p, $) {
      super((0, t.nullIfEmpty)({ message: p }), $, 400), Object.setPrototypeOf(this, c.prototype);
    }
  }
  K.ValidationError = c;
  class f extends d {
    constructor(p) {
      super({ errors: p }, 400), Object.setPrototypeOf(this, f.prototype), this.errors = p;
    }
  }
  K.DataValidationError = f;
  class l extends r {
    constructor(p, $) {
      super(p ?? "Concurrent update happened", $), Object.setPrototypeOf(this, l.prototype);
    }
  }
  return K.ConcurrentUpdateError = l, K;
}
var Tn = {}, M0;
function S9() {
  return M0 || (M0 = 1, Object.defineProperty(Tn, "__esModule", { value: !0 })), Tn;
}
var E0;
function b9() {
  return E0 || (E0 = 1, function(t) {
    var e = Me && Me.__createBinding || (Object.create ? function(n, d, a, i) {
      i === void 0 && (i = a);
      var u = Object.getOwnPropertyDescriptor(d, a);
      (!u || ("get" in u ? !d.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
        return d[a];
      } }), Object.defineProperty(n, i, u);
    } : function(n, d, a, i) {
      i === void 0 && (i = a), n[i] = d[a];
    }), r = Me && Me.__exportStar || function(n, d) {
      for (var a in n) a !== "default" && !Object.prototype.hasOwnProperty.call(d, a) && e(d, n, a);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), r(A9(), t), r(S9(), t);
  }(Me)), Me;
}
var et = {}, R0;
function bi() {
  if (R0) return et;
  R0 = 1, Object.defineProperty(et, "__esModule", { value: !0 }), et.grow = t, et.flatten = e;
  function t(i, u = "", o = "_") {
    return Array.isArray(i) ? i.map((s) => n(s, u, o)) : n(i, u, o);
  }
  function e(i, u = "", o = "_") {
    return Array.isArray(i) ? i.map((s) => a(s, o)).map((s) => r(s, u)) : r(a(i, o), u);
  }
  function r(i, u) {
    const o = {};
    return Object.entries(i).forEach(([s, c]) => {
      o[u + s] = c;
    }), o;
  }
  function n(i, u, o) {
    if (i == null)
      return i;
    const s = {};
    return Object.entries(i).filter(([c]) => c.startsWith(u)).map(([c, f]) => [c.replace(u, ""), f]).forEach(([c, f]) => {
      const l = c.split(o), _ = l.splice(-1, 1);
      let p = s;
      l.forEach(($) => {
        p = d(p, $);
      }), p[_] = f;
    }), s;
  }
  function d(i, u, o) {
    return i[u] === void 0 && (o === void 0 && (o = {}), i[u] = o), i[u];
  }
  function a(i, u, o = [], s = {}) {
    let c = Object.assign({}, s);
    for (const f in i) {
      const l = [...o, f];
      if (Array.isArray(i[f]))
        c[l.join(u)] = i[f];
      else if (typeof i[f] == "object") {
        const _ = a(i[f], u, l, {});
        c = Object.assign(Object.assign({}, c), _);
      } else
        c[l.join(u)] = i[f];
    }
    return c;
  }
  return et;
}
var Ln = {}, tt = {}, P0;
function Mi() {
  if (P0) return tt;
  P0 = 1, Object.defineProperty(tt, "__esModule", { value: !0 }), tt.inTimezone = e, tt.msToDuration = d;
  const t = Xe();
  function e(a, i, u) {
    return new Date(a.toLocaleString(u, {
      timeZone: i
    }));
  }
  const r = {
    ms: 0,
    s: 1,
    m: 2,
    h: 3,
    d: 4
  };
  function n(a, i) {
    return r[a] > r[i];
  }
  function d(a, i = "d") {
    const u = Math.floor(a % (n(i, "ms") ? 1e3 : Number.MAX_SAFE_INTEGER)), o = Math.floor(a / 1e3 % (n(i, "s") ? 60 : i === "s" ? Number.MAX_SAFE_INTEGER : 1)), s = Math.floor(a / 1e3 / 60 % (n(i, "m") ? 60 : i === "m" ? Number.MAX_SAFE_INTEGER : 1)), c = Math.floor(a / 1e3 / 60 / 60 % (n(i, "h") ? 24 : i === "h" ? Number.MAX_SAFE_INTEGER : 1)), f = i === "d" ? Math.floor(a / 1e3 / 60 / 60 / 24 % 24) : 0;
    let l = "";
    if (f || l.length) {
      const _ = `${f}`;
      l += `${_}d `;
    }
    if (c || l.length) {
      const _ = n(i, "h") && l.length ? (0, t.lpad)(c, 2, "0") : `${c}`;
      l += `${_}h `;
    }
    if (s || l.length) {
      const _ = n(i, "m") && l.length ? (0, t.lpad)(s, 2, "0") : `${s}`;
      l += `${_}m `;
    }
    if (o || l.length) {
      const _ = n(i, "s") && l.length ? (0, t.lpad)(o, 2, "0") : `${o}`;
      l += `${_}s `;
    }
    if (u || l.length) {
      const _ = n(i, "ms") && l.length ? (0, t.lpad)(u, 3, "0") : `${u}`;
      l += `${_}ms`;
    }
    return l;
  }
  return tt;
}
var C0;
function M9() {
  return C0 || (C0 = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.noopLogger = t.NoopLogger = t.SimpleConsoleLogger = t.BareConsoleLogger = t.BaseLogger = t.ContextHolder = t.logLevelWeights = t.LogLevel = void 0, t.utcTimeString = c, t.localTimeString = f, t.getMessageText = _;
    const e = Mi(), r = pn(), n = Xe();
    var d;
    (function(p) {
      p.off = "off", p.fatal = "fatal", p.error = "error", p.warn = "warn", p.info = "info", p.trace = "trace", p.debug = "debug";
    })(d || (t.LogLevel = d = {})), t.logLevelWeights = {
      [d.off]: 0,
      [d.fatal]: 1,
      [d.error]: 2,
      [d.warn]: 3,
      [d.info]: 4,
      [d.trace]: 5,
      [d.debug]: 6
    };
    class a {
      constructor($) {
        this.name = $;
      }
    }
    t.ContextHolder = a;
    class i {
      constructor($, h) {
        var g, A;
        this.config = $, this.ctx = h, this._context = (A = (g = this.config) === null || g === void 0 ? void 0 : g.format) === null || A === void 0 ? void 0 : A.context;
      }
      log($, ...h) {
        var g, A, R, y, S, O;
        if (!this.isEnabled($))
          return;
        const P = /* @__PURE__ */ new Date(), b = !((A = (g = this.config) === null || g === void 0 ? void 0 : g.format) === null || A === void 0) && A.timezone ? `${f(P, this.config.format.timezone)} in ${this.config.format.timezone}` : "", I = c(P) + (b ? ` (${b})` : "");
        let E = (O = (R = this.getContext()) !== null && R !== void 0 ? R : (S = (y = this.config) === null || y === void 0 ? void 0 : y.format) === null || S === void 0 ? void 0 : S.context) !== null && O !== void 0 ? O : "MAIN";
        const T = h[h.length - 1];
        T instanceof a && (E = T.name, h = h.slice(0, -1));
        const U = {
          timestamp: I,
          context: E
        }, Z = h.map((H) => (typeof H == "function" && (H = H()), H)).map((H) => {
          var W, re;
          return _(H, !1, (re = (W = this.config) === null || W === void 0 ? void 0 : W.format) === null || re === void 0 ? void 0 : re.objectFormat);
        });
        this.logMessages($, U, ...Z);
      }
      debug(...$) {
        this.log(d.debug, ...$);
      }
      info(...$) {
        this.log(d.info, ...$);
      }
      trace(...$) {
        this.log(d.trace, ...$);
      }
      warn(...$) {
        this.log(d.warn, ...$);
      }
      error(...$) {
        this.log(d.error, ...$);
      }
      fatal(...$) {
        this.log(d.fatal, ...$);
      }
      isEnabled($) {
        var h, g;
        return t.logLevelWeights[(g = (h = this.config) === null || h === void 0 ? void 0 : h.level) !== null && g !== void 0 ? g : d.debug] >= t.logLevelWeights[$];
      }
      setContext($) {
        this._context = $;
      }
      getContext() {
        return this._context;
      }
    }
    t.BaseLogger = i;
    class u extends i {
      constructor($ = d.debug) {
        super({
          level: $
        }), this.level = $;
      }
      clone() {
        return new u(this.level);
      }
      logMessages($, h, ...g) {
        const A = `${g.join(`
`)}`;
        switch ($) {
          case d.fatal:
          case d.error:
            console.error(A);
            break;
          case d.warn:
            console.warn(A);
            break;
          case d.info:
          case d.trace:
            console.info(A);
            break;
          case d.debug:
            console.debug(A);
            break;
          default:
            console.log(A);
        }
      }
    }
    t.BareConsoleLogger = u;
    class o extends i {
      constructor($, h) {
        super(typeof $ == "string" ? void 0 : $), typeof $ == "string" ? this.setContext($) : (this.config = $, this.ctx = h);
      }
      clone() {
        return new o(this.config, this.ctx);
      }
      logMessages($, h, ...g) {
        var A, R, y, S;
        const O = !((A = this.ctx) === null || A === void 0) && A.getId() ? ` <${this.ctx.getId()}>` : "", P = `${h.timestamp} ${(0, n.lpad)($.toUpperCase(), 5)}: [${(0, n.rpad)(h.context, (S = (y = (R = this.config) === null || R === void 0 ? void 0 : R.format) === null || y === void 0 ? void 0 : y.contextPadding) !== null && S !== void 0 ? S : 0)}]${O} ${g.join(`
`)}`;
        switch ($) {
          case d.fatal:
          case d.error:
            console.error(P);
            break;
          case d.warn:
            console.warn(P);
            break;
          case d.info:
          case d.trace:
            console.info(P);
            break;
          case d.debug:
            console.debug(P);
            break;
          default:
            console.log(P);
        }
      }
    }
    t.SimpleConsoleLogger = o;
    class s extends o {
      clone() {
        return new s(this.config, this.ctx);
      }
      isEnabled($) {
        return !1;
      }
    }
    t.NoopLogger = s, t.noopLogger = new s();
    function c(p) {
      return `${p.getUTCFullYear()}-${(0, n.lpad)(p.getUTCMonth() + 1, 2, "0")}-${(0, n.lpad)(p.getUTCDate(), 2, "0")} ${(0, n.lpad)(p.getUTCHours(), 2, "0")}:${(0, n.lpad)(p.getUTCMinutes(), 2, "0")}:${(0, n.lpad)(p.getUTCSeconds(), 2, "0")}.${(0, n.lpad)(p.getUTCMilliseconds(), 3, "0")}`;
    }
    function f(p, $) {
      return p = (0, e.inTimezone)(p, $), `${p.getFullYear()}-${(0, n.lpad)(p.getMonth() + 1, 2, "0")}-${(0, n.lpad)(p.getDate(), 2, "0")} ${(0, n.lpad)(p.getHours(), 2, "0")}:${(0, n.lpad)(p.getMinutes(), 2, "0")}:${(0, n.lpad)(p.getSeconds(), 2, "0")}.${(0, n.lpad)(p.getMilliseconds(), 3, "0")}`;
    }
    function l(p, $) {
      var h;
      return p instanceof Error ? (h = p.stack) !== null && h !== void 0 ? h : p.message : p === null ? "NULL" : p === void 0 ? "UNDEFINED" : (0, r.isPrimitiveValue)(p) ? p : $ === "text" ? p.toString() : $ === "compact-json" ? (0, n.json)(p, !1) : (0, n.json)(p);
    }
    function _(p, $, h) {
      if (Array.isArray(p)) {
        const g = p.map((A) => l(A, "compact-json"));
        return $ ? g.join(`
`) : (0, n.json)(g);
      }
      return p instanceof Map ? (0, n.json)(Object.fromEntries([...p])) : p instanceof Set ? (0, n.json)([...p]) : l(p, h);
    }
  }(Ln)), Ln;
}
var V = {}, N0;
function E9() {
  if (N0) return V;
  N0 = 1, Object.defineProperty(V, "__esModule", { value: !0 }), V.or = e, V.and = r, V.sum = n, V.count = d, V.avg = a, V.unique = i, V.array2Map = u, V.array2ArrayMap = o, V.zip = s, V.last = c, V.first = f, V.range = l, V.charRange = _, V.splitArray = p, V.chunkArray = $, V.rotateLeft = h, V.rotateRight = g, V.diff = A, V.intersect = R, V.union = y, V.hasAny = S, V.hasAll = O, V.hasNone = P;
  const t = Xe();
  function e(b, I = (E) => !!E) {
    return b.reduce((E, T) => E || I(T), !1);
  }
  function r(b, I = (E) => !!E) {
    return b.reduce((E, T) => E && I(T), !0);
  }
  function n(b, I = (E) => E) {
    return b.reduce((E, T) => E + I(T), 0);
  }
  function d(b, I = (E) => E ? 1 : 0) {
    return b.reduce((E, T) => E + I(T), 0);
  }
  function a(b, I = (E) => E) {
    return b.length ? n(b, I) / b.length : 0;
  }
  function i(b, I, E) {
    if (!(b != null && b.length))
      return [];
    I || (I = (Z) => (0, t.json)(Z, !1));
    const T = {}, U = [];
    for (const Z of b) {
      const H = I(Z), W = T[H];
      W === void 0 ? (T[H] = U.length, U.push(Z)) : E && (U[W] = Z);
    }
    return U;
  }
  function u(b, I = (E) => (0, t.json)(E, !1)) {
    if (!(b != null && b.length))
      return {};
    const E = {};
    for (const T of b) {
      const U = I(T);
      E[U] = T;
    }
    return E;
  }
  function o(b, I = (E) => (0, t.json)(E, !1)) {
    var E;
    if (!(b != null && b.length))
      return {};
    const T = {};
    for (const U of b) {
      const Z = I(U);
      ((E = T[Z]) !== null && E !== void 0 ? E : T[Z] = []).push(U);
    }
    return T;
  }
  function s(...b) {
    return Array(Math.max(...b.map((I) => I.length))).fill(0).map((I, E) => b.map((T) => T[E]));
  }
  function c(b) {
    return b[b.length - 1];
  }
  function f(b) {
    return b[0];
  }
  function l(b, I = 0) {
    return [...Array(b).keys()].map((E) => E + I);
  }
  function _(b, I) {
    return l(I.charCodeAt(0) - b.charCodeAt(0) + 1, b.charCodeAt(0)).map((E) => String.fromCharCode(E));
  }
  function p(b, I) {
    const E = I >= 0 ? I : b.length + I;
    return [b.slice(0, E), b.slice(E)];
  }
  function $(b, I) {
    if (I <= 0)
      throw new Error("Chunk size must be greater than 0");
    const E = [];
    for (let T = 0; T < b.length; T += I)
      E.push(b.slice(T, T + I));
    return E;
  }
  function h(b) {
    const [I, E] = p(b, 1);
    return [...E, ...I];
  }
  function g(b) {
    const [I, E] = p(b, -1);
    return [...E, ...I];
  }
  function A(b, I, E = (T, U) => T === U) {
    const T = [];
    for (const U of b)
      I.some((Z) => E(U, Z)) || T.push(U);
    return T;
  }
  function R(b, I, E = (T, U) => T === U) {
    const T = [];
    for (const U of b)
      I.some((Z) => E(U, Z)) && T.push(U);
    return T;
  }
  function y(b, I, E = (T, U) => T === U) {
    const T = [...b];
    for (const U of I)
      T.some((Z) => E(U, Z)) || T.push(U);
    return T;
  }
  function S(b, I) {
    return b.some((E) => I.includes(E));
  }
  function O(b, I) {
    return b.every((E) => I.includes(E));
  }
  function P(b, I) {
    return !S(b, I);
  }
  return V;
}
var ne = {}, O0;
function R9() {
  if (O0) return ne;
  O0 = 1, Object.defineProperty(ne, "__esModule", { value: !0 }), ne.FixedBackoff = ne.ExponentialBackoff = ne.FibonacciBackoff = ne.LinearBackoff = ne.Backoff = void 0;
  class t {
    constructor(i) {
      var u, o;
      this.min = 10, this.max = 1e4, this.jitter = 0, this.cur = 0, this.min = (u = i == null ? void 0 : i.min) !== null && u !== void 0 ? u : 100, this.max = (o = i == null ? void 0 : i.max) !== null && o !== void 0 ? o : 1e4, this.jitter = (i == null ? void 0 : i.jitter) !== void 0 && i.jitter >= 0 && i.jitter <= 1 ? i.jitter : 0, this.reset();
    }
    next() {
      if (this.jitter) {
        const u = this.spread() * this.jitter;
        this.cur += Math.random() * u - u / 2;
      }
      this.cur = Math.max(0, Math.min(this.max, Math.floor(this.cur)));
      const i = this.cur;
      return this.step(), i;
    }
  }
  ne.Backoff = t;
  class e extends t {
    constructor(i) {
      var u;
      super(i), this._step = 50, this._step = (u = i == null ? void 0 : i.step) !== null && u !== void 0 ? u : 50;
    }
    reset() {
      this.cur = this.min;
    }
    spread() {
      return this._step;
    }
    step() {
      this.cur = this.cur + this._step;
    }
  }
  ne.LinearBackoff = e;
  class r extends t {
    constructor() {
      super(...arguments), this.last = 0;
    }
    reset() {
      this.cur = this.min, this.last = 0;
    }
    spread() {
      return this.cur === this.last ? this.cur : this.cur - this.last;
    }
    step() {
      let i = this.last + this.cur;
      i === 0 && (i = 1), this.last = this.cur, this.cur = i;
    }
  }
  ne.FibonacciBackoff = r;
  class n extends t {
    constructor(i) {
      var u;
      super(i), this.factor = 2, this.factor = (u = i == null ? void 0 : i.factor) !== null && u !== void 0 ? u : 2;
    }
    reset() {
      this.cur = this.min;
    }
    spread() {
      return this.cur - this.cur / this.factor;
    }
    step() {
      this.cur === 0 ? this.cur = 1 : this.cur *= this.factor;
    }
  }
  ne.ExponentialBackoff = n;
  class d extends t {
    constructor(i) {
      super(), this.sequence = i.sequence, this.idx = 0, this.lastIdx = this.sequence.length - 1, this.reset();
    }
    reset() {
      var i;
      this.idx = 0, this.cur = (i = this.sequence) === null || i === void 0 ? void 0 : i[this.idx];
    }
    spread() {
      return this.idx === 0 ? this.sequence[this.idx] : Math.abs(this.sequence[this.idx] - this.sequence[this.idx - 1]);
    }
    step() {
      this.idx = Math.min(this.idx + 1, this.lastIdx), this.cur = this.sequence[this.idx];
    }
  }
  return ne.FixedBackoff = d, ne;
}
var gt = {}, x0;
function P9() {
  if (x0) return gt;
  x0 = 1, Object.defineProperty(gt, "__esModule", { value: !0 }), gt.cached = t;
  async function t(e, r, n) {
    let d = e.get(r);
    return d === void 0 && (d = await n(), e.set(r, d)), d;
  }
  return gt;
}
var ce = {}, me = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      this.groups = [], this.each = !1, this.context = void 0, this.type = e.type, this.name = e.name, this.target = e.target, this.propertyName = e.propertyName, this.constraints = e == null ? void 0 : e.constraints, this.constraintCls = e.constraintCls, this.validationTypeOptions = e.validationTypeOptions, e.validationOptions && (this.message = e.validationOptions.message, this.groups = e.validationOptions.groups, this.always = e.validationOptions.always, this.each = e.validationOptions.each, this.context = e.validationOptions.context);
    }
    return t;
  }()
), C9 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.transform = function(e) {
      var r = [];
      return Object.keys(e.properties).forEach(function(n) {
        e.properties[n].forEach(function(d) {
          var a = {
            message: d.message,
            groups: d.groups,
            always: d.always,
            each: d.each
          }, i = {
            type: d.type,
            name: d.name,
            target: e.name,
            propertyName: n,
            constraints: d.constraints,
            validationTypeOptions: d.options,
            validationOptions: a
          };
          r.push(new me(i));
        });
      }), r;
    }, t;
  }()
);
function N9(t) {
  return t instanceof Map ? Array.from(t.values()) : Array.isArray(t) ? t : Array.from(t);
}
function O9() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof global < "u")
    return global;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
}
function Fn(t) {
  return t !== null && typeof t == "object" && typeof t.then == "function";
}
var x9 = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, D0 = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), d, a = [], i;
  try {
    for (; (e === void 0 || e-- > 0) && !(d = n.next()).done; ) a.push(d.value);
  } catch (u) {
    i = { error: u };
  } finally {
    try {
      d && !d.done && (r = n.return) && r.call(n);
    } finally {
      if (i) throw i.error;
    }
  }
  return a;
}, D9 = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, d = e.length, a; n < d; n++)
    (a || !(n in e)) && (a || (a = Array.prototype.slice.call(e, 0, n)), a[n] = e[n]);
  return t.concat(a || Array.prototype.slice.call(e));
}, t0 = (
  /** @class */
  function() {
    function t() {
      this.validationMetadatas = /* @__PURE__ */ new Map(), this.constraintMetadatas = /* @__PURE__ */ new Map();
    }
    return Object.defineProperty(t.prototype, "hasValidationMetaData", {
      get: function() {
        return !!this.validationMetadatas.size;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.addValidationSchema = function(e) {
      var r = this, n = new C9().transform(e);
      n.forEach(function(d) {
        return r.addValidationMetadata(d);
      });
    }, t.prototype.addValidationMetadata = function(e) {
      var r = this.validationMetadatas.get(e.target);
      r ? r.push(e) : this.validationMetadatas.set(e.target, [e]);
    }, t.prototype.addConstraintMetadata = function(e) {
      var r = this.constraintMetadatas.get(e.target);
      r ? r.push(e) : this.constraintMetadatas.set(e.target, [e]);
    }, t.prototype.groupByPropertyName = function(e) {
      var r = {};
      return e.forEach(function(n) {
        r[n.propertyName] || (r[n.propertyName] = []), r[n.propertyName].push(n);
      }), r;
    }, t.prototype.getTargetValidationMetadatas = function(e, r, n, d, a) {
      var i, u, o = function(y) {
        return typeof y.always < "u" ? y.always : y.groups && y.groups.length ? !1 : n;
      }, s = function(y) {
        return !!(d && (!a || !a.length) && y.groups && y.groups.length);
      }, c = this.validationMetadatas.get(e) || [], f = c.filter(function(y) {
        return y.target !== e && y.target !== r ? !1 : o(y) ? !0 : s(y) ? !1 : a && a.length > 0 ? y.groups && !!y.groups.find(function(S) {
          return a.indexOf(S) !== -1;
        }) : !0;
      }), l = [];
      try {
        for (var _ = x9(this.validationMetadatas.entries()), p = _.next(); !p.done; p = _.next()) {
          var $ = D0(p.value, 2), h = $[0], g = $[1];
          e.prototype instanceof h && l.push.apply(l, D9([], D0(g), !1));
        }
      } catch (y) {
        i = { error: y };
      } finally {
        try {
          p && !p.done && (u = _.return) && u.call(_);
        } finally {
          if (i) throw i.error;
        }
      }
      var A = l.filter(function(y) {
        return typeof y.target == "string" || y.target === e || y.target instanceof Function && !(e.prototype instanceof y.target) ? !1 : o(y) ? !0 : s(y) ? !1 : a && a.length > 0 ? y.groups && !!y.groups.find(function(S) {
          return a.indexOf(S) !== -1;
        }) : !0;
      }), R = A.filter(function(y) {
        return !f.find(function(S) {
          return S.propertyName === y.propertyName && S.type === y.type;
        });
      });
      return f.concat(R);
    }, t.prototype.getTargetValidatorConstraints = function(e) {
      return this.constraintMetadatas.get(e) || [];
    }, t;
  }()
);
function ie() {
  var t = O9();
  return t.classValidatorMetadataStorage || (t.classValidatorMetadataStorage = new t0()), t.classValidatorMetadataStorage;
}
var Hn = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.toString = function(e, r, n, d) {
      var a = this;
      e === void 0 && (e = !1), r === void 0 && (r = !1), n === void 0 && (n = ""), d === void 0 && (d = !1);
      var i = e ? "\x1B[1m" : "", u = e ? "\x1B[22m" : "", o = function() {
        var f;
        return (d ? Object.values : Object.keys)((f = a.constraints) !== null && f !== void 0 ? f : {}).join(", ");
      }, s = function(f) {
        return " - property ".concat(i).concat(n).concat(f).concat(u, " has failed the following constraints: ").concat(i).concat(o()).concat(u, ` 
`);
      };
      if (r) {
        var c = Number.isInteger(+this.property) ? "[".concat(this.property, "]") : "".concat(n ? "." : "").concat(this.property);
        return this.constraints ? s(c) : this.children ? this.children.map(function(f) {
          return f.toString(e, !0, "".concat(n).concat(c), d);
        }).join("") : "";
      } else
        return "An instance of ".concat(i).concat(this.target ? this.target.constructor.name : "an object").concat(u, ` has failed the validation:
`) + (this.constraints ? s(this.property) : "") + (this.children ? this.children.map(function(f) {
          return f.toString(e, !0, a.property, d);
        }).join("") : "");
    }, t;
  }()
), Q = (
  /** @class */
  function() {
    function t() {
    }
    return t.isValid = function(e) {
      var r = this;
      return e !== "isValid" && e !== "getMessage" && Object.keys(this).map(function(n) {
        return r[n];
      }).indexOf(e) !== -1;
    }, t.CUSTOM_VALIDATION = "customValidation", t.NESTED_VALIDATION = "nestedValidation", t.PROMISE_VALIDATION = "promiseValidation", t.CONDITIONAL_VALIDATION = "conditionalValidation", t.WHITELIST = "whitelistValidation", t.IS_DEFINED = "isDefined", t;
  }()
);
function T9(t) {
  return Array.isArray(t) ? t.join(", ") : (typeof t == "symbol" && (t = t.description), "".concat(t));
}
var L9 = (
  /** @class */
  function() {
    function t() {
    }
    return t.replaceMessageSpecialTokens = function(e, r) {
      var n;
      return e instanceof Function ? n = e(r) : typeof e == "string" && (n = e), n && Array.isArray(r.constraints) && r.constraints.forEach(function(d, a) {
        n = n.replace(new RegExp("\\$constraint".concat(a + 1), "g"), T9(d));
      }), n && r.value !== void 0 && r.value !== null && ["string", "boolean", "number"].includes(typeof r.value) && (n = n.replace(/\$value/g, r.value)), n && (n = n.replace(/\$property/g, r.property)), n && (n = n.replace(/\$target/g, r.targetName)), n;
    }, t;
  }()
), rt = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), d, a = [], i;
  try {
    for (; (e === void 0 || e-- > 0) && !(d = n.next()).done; ) a.push(d.value);
  } catch (u) {
    i = { error: u };
  } finally {
    try {
      d && !d.done && (r = n.return) && r.call(n);
    } finally {
      if (i) throw i.error;
    }
  }
  return a;
}, T0 = (
  /** @class */
  function() {
    function t(e, r) {
      this.validator = e, this.validatorOptions = r, this.awaitingPromises = [], this.ignoreAsyncValidations = !1, this.metadataStorage = ie();
    }
    return t.prototype.execute = function(e, r, n) {
      var d = this, a, i;
      !this.metadataStorage.hasValidationMetaData && ((a = this.validatorOptions) === null || a === void 0 ? void 0 : a.enableDebugMessages) === !0 && console.warn(`No validation metadata found. No validation will be  performed. There are multiple possible reasons:
  - There may be multiple class-validator versions installed. You will need to flatten your dependencies to fix the issue.
  - This validation runs before any file with validation decorator was parsed by NodeJS.`);
      var u = this.validatorOptions ? this.validatorOptions.groups : void 0, o = this.validatorOptions && this.validatorOptions.strictGroups || !1, s = this.validatorOptions && this.validatorOptions.always || !1, c = ((i = this.validatorOptions) === null || i === void 0 ? void 0 : i.forbidUnknownValues) === void 0 || this.validatorOptions.forbidUnknownValues !== !1, f = this.metadataStorage.getTargetValidationMetadatas(e.constructor, r, s, o, u), l = this.metadataStorage.groupByPropertyName(f);
      if (c && !f.length) {
        var _ = new Hn();
        (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (_.target = e), _.value = void 0, _.property = void 0, _.children = [], _.constraints = { unknownValue: "an unknown value was passed to the validate function" }, n.push(_);
        return;
      }
      this.validatorOptions && this.validatorOptions.whitelist && this.whitelist(e, l, n), Object.keys(l).forEach(function(p) {
        var $ = e[p], h = l[p].filter(function(A) {
          return A.type === Q.IS_DEFINED;
        }), g = l[p].filter(function(A) {
          return A.type !== Q.IS_DEFINED && A.type !== Q.WHITELIST;
        });
        $ instanceof Promise && g.find(function(A) {
          return A.type === Q.PROMISE_VALIDATION;
        }) ? d.awaitingPromises.push($.then(function(A) {
          d.performValidations(e, A, p, h, g, n);
        })) : d.performValidations(e, $, p, h, g, n);
      });
    }, t.prototype.whitelist = function(e, r, n) {
      var d = this, a = [];
      Object.keys(e).forEach(function(i) {
        (!r[i] || r[i].length === 0) && a.push(i);
      }), a.length > 0 && (this.validatorOptions && this.validatorOptions.forbidNonWhitelisted ? a.forEach(function(i) {
        var u, o = d.generateValidationError(e, e[i], i);
        o.constraints = (u = {}, u[Q.WHITELIST] = "property ".concat(i, " should not exist"), u), o.children = void 0, n.push(o);
      }) : a.forEach(function(i) {
        return delete e[i];
      }));
    }, t.prototype.stripEmptyErrors = function(e) {
      var r = this;
      return e.filter(function(n) {
        if (n.children && (n.children = r.stripEmptyErrors(n.children)), Object.keys(n.constraints).length === 0) {
          if (n.children.length === 0)
            return !1;
          delete n.constraints;
        }
        return !0;
      });
    }, t.prototype.performValidations = function(e, r, n, d, a, i) {
      var u = a.filter(function(l) {
        return l.type === Q.CUSTOM_VALIDATION;
      }), o = a.filter(function(l) {
        return l.type === Q.NESTED_VALIDATION;
      }), s = a.filter(function(l) {
        return l.type === Q.CONDITIONAL_VALIDATION;
      }), c = this.generateValidationError(e, r, n);
      i.push(c);
      var f = this.conditionalValidations(e, r, s);
      f && (this.customValidations(e, r, d, c), this.mapContexts(e, r, d, c), !(r === void 0 && this.validatorOptions && this.validatorOptions.skipUndefinedProperties === !0) && (r === null && this.validatorOptions && this.validatorOptions.skipNullProperties === !0 || r == null && this.validatorOptions && this.validatorOptions.skipMissingProperties === !0 || (this.customValidations(e, r, u, c), this.nestedValidations(r, o, c), this.mapContexts(e, r, a, c), this.mapContexts(e, r, u, c))));
    }, t.prototype.generateValidationError = function(e, r, n) {
      var d = new Hn();
      return (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (d.target = e), (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.value === void 0 || this.validatorOptions.validationError.value === !0) && (d.value = r), d.property = n, d.children = [], d.constraints = {}, d;
    }, t.prototype.conditionalValidations = function(e, r, n) {
      return n.map(function(d) {
        return d.constraints[0](e, r);
      }).reduce(function(d, a) {
        return d && a;
      }, !0);
    }, t.prototype.customValidations = function(e, r, n, d) {
      var a = this;
      n.forEach(function(i) {
        a.metadataStorage.getTargetValidatorConstraints(i.constraintCls).forEach(function(u) {
          if (!(u.async && a.ignoreAsyncValidations) && !(a.validatorOptions && a.validatorOptions.stopAtFirstError && Object.keys(d.constraints || {}).length > 0)) {
            var o = {
              targetName: e.constructor ? e.constructor.name : void 0,
              property: i.propertyName,
              object: e,
              value: r,
              constraints: i.constraints
            };
            if (!i.each || !(Array.isArray(r) || r instanceof Set || r instanceof Map)) {
              var s = u.instance.validate(r, o);
              if (Fn(s)) {
                var c = s.then(function(S) {
                  if (!S) {
                    var O = rt(a.createValidationError(e, r, i, u), 2), P = O[0], b = O[1];
                    d.constraints[P] = b, i.context && (d.contexts || (d.contexts = {}), d.contexts[P] = Object.assign(d.contexts[P] || {}, i.context));
                  }
                });
                a.awaitingPromises.push(c);
              } else if (!s) {
                var f = rt(a.createValidationError(e, r, i, u), 2), l = f[0], _ = f[1];
                d.constraints[l] = _;
              }
              return;
            }
            var p = N9(r), $ = p.map(function(S) {
              return u.instance.validate(S, o);
            }), h = $.some(function(S) {
              return Fn(S);
            });
            if (h) {
              var g = $.map(function(S) {
                return Fn(S) ? S : Promise.resolve(S);
              }), A = Promise.all(g).then(function(S) {
                var O = S.every(function(E) {
                  return E;
                });
                if (!O) {
                  var P = rt(a.createValidationError(e, r, i, u), 2), b = P[0], I = P[1];
                  d.constraints[b] = I, i.context && (d.contexts || (d.contexts = {}), d.contexts[b] = Object.assign(d.contexts[b] || {}, i.context));
                }
              });
              a.awaitingPromises.push(A);
              return;
            }
            var R = $.every(function(S) {
              return S;
            });
            if (!R) {
              var y = rt(a.createValidationError(e, r, i, u), 2), l = y[0], _ = y[1];
              d.constraints[l] = _;
            }
          }
        });
      });
    }, t.prototype.nestedValidations = function(e, r, n) {
      var d = this;
      e !== void 0 && r.forEach(function(a) {
        if (!(a.type !== Q.NESTED_VALIDATION && a.type !== Q.PROMISE_VALIDATION) && !(d.validatorOptions && d.validatorOptions.stopAtFirstError && Object.keys(n.constraints || {}).length > 0))
          if (Array.isArray(e) || e instanceof Set || e instanceof Map) {
            var i = e instanceof Set ? Array.from(e) : e;
            i.forEach(function(f, l) {
              d.performValidations(e, f, l.toString(), [], r, n.children);
            });
          } else if (e instanceof Object) {
            var u = typeof a.target == "string" ? a.target : a.target.name;
            d.execute(e, u, n.children);
          } else {
            var o = rt(d.createValidationError(a.target, e, a), 2), s = o[0], c = o[1];
            n.constraints[s] = c;
          }
      });
    }, t.prototype.mapContexts = function(e, r, n, d) {
      var a = this;
      return n.forEach(function(i) {
        if (i.context) {
          var u = void 0;
          if (i.type === Q.CUSTOM_VALIDATION) {
            var o = a.metadataStorage.getTargetValidatorConstraints(i.constraintCls);
            u = o[0];
          }
          var s = a.getConstraintType(i, u);
          d.constraints[s] && (d.contexts || (d.contexts = {}), d.contexts[s] = Object.assign(d.contexts[s] || {}, i.context));
        }
      });
    }, t.prototype.createValidationError = function(e, r, n, d) {
      var a = e.constructor ? e.constructor.name : void 0, i = this.getConstraintType(n, d), u = {
        targetName: a,
        property: n.propertyName,
        object: e,
        value: r,
        constraints: n.constraints
      }, o = n.message || "";
      !n.message && (!this.validatorOptions || this.validatorOptions && !this.validatorOptions.dismissDefaultMessages) && d && d.instance.defaultMessage instanceof Function && (o = d.instance.defaultMessage(u));
      var s = L9.replaceMessageSpecialTokens(o, u);
      return [i, s];
    }, t.prototype.getConstraintType = function(e, r) {
      var n = r && r.name ? r.name : e.type;
      return n;
    }, t;
  }()
), F9 = function(t, e, r, n) {
  function d(a) {
    return a instanceof r ? a : new r(function(i) {
      i(a);
    });
  }
  return new (r || (r = Promise))(function(a, i) {
    function u(c) {
      try {
        s(n.next(c));
      } catch (f) {
        i(f);
      }
    }
    function o(c) {
      try {
        s(n.throw(c));
      } catch (f) {
        i(f);
      }
    }
    function s(c) {
      c.done ? a(c.value) : d(c.value).then(u, o);
    }
    s((n = n.apply(t, e || [])).next());
  });
}, w9 = function(t, e) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, d, a, i;
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(s) {
    return function(c) {
      return o([s, c]);
    };
  }
  function o(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, s[0] && (r = 0)), r; ) try {
      if (n = 1, d && (a = s[0] & 2 ? d.return : s[0] ? d.throw || ((a = d.return) && a.call(d), 0) : d.next) && !(a = a.call(d, s[1])).done) return a;
      switch (d = 0, a && (s = [s[0] & 2, a.value]), s[0]) {
        case 0:
        case 1:
          a = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, d = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!a || s[1] > a[0] && s[1] < a[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = s;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(s);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = e.call(t, r);
    } catch (c) {
      s = [6, c], d = 0;
    } finally {
      n = a = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Pe = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.validate = function(e, r, n) {
      return this.coreValidate(e, r, n);
    }, t.prototype.validateOrReject = function(e, r, n) {
      return F9(this, void 0, void 0, function() {
        var d;
        return w9(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.coreValidate(e, r, n)];
            case 1:
              return d = a.sent(), d.length ? [2, Promise.reject(d)] : [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.validateSync = function(e, r, n) {
      var d = typeof e == "string" ? r : e, a = typeof e == "string" ? n : r, i = typeof e == "string" ? e : void 0, u = new T0(this, a);
      u.ignoreAsyncValidations = !0;
      var o = [];
      return u.execute(d, i, o), u.stripEmptyErrors(o);
    }, t.prototype.coreValidate = function(e, r, n) {
      var d = typeof e == "string" ? r : e, a = typeof e == "string" ? n : r, i = typeof e == "string" ? e : void 0, u = new T0(this, a), o = [];
      return u.execute(d, i, o), Promise.all(u.awaitingPromises).then(function() {
        return u.stripEmptyErrors(o);
      });
    }, t;
  }()
), B9 = new /** @class */
(function() {
  function t() {
    this.instances = [];
  }
  return t.prototype.get = function(e) {
    var r = this.instances.find(function(n) {
      return n.type === e;
    });
    return r || (r = { type: e, object: new e() }, this.instances.push(r)), r.object;
  }, t;
}())(), Gn, dt;
function U9(t, e) {
  Gn = t, dt = e;
}
function pe(t) {
  if (Gn)
    try {
      var e = Gn.get(t);
      if (e || !dt || !dt.fallback)
        return e;
    } catch (r) {
      if (!dt || !dt.fallbackOnErrors)
        throw r;
    }
  return B9.get(t);
}
function q9(t) {
  return function(e, r) {
    var n = {
      type: Q.WHITELIST,
      target: e.constructor,
      propertyName: r,
      validationOptions: t
    };
    ie().addValidationMetadata(new me(n));
  };
}
var Ei = (
  /** @class */
  function() {
    function t(e, r, n) {
      n === void 0 && (n = !1), this.target = e, this.name = r, this.async = n;
    }
    return Object.defineProperty(t.prototype, "instance", {
      // -------------------------------------------------------------------------
      // Accessors
      // -------------------------------------------------------------------------
      /**
       * Instance of the target custom validation class which performs validation.
       */
      get: function() {
        return pe(this.target);
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }()
);
function Ri(t) {
  var e;
  if (t.validator instanceof Function) {
    e = t.validator;
    var r = pe(t0).getTargetValidatorConstraints(t.validator);
    if (r.length > 1)
      throw "More than one implementation of ValidatorConstraintInterface found for validator on: ".concat(t.target.name, ":").concat(t.propertyName);
  } else {
    var n = t.validator;
    e = /** @class */
    function() {
      function a() {
      }
      return a.prototype.validate = function(i, u) {
        return n.validate(i, u);
      }, a.prototype.defaultMessage = function(i) {
        return n.defaultMessage ? n.defaultMessage(i) : "";
      }, a;
    }(), ie().addConstraintMetadata(new Ei(e, t.name, t.async));
  }
  var d = {
    type: t.name && Q.isValid(t.name) ? t.name : Q.CUSTOM_VALIDATION,
    name: t.name,
    target: t.target,
    propertyName: t.propertyName,
    validationOptions: t.options,
    constraintCls: e,
    constraints: t.constraints
  };
  ie().addValidationMetadata(new me(d));
}
function C(t, e) {
  return function(r) {
    var n = e && e.each ? "each value in " : "";
    return t(n, r);
  };
}
function N(t, e) {
  return function(r, n) {
    Ri({
      name: t.name,
      target: r.constructor,
      propertyName: n,
      options: e,
      constraints: t.constraints,
      validator: t.validator
    });
  };
}
var Pi = Q.IS_DEFINED;
function Ci(t) {
  return t != null;
}
function Z9(t) {
  return N({
    name: Pi,
    validator: {
      validate: function(e) {
        return Ci(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property should not be null or undefined";
      }, t)
    }
  }, t);
}
var Ni = "isOptional";
function k9(t) {
  return function(e, r) {
    var n = {
      type: Q.CONDITIONAL_VALIDATION,
      name: Ni,
      target: e.constructor,
      propertyName: r,
      constraints: [
        function(d, a) {
          return d[r] !== null && d[r] !== void 0;
        }
      ],
      validationOptions: t
    };
    ie().addValidationMetadata(new me(n));
  };
}
function H9(t) {
  return function(e) {
    var r = t && t.async, n = t && t.name ? t.name : "";
    n || (n = e.name, n || (n = n.replace(/\.?([A-Z]+)/g, function(a, i) {
      return "_" + i.toLowerCase();
    }).replace(/^_/, "")));
    var d = new Ei(e, n, r);
    ie().addConstraintMetadata(d);
  };
}
function G9(t, e, r) {
  return function(n, d) {
    var a = {
      type: Q.CUSTOM_VALIDATION,
      target: n.constructor,
      propertyName: d,
      constraintCls: t,
      constraints: Array.isArray(e) ? e : void 0,
      validationOptions: Array.isArray(e) ? r : e
    };
    ie().addValidationMetadata(new me(a));
  };
}
function j9(t, e) {
  return function(r, n) {
    var d = {
      type: Q.CONDITIONAL_VALIDATION,
      target: r.constructor,
      propertyName: n,
      constraints: [t],
      validationOptions: e
    };
    ie().addValidationMetadata(new me(d));
  };
}
var jn = function() {
  return jn = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var d in e) Object.prototype.hasOwnProperty.call(e, d) && (t[d] = e[d]);
    }
    return t;
  }, jn.apply(this, arguments);
};
function V9(t) {
  var e = jn({}, t), r = e.each ? "each value in " : "";
  return e.message = e.message || r + "nested property $property must be either object or array", function(n, d) {
    var a = {
      type: Q.NESTED_VALIDATION,
      target: n.constructor,
      propertyName: d,
      validationOptions: e
    };
    ie().addValidationMetadata(new me(a));
  };
}
function W9(t) {
  return function(e, r) {
    var n = {
      type: Q.PROMISE_VALIDATION,
      target: e.constructor,
      propertyName: r,
      validationOptions: t
    };
    ie().addValidationMetadata(new me(n));
  };
}
var yt = { exports: {} }, mt = { exports: {} }, L0;
function D() {
  return L0 || (L0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n;
    function r(d) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
        return typeof a;
      } : function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
      }, r(d);
    }
    function n(d) {
      var a = typeof d == "string" || d instanceof String;
      if (!a) {
        var i = r(d);
        throw d === null ? i = "null" : i === "object" && (i = d.constructor.name), new TypeError("Expected a string but received a ".concat(i));
      }
    }
    t.exports = e.default, t.exports.default = e.default;
  }(mt, mt.exports)), mt.exports;
}
var _t = { exports: {} }, F0;
function ee() {
  return F0 || (F0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = r;
    function r() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, d = arguments.length > 1 ? arguments[1] : void 0;
      for (var a in d)
        typeof n[a] > "u" && (n[a] = d[a]);
      return n;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(_t, _t.exports)), _t.exports;
}
var w0;
function Oi() {
  return w0 || (w0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = c;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ ee());
    function d(f) {
      return f && f.__esModule ? f : { default: f };
    }
    var a = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/, i = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/, u = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i, o = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i, s = {
      checkDMS: !1
    };
    function c(f, l) {
      if ((0, r.default)(f), l = (0, n.default)(l, s), !f.includes(",")) return !1;
      var _ = f.split(",");
      return _[0].startsWith("(") && !_[1].endsWith(")") || _[1].endsWith(")") && !_[0].startsWith("(") ? !1 : l.checkDMS ? u.test(_[0]) && o.test(_[1]) : a.test(_[0]) && i.test(_[1]);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(yt, yt.exports)), yt.exports;
}
var K9 = /* @__PURE__ */ Oi();
const Y9 = /* @__PURE__ */ B(K9);
var xi = "isLatLong";
function hn(t) {
  return typeof t == "string" && Y9(t);
}
function z9(t) {
  return N({
    name: xi,
    validator: {
      validate: function(e, r) {
        return hn(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a latitude,longitude string";
      }, t)
    }
  }, t);
}
var Di = "isLatitude";
function Ti(t) {
  return (typeof t == "number" || typeof t == "string") && hn("".concat(t, ",0"));
}
function J9(t) {
  return N({
    name: Di,
    validator: {
      validate: function(e, r) {
        return Ti(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a latitude string or number";
      }, t)
    }
  }, t);
}
var Li = "isLongitude";
function Fi(t) {
  return (typeof t == "number" || typeof t == "string") && hn("0,".concat(t));
}
function X9(t) {
  return N({
    name: Li,
    validator: {
      validate: function(e, r) {
        return Fi(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a longitude string or number";
      }, t)
    }
  }, t);
}
var wi = "equals";
function Bi(t, e) {
  return t === e;
}
function Q9(t, e) {
  return N({
    name: wi,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Bi(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be equal to $constraint1";
      }, e)
    }
  }, e);
}
var Ui = "notEquals";
function qi(t, e) {
  return t !== e;
}
function el(t, e) {
  return N({
    name: Ui,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return qi(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property should not be equal to $constraint1";
      }, e)
    }
  }, e);
}
var Zi = "isEmpty";
function ki(t) {
  return t === "" || t === null || t === void 0;
}
function tl(t) {
  return N({
    name: Zi,
    validator: {
      validate: function(e, r) {
        return ki(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be empty";
      }, t)
    }
  }, t);
}
var Hi = "isNotEmpty";
function Gi(t) {
  return t !== "" && t !== null && t !== void 0;
}
function rl(t) {
  return N({
    name: Hi,
    validator: {
      validate: function(e, r) {
        return Gi(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property should not be empty";
      }, t)
    }
  }, t);
}
var ji = "isIn";
function Vi(t, e) {
  return Array.isArray(e) && e.some(function(r) {
    return r === t;
  });
}
function nl(t, e) {
  return N({
    name: ji,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Vi(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be one of the following values: $constraint1";
      }, e)
    }
  }, e);
}
var Wi = "isNotIn";
function Ki(t, e) {
  return !Array.isArray(e) || !e.some(function(r) {
    return r === t;
  });
}
function dl(t, e) {
  return N({
    name: Wi,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Ki(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property should not be one of the following values: $constraint1";
      }, e)
    }
  }, e);
}
var It = { exports: {} }, At = { exports: {} }, De = {}, St = { exports: {} }, B0;
function Yi() {
  return B0 || (B0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = r;
    function r(n) {
      return n == null;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(St, St.exports)), St.exports;
}
var X = {}, U0;
function ot() {
  if (U0) return X;
  U0 = 1, Object.defineProperty(X, "__esModule", {
    value: !0
  }), X.farsiLocales = X.englishLocales = X.dotDecimal = X.decimal = X.commaDecimal = X.bengaliLocales = X.arabicLocales = X.alphanumeric = X.alpha = void 0;
  for (var t = X.alpha = {
    "en-US": /^[A-Z]+$/i,
    "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[А-Я]+$/i,
    "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[A-ZÆØÅ]+$/i,
    "de-DE": /^[A-ZÄÖÜß]+$/i,
    "el-GR": /^[Α-ώ]+$/i,
    "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
    "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
    "fi-FI": /^[A-ZÅÄÖ]+$/i,
    "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "nb-NO": /^[A-ZÆØÅ]+$/i,
    "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[A-ZÆØÅ]+$/i,
    "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[А-ЯЁ]+$/i,
    "kk-KZ": /^[А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๐\s]+$/i,
    "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
    "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[א-ת]+$/,
    fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    eo: /^[ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
    "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
    "si-LK": /^[\u0D80-\u0DFF]+$/
  }, e = X.alphanumeric = {
    "en-US": /^[0-9A-Z]+$/i,
    "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[0-9А-Я]+$/i,
    "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[0-9A-ZÆØÅ]+$/i,
    "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
    "el-GR": /^[0-9Α-ω]+$/i,
    "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
    "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
    "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
    "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
    "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[0-9А-ЯЁ]+$/i,
    "kk-KZ": /^[0-9А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๙\s]+$/i,
    "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
    "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[0-9א-ת]+$/,
    fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    eo: /^[0-9ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
    "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
    "si-LK": /^[0-9\u0D80-\u0DFF]+$/
  }, r = X.decimal = {
    "en-US": ".",
    ar: "٫"
  }, n = X.englishLocales = ["AU", "GB", "HK", "IN", "NZ", "ZA", "ZM"], d, a = 0; a < n.length; a++)
    d = "en-".concat(n[a]), t[d] = t["en-US"], e[d] = e["en-US"], r[d] = r["en-US"];
  for (var i = X.arabicLocales = ["AE", "BH", "DZ", "EG", "IQ", "JO", "KW", "LB", "LY", "MA", "QM", "QA", "SA", "SD", "SY", "TN", "YE"], u, o = 0; o < i.length; o++)
    u = "ar-".concat(i[o]), t[u] = t.ar, e[u] = e.ar, r[u] = r.ar;
  for (var s = X.farsiLocales = ["IR", "AF"], c, f = 0; f < s.length; f++)
    c = "fa-".concat(s[f]), e[c] = e.fa, r[c] = r.ar;
  for (var l = X.bengaliLocales = ["BD", "IN"], _, p = 0; p < l.length; p++)
    _ = "bn-".concat(l[p]), t[_] = t.bn, e[_] = e.bn, r[_] = r["en-US"];
  for (var $ = X.dotDecimal = ["ar-EG", "ar-LB", "ar-LY"], h = X.commaDecimal = ["bg-BG", "cs-CZ", "da-DK", "de-DE", "el-GR", "en-ZM", "eo", "es-ES", "fr-CA", "fr-FR", "id-ID", "it-IT", "ku-IQ", "hi-IN", "hu-HU", "nb-NO", "nn-NO", "nl-NL", "pl-PL", "pt-PT", "ru-RU", "kk-KZ", "si-LK", "sl-SI", "sr-RS@latin", "sr-RS", "sv-SE", "tr-TR", "uk-UA", "vi-VN"], g = 0; g < $.length; g++)
    r[$[g]] = r["en-US"];
  for (var A = 0; A < h.length; A++)
    r[h[A]] = ",";
  return t["fr-CA"] = t["fr-FR"], e["fr-CA"] = e["fr-FR"], t["pt-BR"] = t["pt-PT"], e["pt-BR"] = e["pt-PT"], r["pt-BR"] = r["pt-PT"], t["pl-Pl"] = t["pl-PL"], e["pl-Pl"] = e["pl-PL"], r["pl-Pl"] = r["pl-PL"], t["fa-AF"] = t.fa, X;
}
var q0;
function zi() {
  if (q0) return De;
  q0 = 1, Object.defineProperty(De, "__esModule", {
    value: !0
  }), De.default = d, De.locales = void 0;
  var t = n(/* @__PURE__ */ D()), e = n(/* @__PURE__ */ Yi()), r = /* @__PURE__ */ ot();
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function d(a, i) {
    (0, t.default)(a), i = i || {};
    var u = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(i.locale ? r.decimal[i.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
    if (a === "" || a === "." || a === "," || a === "-" || a === "+")
      return !1;
    var o = parseFloat(a.replace(",", "."));
    return u.test(a) && (!i.hasOwnProperty("min") || (0, e.default)(i.min) || o >= i.min) && (!i.hasOwnProperty("max") || (0, e.default)(i.max) || o <= i.max) && (!i.hasOwnProperty("lt") || (0, e.default)(i.lt) || o < i.lt) && (!i.hasOwnProperty("gt") || (0, e.default)(i.gt) || o > i.gt);
  }
  return De.locales = Object.keys(r.decimal), De;
}
var Z0;
function Ji() {
  return Z0 || (Z0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ zi());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a) ? parseFloat(a) : NaN;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(At, At.exports)), At.exports;
}
var k0;
function Xi() {
  return k0 || (k0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ Ji());
    function d(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function a(i, u) {
      return (0, r.default)(i), (0, n.default)(i) % parseInt(u, 10) === 0;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(It, It.exports)), It.exports;
}
var al = /* @__PURE__ */ Xi();
const il = /* @__PURE__ */ B(al);
var Qi = "isDivisibleBy";
function eu(t, e) {
  return typeof t == "number" && typeof e == "number" && il(String(t), e);
}
function ul(t, e) {
  return N({
    name: Qi,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return eu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be divisible by $constraint1";
      }, e)
    }
  }, e);
}
var tu = "isPositive";
function ru(t) {
  return typeof t == "number" && t > 0;
}
function ol(t) {
  return N({
    name: tu,
    validator: {
      validate: function(e, r) {
        return ru(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a positive number";
      }, t)
    }
  }, t);
}
var nu = "isNegative";
function du(t) {
  return typeof t == "number" && t < 0;
}
function sl(t) {
  return N({
    name: nu,
    validator: {
      validate: function(e, r) {
        return du(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a negative number";
      }, t)
    }
  }, t);
}
var au = "max";
function iu(t, e) {
  return typeof t == "number" && typeof e == "number" && t <= e;
}
function ll(t, e) {
  return N({
    name: au,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return iu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must not be greater than $constraint1";
      }, e)
    }
  }, e);
}
var uu = "min";
function ou(t, e) {
  return typeof t == "number" && typeof e == "number" && t >= e;
}
function fl(t, e) {
  return N({
    name: uu,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return ou(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must not be less than $constraint1";
      }, e)
    }
  }, e);
}
var su = "minDate";
function lu(t, e) {
  return t instanceof Date && t.getTime() >= (e instanceof Date ? e : e()).getTime();
}
function cl(t, e) {
  return N({
    name: su,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return lu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return "minimal allowed date for " + r + "$property is $constraint1";
      }, e)
    }
  }, e);
}
var fu = "maxDate";
function cu(t, e) {
  return t instanceof Date && t.getTime() <= (e instanceof Date ? e : e()).getTime();
}
function $l(t, e) {
  return N({
    name: fu,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return cu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return "maximal allowed date for " + r + "$property is $constraint1";
      }, e)
    }
  }, e);
}
var bt = { exports: {} }, Mt = { exports: {} }, H0;
function $u() {
  return H0 || (H0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n;
    function r(d) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
        return typeof a;
      } : function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
      }, r(d);
    }
    function n(d) {
      return r(d) === "object" && d !== null ? typeof d.toString == "function" ? d = d.toString() : d = "[object Object]" : (d === null || typeof d > "u" || isNaN(d) && !d.length) && (d = ""), String(d);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Mt, Mt.exports)), Mt.exports;
}
var G0;
function vu() {
  return G0 || (G0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = u;
    var r = a(/* @__PURE__ */ D()), n = a(/* @__PURE__ */ $u()), d = a(/* @__PURE__ */ ee());
    function a(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var i = {
      ignoreCase: !1,
      minOccurrences: 1
    };
    function u(o, s, c) {
      return (0, r.default)(o), c = (0, d.default)(c, i), c.ignoreCase ? o.toLowerCase().split((0, n.default)(s).toLowerCase()).length > c.minOccurrences : o.split((0, n.default)(s)).length > c.minOccurrences;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(bt, bt.exports)), bt.exports;
}
var vl = /* @__PURE__ */ vu();
const pu = /* @__PURE__ */ B(vl);
var hu = "contains";
function gu(t, e) {
  return typeof t == "string" && pu(t, e);
}
function pl(t, e) {
  return N({
    name: hu,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return gu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must contain a $constraint1 string";
      }, e)
    }
  }, e);
}
var yu = "notContains";
function mu(t, e) {
  return typeof t == "string" && !pu(t, e);
}
function hl(t, e) {
  return N({
    name: yu,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return mu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property should not contain a $constraint1 string";
      }, e)
    }
  }, e);
}
var Te = {}, j0;
function _u() {
  if (j0) return Te;
  j0 = 1, Object.defineProperty(Te, "__esModule", {
    value: !0
  }), Te.default = n, Te.locales = void 0;
  var t = r(/* @__PURE__ */ D()), e = /* @__PURE__ */ ot();
  function r(d) {
    return d && d.__esModule ? d : { default: d };
  }
  function n(d) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, t.default)(d);
    var u = d, o = i.ignore;
    if (o)
      if (o instanceof RegExp)
        u = u.replace(o, "");
      else if (typeof o == "string")
        u = u.replace(new RegExp("[".concat(o.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
      else
        throw new Error("ignore should be instance of a String or RegExp");
    if (a in e.alpha)
      return e.alpha[a].test(u);
    throw new Error("Invalid locale '".concat(a, "'"));
  }
  return Te.locales = Object.keys(e.alpha), Te;
}
var gl = /* @__PURE__ */ _u();
const yl = /* @__PURE__ */ B(gl);
var Iu = "isAlpha";
function Au(t, e) {
  return typeof t == "string" && yl(t, e);
}
function ml(t, e) {
  return N({
    name: Iu,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Au(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must contain only letters (a-zA-Z)";
      }, e)
    }
  }, e);
}
var Le = {}, V0;
function Su() {
  if (V0) return Le;
  V0 = 1, Object.defineProperty(Le, "__esModule", {
    value: !0
  }), Le.default = n, Le.locales = void 0;
  var t = r(/* @__PURE__ */ D()), e = /* @__PURE__ */ ot();
  function r(d) {
    return d && d.__esModule ? d : { default: d };
  }
  function n(d) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, t.default)(d);
    var u = d, o = i.ignore;
    if (o)
      if (o instanceof RegExp)
        u = u.replace(o, "");
      else if (typeof o == "string")
        u = u.replace(new RegExp("[".concat(o.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
      else
        throw new Error("ignore should be instance of a String or RegExp");
    if (a in e.alphanumeric)
      return e.alphanumeric[a].test(u);
    throw new Error("Invalid locale '".concat(a, "'"));
  }
  return Le.locales = Object.keys(e.alphanumeric), Le;
}
var _l = /* @__PURE__ */ Su();
const Il = /* @__PURE__ */ B(_l);
var bu = "isAlphanumeric";
function Mu(t, e) {
  return typeof t == "string" && Il(t, e);
}
function Al(t, e) {
  return N({
    name: bu,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Mu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must contain only letters and numbers";
      }, e)
    }
  }, e);
}
var Et = { exports: {} }, Rt = { exports: {} }, W0;
function Sl() {
  return W0 || (W0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = function(d, a) {
      return d.some(function(i) {
        return a === i;
      });
    };
    e.default = r, t.exports = e.default, t.exports.default = e.default;
  }(Rt, Rt.exports)), Rt.exports;
}
var K0;
function Eu() {
  return K0 || (K0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = c;
    var r = i(/* @__PURE__ */ ee()), n = i(/* @__PURE__ */ D()), d = i(/* @__PURE__ */ Sl()), a = /* @__PURE__ */ ot();
    function i(f) {
      return f && f.__esModule ? f : { default: f };
    }
    function u(f) {
      var l = new RegExp("^[-+]?([0-9]+)?(\\".concat(a.decimal[f.locale], "[0-9]{").concat(f.decimal_digits, "})").concat(f.force_decimal ? "" : "?", "$"));
      return l;
    }
    var o = {
      force_decimal: !1,
      decimal_digits: "1,",
      locale: "en-US"
    }, s = ["", "-", "+"];
    function c(f, l) {
      if ((0, n.default)(f), l = (0, r.default)(l, o), l.locale in a.decimal)
        return !(0, d.default)(s, f.replace(/ /g, "")) && u(l).test(f);
      throw new Error("Invalid locale '".concat(l.locale, "'"));
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Et, Et.exports)), Et.exports;
}
var bl = /* @__PURE__ */ Eu();
const Ml = /* @__PURE__ */ B(bl);
var Ru = "isDecimal";
function Pu(t, e) {
  return typeof t == "string" && Ml(t, e);
}
function El(t, e) {
  return N({
    name: Ru,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Pu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property is not a valid decimal number.";
      }, e)
    }
  }, e);
}
var Pt = { exports: {} }, Y0;
function Cu() {
  return Y0 || (Y0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^[\x00-\x7F]+$/;
    function a(i) {
      return (0, r.default)(i), d.test(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Pt, Pt.exports)), Pt.exports;
}
var Rl = /* @__PURE__ */ Cu();
const Pl = /* @__PURE__ */ B(Rl);
var Nu = "isAscii";
function Ou(t) {
  return typeof t == "string" && Pl(t);
}
function Cl(t) {
  return N({
    name: Nu,
    validator: {
      validate: function(e, r) {
        return Ou(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must contain only ASCII characters";
      }, t)
    }
  }, t);
}
var Ct = { exports: {} }, z0;
function r0() {
  return z0 || (z0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = o;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ ee());
    function d(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var a = /[^A-Z0-9+\/=]/i, i = /^[A-Z0-9_\-]*$/i, u = {
      urlSafe: !1
    };
    function o(s, c) {
      (0, r.default)(s), c = (0, n.default)(c, u);
      var f = s.length;
      if (c.urlSafe)
        return i.test(s);
      if (f % 4 !== 0 || a.test(s))
        return !1;
      var l = s.indexOf("=");
      return l === -1 || l === f - 1 || l === f - 2 && s[f - 1] === "=";
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Ct, Ct.exports)), Ct.exports;
}
var Nl = /* @__PURE__ */ r0();
const Ol = /* @__PURE__ */ B(Nl);
var xu = "isBase64";
function Du(t, e) {
  return typeof t == "string" && Ol(t, e);
}
function xl(t, e) {
  return N({
    name: xu,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Du(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be base64 encoded";
      }, e)
    }
  }, e);
}
var Nt = { exports: {} }, J0;
function n0() {
  return J0 || (J0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function d(i) {
      "@babel/helpers - typeof";
      return d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
        return typeof u;
      } : function(u) {
        return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
      }, d(i);
    }
    function a(i, u) {
      (0, r.default)(i);
      var o, s;
      d(u) === "object" ? (o = u.min || 0, s = u.max) : (o = arguments[1], s = arguments[2]);
      var c = encodeURI(i).split(/%..|./).length - 1;
      return c >= o && (typeof s > "u" || c <= s);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Nt, Nt.exports)), Nt.exports;
}
var Dl = /* @__PURE__ */ n0();
const Tl = /* @__PURE__ */ B(Dl);
var Tu = "isByteLength";
function Lu(t, e, r) {
  return typeof t == "string" && Tl(t, { min: e, max: r });
}
function Ll(t, e, r) {
  return N({
    name: Tu,
    constraints: [t, e],
    validator: {
      validate: function(n, d) {
        return Lu(n, d == null ? void 0 : d.constraints[0], d == null ? void 0 : d.constraints[1]);
      },
      defaultMessage: C(function(n) {
        return n + "$property's byte length must fall into ($constraint1, $constraint2) range";
      }, r)
    }
  }, r);
}
var Ot = { exports: {} }, xt = { exports: {} }, X0;
function Fu() {
  return X0 || (X0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      (0, r.default)(a);
      for (var i = a.replace(/[- ]+/g, ""), u = 0, o, s, c, f = i.length - 1; f >= 0; f--)
        o = i.substring(f, f + 1), s = parseInt(o, 10), c ? (s *= 2, s >= 10 ? u += s % 10 + 1 : u += s) : u += s, c = !c;
      return !!(u % 10 === 0 && i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(xt, xt.exports)), xt.exports;
}
var Q0;
function wu() {
  return Q0 || (Q0 = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = u;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ Fu());
    function d(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var a = {
      amex: /^3[47][0-9]{13}$/,
      dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
      discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
      jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
      mastercard: /^5[1-5][0-9]{2}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
      // /^[25][1-7][0-9]{14}$/;
      unionpay: /^(6[27][0-9]{14}|^(81[0-9]{14,17}))$/,
      visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/
    }, i = function() {
      var o = [];
      for (var s in a)
        a.hasOwnProperty(s) && o.push(a[s]);
      return o;
    }();
    function u(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, r.default)(o);
      var c = s.provider, f = o.replace(/[- ]+/g, "");
      if (c && c.toLowerCase() in a) {
        if (!a[c.toLowerCase()].test(f))
          return !1;
      } else {
        if (c && !(c.toLowerCase() in a))
          throw new Error("".concat(c, " is not a valid credit card provider."));
        if (!i.some(function(l) {
          return l.test(f);
        }))
          return !1;
      }
      return (0, n.default)(o);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Ot, Ot.exports)), Ot.exports;
}
var Fl = /* @__PURE__ */ wu();
const wl = /* @__PURE__ */ B(Fl);
var Bu = "isCreditCard";
function Uu(t) {
  return typeof t == "string" && wl(t);
}
function Bl(t) {
  return N({
    name: Bu,
    validator: {
      validate: function(e, r) {
        return Uu(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a credit card";
      }, t)
    }
  }, t);
}
var Dt = { exports: {} }, ed;
function qu() {
  return ed || (ed = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = u;
    var r = d(/* @__PURE__ */ ee()), n = d(/* @__PURE__ */ D());
    function d(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function a(o) {
      var s = "\\d{".concat(o.digits_after_decimal[0], "}");
      o.digits_after_decimal.forEach(function(A, R) {
        R !== 0 && (s = "".concat(s, "|\\d{").concat(A, "}"));
      });
      var c = "(".concat(o.symbol.replace(/\W/, function(A) {
        return "\\".concat(A);
      }), ")").concat(o.require_symbol ? "" : "?"), f = "-?", l = "[1-9]\\d*", _ = "[1-9]\\d{0,2}(\\".concat(o.thousands_separator, "\\d{3})*"), p = ["0", l, _], $ = "(".concat(p.join("|"), ")?"), h = "(\\".concat(o.decimal_separator, "(").concat(s, "))").concat(o.require_decimal ? "" : "?"), g = $ + (o.allow_decimal || o.require_decimal ? h : "");
      return o.allow_negatives && !o.parens_for_negatives && (o.negative_sign_after_digits ? g += f : o.negative_sign_before_digits && (g = f + g)), o.allow_negative_sign_placeholder ? g = "( (?!\\-))?".concat(g) : o.allow_space_after_symbol ? g = " ?".concat(g) : o.allow_space_after_digits && (g += "( (?!$))?"), o.symbol_after_digits ? g += c : g = c + g, o.allow_negatives && (o.parens_for_negatives ? g = "(\\(".concat(g, "\\)|").concat(g, ")") : o.negative_sign_before_digits || o.negative_sign_after_digits || (g = f + g)), new RegExp("^(?!-? )(?=.*\\d)".concat(g, "$"));
    }
    var i = {
      symbol: "$",
      require_symbol: !1,
      allow_space_after_symbol: !1,
      symbol_after_digits: !1,
      allow_negatives: !0,
      parens_for_negatives: !1,
      negative_sign_before_digits: !1,
      negative_sign_after_digits: !1,
      allow_negative_sign_placeholder: !1,
      thousands_separator: ",",
      decimal_separator: ".",
      allow_decimal: !0,
      require_decimal: !1,
      digits_after_decimal: [2],
      allow_space_after_digits: !1
    };
    function u(o, s) {
      return (0, n.default)(o), s = (0, r.default)(s, i), a(s).test(o);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Dt, Dt.exports)), Dt.exports;
}
var Ul = /* @__PURE__ */ qu();
const ql = /* @__PURE__ */ B(Ul);
var Zu = "isCurrency";
function ku(t, e) {
  return typeof t == "string" && ql(t, e);
}
function Zl(t, e) {
  return N({
    name: Zu,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return ku(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a currency";
      }, e)
    }
  }, e);
}
var Tt = { exports: {} }, Lt = { exports: {} }, td;
function Hu() {
  return td || (td = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n;
    function r(d) {
      return Object.prototype.toString.call(d) === "[object RegExp]";
    }
    function n(d, a) {
      for (var i = 0; i < a.length; i++) {
        var u = a[i];
        if (d === u || r(u) && u.test(d))
          return !0;
      }
      return !1;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Lt, Lt.exports)), Lt.exports;
}
var Ft = { exports: {} }, rd;
function gn() {
  return rd || (rd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ ee());
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = {
      require_tld: !0,
      allow_underscores: !1,
      allow_trailing_dot: !1,
      allow_numeric_tld: !1,
      allow_wildcard: !1,
      ignore_max_length: !1
    };
    function i(u, o) {
      (0, r.default)(u), o = (0, n.default)(o, a), o.allow_trailing_dot && u[u.length - 1] === "." && (u = u.substring(0, u.length - 1)), o.allow_wildcard === !0 && u.indexOf("*.") === 0 && (u = u.substring(2));
      var s = u.split("."), c = s[s.length - 1];
      return o.require_tld && (s.length < 2 || !o.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(c) || /\s/.test(c)) || !o.allow_numeric_tld && /^\d+$/.test(c) ? !1 : s.every(function(f) {
        return !(f.length > 63 && !o.ignore_max_length || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(f) || /[\uff01-\uff5e]/.test(f) || /^-|-$/.test(f) || !o.allow_underscores && /_/.test(f));
      });
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Ft, Ft.exports)), Ft.exports;
}
var wt = { exports: {} }, nd;
function st() {
  return nd || (nd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = s;
    var r = n(/* @__PURE__ */ D());
    function n(c) {
      return c && c.__esModule ? c : { default: c };
    }
    var d = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", a = "(".concat(d, "[.]){3}").concat(d), i = new RegExp("^".concat(a, "$")), u = "(?:[0-9a-fA-F]{1,4})", o = new RegExp("^(" + "(?:".concat(u, ":){7}(?:").concat(u, "|:)|") + "(?:".concat(u, ":){6}(?:").concat(a, "|:").concat(u, "|:)|") + "(?:".concat(u, ":){5}(?::").concat(a, "|(:").concat(u, "){1,2}|:)|") + "(?:".concat(u, ":){4}(?:(:").concat(u, "){0,1}:").concat(a, "|(:").concat(u, "){1,3}|:)|") + "(?:".concat(u, ":){3}(?:(:").concat(u, "){0,2}:").concat(a, "|(:").concat(u, "){1,4}|:)|") + "(?:".concat(u, ":){2}(?:(:").concat(u, "){0,3}:").concat(a, "|(:").concat(u, "){1,5}|:)|") + "(?:".concat(u, ":){1}(?:(:").concat(u, "){0,4}:").concat(a, "|(:").concat(u, "){1,6}|:)|") + "(?::((?::".concat(u, "){0,5}:").concat(a, "|(?::").concat(u, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
    function s(c) {
      var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      return (0, r.default)(c), f = String(f), f ? f === "4" ? i.test(c) : f === "6" ? o.test(c) : !1 : s(c, 4) || s(c, 6);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(wt, wt.exports)), wt.exports;
}
var dd;
function d0() {
  return dd || (dd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = A;
    var r = o(/* @__PURE__ */ D()), n = o(/* @__PURE__ */ Hu()), d = o(/* @__PURE__ */ n0()), a = o(/* @__PURE__ */ gn()), i = o(/* @__PURE__ */ st()), u = o(/* @__PURE__ */ ee());
    function o(R) {
      return R && R.__esModule ? R : { default: R };
    }
    var s = {
      allow_display_name: !1,
      allow_underscores: !1,
      require_display_name: !1,
      allow_utf8_local_part: !0,
      require_tld: !0,
      blacklisted_chars: "",
      ignore_max_length: !1,
      host_blacklist: [],
      host_whitelist: []
    }, c = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i, f = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, l = /^[a-z\d]+$/, _ = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, p = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, $ = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, h = 254;
    function g(R) {
      var y = R.replace(/^"(.+)"$/, "$1");
      if (!y.trim())
        return !1;
      var S = /[\.";<>]/.test(y);
      if (S) {
        if (y === R)
          return !1;
        var O = y.split('"').length === y.split('\\"').length;
        if (!O)
          return !1;
      }
      return !0;
    }
    function A(R, y) {
      if ((0, r.default)(R), y = (0, u.default)(y, s), y.require_display_name || y.allow_display_name) {
        var S = R.match(c);
        if (S) {
          var O = S[1];
          if (R = R.replace(O, "").replace(/(^<|>$)/g, ""), O.endsWith(" ") && (O = O.slice(0, -1)), !g(O))
            return !1;
        } else if (y.require_display_name)
          return !1;
      }
      if (!y.ignore_max_length && R.length > h)
        return !1;
      var P = R.split("@"), b = P.pop(), I = b.toLowerCase();
      if (y.host_blacklist.length > 0 && (0, n.default)(I, y.host_blacklist) || y.host_whitelist.length > 0 && !(0, n.default)(I, y.host_whitelist))
        return !1;
      var E = P.join("@");
      if (y.domain_specific_validation && (I === "gmail.com" || I === "googlemail.com")) {
        E = E.toLowerCase();
        var T = E.split("+")[0];
        if (!(0, d.default)(T.replace(/\./g, ""), {
          min: 6,
          max: 30
        }))
          return !1;
        for (var U = T.split("."), Z = 0; Z < U.length; Z++)
          if (!l.test(U[Z]))
            return !1;
      }
      if (y.ignore_max_length === !1 && (!(0, d.default)(E, {
        max: 64
      }) || !(0, d.default)(b, {
        max: 254
      })))
        return !1;
      if (!(0, a.default)(b, {
        require_tld: y.require_tld,
        ignore_max_length: y.ignore_max_length,
        allow_underscores: y.allow_underscores
      })) {
        if (!y.allow_ip_domain)
          return !1;
        if (!(0, i.default)(b)) {
          if (!b.startsWith("[") || !b.endsWith("]"))
            return !1;
          var H = b.slice(1, -1);
          if (H.length === 0 || !(0, i.default)(H))
            return !1;
        }
      }
      if (y.blacklisted_chars && E.search(new RegExp("[".concat(y.blacklisted_chars, "]+"), "g")) !== -1)
        return !1;
      if (E[0] === '"' && E[E.length - 1] === '"')
        return E = E.slice(1, E.length - 1), y.allow_utf8_local_part ? $.test(E) : _.test(E);
      for (var W = y.allow_utf8_local_part ? p : f, re = E.split("."), _e = 0; _e < re.length; _e++)
        if (!W.test(re[_e]))
          return !1;
      return !0;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Tt, Tt.exports)), Tt.exports;
}
var kl = /* @__PURE__ */ d0();
const Hl = /* @__PURE__ */ B(kl);
var Gu = "isEmail";
function ju(t, e) {
  return typeof t == "string" && Hl(t, e);
}
function Gl(t, e) {
  return N({
    name: Gu,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return ju(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be an email";
      }, e)
    }
  }, e);
}
var jl = /* @__PURE__ */ gn();
const Vl = /* @__PURE__ */ B(jl);
var Vu = "isFqdn";
function Wu(t, e) {
  return typeof t == "string" && Vl(t, e);
}
function Wl(t, e) {
  return N({
    name: Vu,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Wu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a valid domain name";
      }, e)
    }
  }, e);
}
var Fe = {}, ad;
function a0() {
  if (ad) return Fe;
  ad = 1, Object.defineProperty(Fe, "__esModule", {
    value: !0
  }), Fe.default = n, Fe.fullWidth = void 0;
  var t = e(/* @__PURE__ */ D());
  function e(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = Fe.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
  function n(d) {
    return (0, t.default)(d), r.test(d);
  }
  return Fe;
}
var Kl = /* @__PURE__ */ a0();
const Yl = /* @__PURE__ */ B(Kl);
var Ku = "isFullWidth";
function Yu(t) {
  return typeof t == "string" && Yl(t);
}
function zl(t) {
  return N({
    name: Ku,
    validator: {
      validate: function(e, r) {
        return Yu(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must contain a full-width characters";
      }, t)
    }
  }, t);
}
var we = {}, id;
function i0() {
  if (id) return we;
  id = 1, Object.defineProperty(we, "__esModule", {
    value: !0
  }), we.default = n, we.halfWidth = void 0;
  var t = e(/* @__PURE__ */ D());
  function e(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = we.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
  function n(d) {
    return (0, t.default)(d), r.test(d);
  }
  return we;
}
var Jl = /* @__PURE__ */ i0();
const Xl = /* @__PURE__ */ B(Jl);
var zu = "isHalfWidth";
function Ju(t) {
  return typeof t == "string" && Xl(t);
}
function Ql(t) {
  return N({
    name: zu,
    validator: {
      validate: function(e, r) {
        return Ju(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must contain a half-width characters";
      }, t)
    }
  }, t);
}
var Bt = { exports: {} }, ud;
function Xu() {
  return ud || (ud = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = a(/* @__PURE__ */ D()), n = /* @__PURE__ */ a0(), d = /* @__PURE__ */ i0();
    function a(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function i(u) {
      return (0, r.default)(u), n.fullWidth.test(u) && d.halfWidth.test(u);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Bt, Bt.exports)), Bt.exports;
}
var ef = /* @__PURE__ */ Xu();
const tf = /* @__PURE__ */ B(ef);
var Qu = "isVariableWidth";
function e1(t) {
  return typeof t == "string" && tf(t);
}
function rf(t) {
  return N({
    name: Qu,
    validator: {
      validate: function(e, r) {
        return e1(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must contain a full-width and half-width characters";
      }, t)
    }
  }, t);
}
var Ut = { exports: {} }, od;
function t1() {
  return od || (od = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
    function a(i) {
      return (0, r.default)(i), d.test(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Ut, Ut.exports)), Ut.exports;
}
var nf = /* @__PURE__ */ t1();
const df = /* @__PURE__ */ B(nf);
var r1 = "isHexColor";
function n1(t) {
  return typeof t == "string" && df(t);
}
function af(t) {
  return N({
    name: r1,
    validator: {
      validate: function(e, r) {
        return n1(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a hexadecimal color";
      }, t)
    }
  }, t);
}
var qt = { exports: {} }, sd;
function u0() {
  return sd || (sd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^(0x|0h)?[0-9A-F]+$/i;
    function a(i) {
      return (0, r.default)(i), d.test(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(qt, qt.exports)), qt.exports;
}
var uf = /* @__PURE__ */ u0();
const of = /* @__PURE__ */ B(uf);
var d1 = "isHexadecimal";
function a1(t) {
  return typeof t == "string" && of(t);
}
function sf(t) {
  return N({
    name: d1,
    validator: {
      validate: function(e, r) {
        return a1(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a hexadecimal number";
      }, t)
    }
  }, t);
}
function Vn(t) {
  return t ? "each" in t || "message" in t || "groups" in t || "always" in t || "context" in t : !1;
}
var Zt = { exports: {} }, ld;
function i1() {
  return ld || (ld = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = c;
    var r = n(/* @__PURE__ */ D());
    function n(f) {
      return f && f.__esModule ? f : { default: f };
    }
    var d = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/, a = /^([0-9a-fA-F]){12}$/, i = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/, u = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){6}([0-9a-fA-F]{2})$/, o = /^([0-9a-fA-F]){16}$/, s = /^([0-9a-fA-F]{4}\.){3}([0-9a-fA-F]{4})$/;
    function c(f, l) {
      return (0, r.default)(f), l != null && l.eui && (l.eui = String(l.eui)), l != null && l.no_colons || l != null && l.no_separators ? l.eui === "48" ? a.test(f) : l.eui === "64" ? o.test(f) : a.test(f) || o.test(f) : (l == null ? void 0 : l.eui) === "48" ? d.test(f) || i.test(f) : (l == null ? void 0 : l.eui) === "64" ? u.test(f) || s.test(f) : c(f, {
        eui: "48"
      }) || c(f, {
        eui: "64"
      });
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Zt, Zt.exports)), Zt.exports;
}
var lf = /* @__PURE__ */ i1();
const ff = /* @__PURE__ */ B(lf);
var u1 = "isMacAddress";
function o1(t, e) {
  return typeof t == "string" && ff(t, e);
}
function cf(t, e) {
  var r = Vn(t) ? void 0 : t, n = Vn(t) ? t : e;
  return N({
    name: u1,
    constraints: [r],
    validator: {
      validate: function(d, a) {
        return o1(d, r);
      },
      defaultMessage: C(function(d) {
        return d + "$property must be a MAC Address";
      }, n)
    }
  }, n);
}
var $f = /* @__PURE__ */ st();
const vf = /* @__PURE__ */ B($f);
var s1 = "isIp";
function l1(t, e) {
  var r = e ? "".concat(e) : void 0;
  return typeof t == "string" && vf(t, r);
}
function pf(t, e) {
  return N({
    name: s1,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return l1(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be an ip address";
      }, e)
    }
  }, e);
}
var kt = { exports: {} }, Ht = { exports: {} }, fd;
function o0() {
  return fd || (fd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = u;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ Yi());
    function d(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var a = /^(?:[-+]?(?:0|[1-9][0-9]*))$/, i = /^[-+]?[0-9]+$/;
    function u(o, s) {
      (0, r.default)(o), s = s || {};
      var c = s.allow_leading_zeroes === !1 ? a : i, f = !s.hasOwnProperty("min") || (0, n.default)(s.min) || o >= s.min, l = !s.hasOwnProperty("max") || (0, n.default)(s.max) || o <= s.max, _ = !s.hasOwnProperty("lt") || (0, n.default)(s.lt) || o < s.lt, p = !s.hasOwnProperty("gt") || (0, n.default)(s.gt) || o > s.gt;
      return c.test(o) && f && l && _ && p;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Ht, Ht.exports)), Ht.exports;
}
var cd;
function f1() {
  return cd || (cd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ o0());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a, {
        allow_leading_zeroes: !1,
        min: 0,
        max: 65535
      });
    }
    t.exports = e.default, t.exports.default = e.default;
  }(kt, kt.exports)), kt.exports;
}
var hf = /* @__PURE__ */ f1();
const gf = /* @__PURE__ */ B(hf);
var c1 = "isPort";
function $1(t) {
  return typeof t == "string" && gf(t);
}
function yf(t) {
  return N({
    name: c1,
    validator: {
      validate: function(e, r) {
        return $1(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a port";
      }, t)
    }
  }, t);
}
var Gt = { exports: {} }, $d;
function v1() {
  return $d || ($d = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = u;
    var r = n(/* @__PURE__ */ D());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^(?:[0-9]{9}X|[0-9]{10})$/, a = /^(?:[0-9]{13})$/, i = [1, 3];
    function u(o, s) {
      (0, r.default)(o);
      var c = String((s == null ? void 0 : s.version) || s);
      if (!(s != null && s.version || s))
        return u(o, {
          version: 10
        }) || u(o, {
          version: 13
        });
      var f = o.replace(/[\s-]+/g, ""), l = 0;
      if (c === "10") {
        if (!d.test(f))
          return !1;
        for (var _ = 0; _ < c - 1; _++)
          l += (_ + 1) * f.charAt(_);
        if (f.charAt(9) === "X" ? l += 10 * 10 : l += 10 * f.charAt(9), l % 11 === 0)
          return !0;
      } else if (c === "13") {
        if (!a.test(f))
          return !1;
        for (var p = 0; p < 12; p++)
          l += i[p % 2] * f.charAt(p);
        if (f.charAt(12) - (10 - l % 10) % 10 === 0)
          return !0;
      }
      return !1;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Gt, Gt.exports)), Gt.exports;
}
var mf = /* @__PURE__ */ v1();
const _f = /* @__PURE__ */ B(mf);
var p1 = "isIsbn";
function h1(t, e) {
  var r = e ? "".concat(e) : void 0;
  return typeof t == "string" && _f(t, r);
}
function If(t, e) {
  return N({
    name: p1,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return h1(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be an ISBN";
      }, e)
    }
  }, e);
}
var jt = { exports: {} }, vd;
function g1() {
  return vd || (vd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
    function a(i) {
      if ((0, r.default)(i), !d.test(i))
        return !1;
      for (var u = !0, o = 0, s = i.length - 2; s >= 0; s--)
        if (i[s] >= "A" && i[s] <= "Z")
          for (var c = i[s].charCodeAt(0) - 55, f = c % 10, l = Math.trunc(c / 10), _ = 0, p = [f, l]; _ < p.length; _++) {
            var $ = p[_];
            u ? $ >= 5 ? o += 1 + ($ - 5) * 2 : o += $ * 2 : o += $, u = !u;
          }
        else {
          var h = i[s].charCodeAt(0) - 48;
          u ? h >= 5 ? o += 1 + (h - 5) * 2 : o += h * 2 : o += h, u = !u;
        }
      var g = Math.trunc((o + 9) / 10) * 10 - o;
      return +i[i.length - 1] === g;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(jt, jt.exports)), jt.exports;
}
var Af = /* @__PURE__ */ g1();
const Sf = /* @__PURE__ */ B(Af);
var y1 = "isIsin";
function m1(t) {
  return typeof t == "string" && Sf(t);
}
function bf(t) {
  return N({
    name: y1,
    validator: {
      validate: function(e, r) {
        return m1(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be an ISIN (stock/security identifier)";
      }, t)
    }
  }, t);
}
var Vt = { exports: {} }, pd;
function _1() {
  return pd || (pd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = u;
    var r = n(/* @__PURE__ */ D());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, a = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, i = function(s) {
      var c = s.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
      if (c) {
        var f = Number(c[1]), l = Number(c[2]);
        return f % 4 === 0 && f % 100 !== 0 || f % 400 === 0 ? l <= 366 : l <= 365;
      }
      var _ = s.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number), p = _[1], $ = _[2], h = _[3], g = $ && "0".concat($).slice(-2), A = h && "0".concat(h).slice(-2), R = new Date("".concat(p, "-").concat(g || "01", "-").concat(A || "01"));
      return $ && h ? R.getUTCFullYear() === p && R.getUTCMonth() + 1 === $ && R.getUTCDate() === h : !0;
    };
    function u(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, r.default)(o);
      var c = s.strictSeparator ? a.test(o) : d.test(o);
      return c && s.strict ? i(o) : c;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Vt, Vt.exports)), Vt.exports;
}
var Mf = /* @__PURE__ */ _1();
const Ef = /* @__PURE__ */ B(Mf);
var I1 = "isIso8601";
function s0(t, e) {
  return typeof t == "string" && Ef(t, e);
}
function Rf(t, e) {
  return N({
    name: I1,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return s0(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a valid ISO 8601 date string";
      }, e)
    }
  }, e);
}
var Wt = { exports: {} }, hd;
function A1() {
  return hd || (hd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = u;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ ee());
    function d(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function a(o) {
      "@babel/helpers - typeof";
      return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
        return typeof s;
      } : function(s) {
        return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
      }, a(o);
    }
    var i = {
      allow_primitives: !1
    };
    function u(o, s) {
      (0, r.default)(o);
      try {
        s = (0, n.default)(s, i);
        var c = [];
        s.allow_primitives && (c = [null, !1, !0]);
        var f = JSON.parse(o);
        return c.includes(f) || !!f && a(f) === "object";
      } catch {
      }
      return !1;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Wt, Wt.exports)), Wt.exports;
}
var Pf = /* @__PURE__ */ A1();
const Cf = /* @__PURE__ */ B(Pf);
var S1 = "isJson";
function b1(t) {
  return typeof t == "string" && Cf(t);
}
function Nf(t) {
  return N({
    name: S1,
    validator: {
      validate: function(e, r) {
        return b1(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a json string";
      }, t)
    }
  }, t);
}
var Kt = { exports: {} }, gd;
function M1() {
  return gd || (gd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ r0());
    function d(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function a(i) {
      (0, r.default)(i);
      var u = i.split("."), o = u.length;
      return o !== 3 ? !1 : u.reduce(function(s, c) {
        return s && (0, n.default)(c, {
          urlSafe: !0
        });
      }, !0);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Kt, Kt.exports)), Kt.exports;
}
var Of = /* @__PURE__ */ M1();
const xf = /* @__PURE__ */ B(Of);
var E1 = "isJwt";
function R1(t) {
  return typeof t == "string" && xf(t);
}
function Df(t) {
  return N({
    name: E1,
    validator: {
      validate: function(e, r) {
        return R1(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a jwt string";
      }, t)
    }
  }, t);
}
var Yt = { exports: {} }, yd;
function P1() {
  return yd || (yd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a), a === a.toLowerCase();
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Yt, Yt.exports)), Yt.exports;
}
var Tf = /* @__PURE__ */ P1();
const Lf = /* @__PURE__ */ B(Tf);
var C1 = "isLowercase";
function N1(t) {
  return typeof t == "string" && Lf(t);
}
function Ff(t) {
  return N({
    name: C1,
    validator: {
      validate: function(e, r) {
        return N1(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a lowercase string";
      }, t)
    }
  }, t);
}
var Be = {}, md;
function O1() {
  if (md) return Be;
  md = 1, Object.defineProperty(Be, "__esModule", {
    value: !0
  }), Be.default = n, Be.locales = void 0;
  var t = e(/* @__PURE__ */ D());
  function e(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = {
    "am-AM": /^(\+?374|0)(33|4[134]|55|77|88|9[13-689])\d{6}$/,
    "ar-AE": /^((\+?971)|0)?5[024568]\d{7}$/,
    "ar-BH": /^(\+?973)?(3|6)\d{7}$/,
    "ar-DZ": /^(\+?213|0)(5|6|7)\d{8}$/,
    "ar-LB": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
    "ar-EG": /^((\+?20)|0)?1[0125]\d{8}$/,
    "ar-IQ": /^(\+?964|0)?7[0-9]\d{8}$/,
    "ar-JO": /^(\+?962|0)?7[789]\d{7}$/,
    "ar-KW": /^(\+?965)([569]\d{7}|41\d{6})$/,
    "ar-LY": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
    "ar-MA": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
    "ar-OM": /^((\+|00)968)?(9[1-9])\d{6}$/,
    "ar-PS": /^(\+?970|0)5[6|9](\d{7})$/,
    "ar-SA": /^(!?(\+?966)|0)?5\d{8}$/,
    "ar-SD": /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
    "ar-SY": /^(!?(\+?963)|0)?9\d{8}$/,
    "ar-TN": /^(\+?216)?[2459]\d{7}$/,
    "az-AZ": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
    "bs-BA": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
    "be-BY": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
    "bg-BG": /^(\+?359|0)?8[789]\d{7}$/,
    "bn-BD": /^(\+?880|0)1[13456789][0-9]{8}$/,
    "ca-AD": /^(\+376)?[346]\d{5}$/,
    "cs-CZ": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "da-DK": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "de-DE": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
    "de-AT": /^(\+43|0)\d{1,4}\d{3,12}$/,
    "de-CH": /^(\+41|0)([1-9])\d{1,9}$/,
    "de-LU": /^(\+352)?((6\d1)\d{6})$/,
    "dv-MV": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
    "el-GR": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
    "el-CY": /^(\+?357?)?(9(9|6)\d{6})$/,
    "en-AI": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
    "en-AU": /^(\+?61|0)4\d{8}$/,
    "en-AG": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
    "en-BM": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
    "en-BS": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
    "en-GB": /^(\+?44|0)7[1-9]\d{8}$/,
    "en-GG": /^(\+?44|0)1481\d{6}$/,
    "en-GH": /^(\+233|0)(20|50|24|54|27|57|26|56|23|53|28|55|59)\d{7}$/,
    "en-GY": /^(\+592|0)6\d{6}$/,
    "en-HK": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
    "en-MO": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
    "en-IE": /^(\+?353|0)8[356789]\d{7}$/,
    "en-IN": /^(\+?91|0)?[6789]\d{9}$/,
    "en-JM": /^(\+?876)?\d{7}$/,
    "en-KE": /^(\+?254|0)(7|1)\d{8}$/,
    "fr-CF": /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
    "en-SS": /^(\+?211|0)(9[1257])\d{7}$/,
    "en-KI": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
    "en-KN": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
    "en-LS": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
    "en-MT": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
    "en-MU": /^(\+?230|0)?\d{8}$/,
    "en-MW": /^(\+?265|0)(((77|88|31|99|98|21)\d{7})|(((111)|1)\d{6})|(32000\d{4}))$/,
    "en-NA": /^(\+?264|0)(6|8)\d{7}$/,
    "en-NG": /^(\+?234|0)?[789]\d{9}$/,
    "en-NZ": /^(\+?64|0)[28]\d{7,9}$/,
    "en-PG": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
    "en-PK": /^((00|\+)?92|0)3[0-6]\d{8}$/,
    "en-PH": /^(09|\+639)\d{9}$/,
    "en-RW": /^(\+?250|0)?[7]\d{8}$/,
    "en-SG": /^(\+65)?[3689]\d{7}$/,
    "en-SL": /^(\+?232|0)\d{8}$/,
    "en-TZ": /^(\+?255|0)?[67]\d{8}$/,
    "en-UG": /^(\+?256|0)?[7]\d{8}$/,
    "en-US": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
    "en-ZA": /^(\+?27|0)\d{9}$/,
    "en-ZM": /^(\+?26)?0[79][567]\d{7}$/,
    "en-ZW": /^(\+263)[0-9]{9}$/,
    "en-BW": /^(\+?267)?(7[1-8]{1})\d{6}$/,
    "es-AR": /^\+?549(11|[2368]\d)\d{8}$/,
    "es-BO": /^(\+?591)?(6|7)\d{7}$/,
    "es-CO": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
    "es-CL": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
    "es-CR": /^(\+506)?[2-8]\d{7}$/,
    "es-CU": /^(\+53|0053)?5\d{7}$/,
    "es-DO": /^(\+?1)?8[024]9\d{7}$/,
    "es-HN": /^(\+?504)?[9|8|3|2]\d{7}$/,
    "es-EC": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
    "es-ES": /^(\+?34)?[6|7]\d{8}$/,
    "es-GT": /^(\+?502)?[2|6|7]\d{7}$/,
    "es-PE": /^(\+?51)?9\d{8}$/,
    "es-MX": /^(\+?52)?(1|01)?\d{10,11}$/,
    "es-NI": /^(\+?505)\d{7,8}$/,
    "es-PA": /^(\+?507)\d{7,8}$/,
    "es-PY": /^(\+?595|0)9[9876]\d{7}$/,
    "es-SV": /^(\+?503)?[67]\d{7}$/,
    "es-UY": /^(\+598|0)9[1-9][\d]{6}$/,
    "es-VE": /^(\+?58)?(2|4)\d{9}$/,
    "et-EE": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
    "fa-IR": /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
    "fi-FI": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
    "fj-FJ": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
    "fo-FO": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "fr-BF": /^(\+226|0)[67]\d{7}$/,
    "fr-BJ": /^(\+229)\d{8}$/,
    "fr-CD": /^(\+?243|0)?(8|9)\d{8}$/,
    "fr-CM": /^(\+?237)6[0-9]{8}$/,
    "fr-FR": /^(\+?33|0)[67]\d{8}$/,
    "fr-GF": /^(\+?594|0|00594)[67]\d{8}$/,
    "fr-GP": /^(\+?590|0|00590)[67]\d{8}$/,
    "fr-MQ": /^(\+?596|0|00596)[67]\d{8}$/,
    "fr-PF": /^(\+?689)?8[789]\d{6}$/,
    "fr-RE": /^(\+?262|0|00262)[67]\d{8}$/,
    "fr-WF": /^(\+681)?\d{6}$/,
    "he-IL": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
    "hu-HU": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
    "id-ID": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
    "ir-IR": /^(\+98|0)?9\d{9}$/,
    "it-IT": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
    "it-SM": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
    "ja-JP": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
    "ka-GE": /^(\+?995)?(79\d{7}|5\d{8})$/,
    "kk-KZ": /^(\+?7|8)?7\d{9}$/,
    "kl-GL": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "ko-KR": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
    "ky-KG": /^(\+996\s?)?(22[0-9]|50[0-9]|55[0-9]|70[0-9]|75[0-9]|77[0-9]|880|990|995|996|997|998)\s?\d{3}\s?\d{3}$/,
    "lt-LT": /^(\+370|8)\d{8}$/,
    "lv-LV": /^(\+?371)2\d{7}$/,
    "mg-MG": /^((\+?261|0)(2|3)\d)?\d{7}$/,
    "mn-MN": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
    "my-MM": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
    "ms-MY": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
    "mz-MZ": /^(\+?258)?8[234567]\d{7}$/,
    "nb-NO": /^(\+?47)?[49]\d{7}$/,
    "ne-NP": /^(\+?977)?9[78]\d{8}$/,
    "nl-BE": /^(\+?32|0)4\d{8}$/,
    "nl-NL": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
    "nl-AW": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
    "nn-NO": /^(\+?47)?[49]\d{7}$/,
    "pl-PL": /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
    "pt-BR": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
    "pt-PT": /^(\+?351)?9[1236]\d{7}$/,
    "pt-AO": /^(\+244)\d{9}$/,
    "ro-MD": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
    "ro-RO": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
    "ru-RU": /^(\+?7|8)?9\d{9}$/,
    "si-LK": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
    "sl-SI": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
    "sk-SK": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "so-SO": /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
    "sq-AL": /^(\+355|0)6[2-9]\d{7}$/,
    "sr-RS": /^(\+3816|06)[- \d]{5,9}$/,
    "sv-SE": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
    "tg-TJ": /^(\+?992)?[5][5]\d{7}$/,
    "th-TH": /^(\+66|66|0)\d{9}$/,
    "tr-TR": /^(\+?90|0)?5\d{9}$/,
    "tk-TM": /^(\+993|993|8)\d{8}$/,
    "uk-UA": /^(\+?38)?0(50|6[36-8]|7[357]|9[1-9])\d{7}$/,
    "uz-UZ": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
    "vi-VN": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
    "zh-CN": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
    "zh-TW": /^(\+?886\-?|0)?9\d{8}$/,
    "dz-BT": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
    "ar-YE": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
    "ar-EH": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
    "fa-AF": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/,
    "mk-MK": /^(\+?389|0)?((?:2[2-9]\d{6}|(?:3[1-4]|4[2-8])\d{6}|500\d{5}|5[2-9]\d{6}|7[0-9][2-9]\d{5}|8[1-9]\d{6}|800\d{5}|8009\d{4}))$/
  };
  r["en-CA"] = r["en-US"], r["fr-CA"] = r["en-CA"], r["fr-BE"] = r["nl-BE"], r["zh-HK"] = r["en-HK"], r["zh-MO"] = r["en-MO"], r["ga-IE"] = r["en-IE"], r["fr-CH"] = r["de-CH"], r["it-CH"] = r["fr-CH"];
  function n(d, a, i) {
    if ((0, t.default)(d), i && i.strictMode && !d.startsWith("+"))
      return !1;
    if (Array.isArray(a))
      return a.some(function(s) {
        if (r.hasOwnProperty(s)) {
          var c = r[s];
          if (c.test(d))
            return !0;
        }
        return !1;
      });
    if (a in r)
      return r[a].test(d);
    if (!a || a === "any") {
      for (var u in r)
        if (r.hasOwnProperty(u)) {
          var o = r[u];
          if (o.test(d))
            return !0;
        }
      return !1;
    }
    throw new Error("Invalid locale '".concat(a, "'"));
  }
  return Be.locales = Object.keys(r), Be;
}
var wf = /* @__PURE__ */ O1();
const Bf = /* @__PURE__ */ B(wf);
var x1 = "isMobilePhone";
function D1(t, e, r) {
  return typeof t == "string" && Bf(t, e, r);
}
function Uf(t, e, r) {
  return N({
    name: x1,
    constraints: [t, e],
    validator: {
      validate: function(n, d) {
        return D1(n, d == null ? void 0 : d.constraints[0], d == null ? void 0 : d.constraints[1]);
      },
      defaultMessage: C(function(n) {
        return n + "$property must be a phone number";
      }, r)
    }
  }, r);
}
var Ue = {}, _d;
function l0() {
  if (_d) return Ue;
  _d = 1, Object.defineProperty(Ue, "__esModule", {
    value: !0
  }), Ue.CountryCodes = void 0, Ue.default = n;
  var t = e(/* @__PURE__ */ D());
  function e(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = /* @__PURE__ */ new Set(["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW"]);
  function n(d) {
    return (0, t.default)(d), r.has(d.toUpperCase());
  }
  return Ue.CountryCodes = r, Ue;
}
var qf = /* @__PURE__ */ l0();
const Zf = /* @__PURE__ */ B(qf);
var T1 = "isISO31661Alpha2";
function L1(t) {
  return typeof t == "string" && Zf(t);
}
function kf(t) {
  return N({
    name: T1,
    validator: {
      validate: function(e, r) {
        return L1(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a valid ISO31661 Alpha2 code";
      }, t)
    }
  }, t);
}
var zt = { exports: {} }, Id;
function F1() {
  return Id || (Id = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /* @__PURE__ */ new Set(["AFG", "ALA", "ALB", "DZA", "ASM", "AND", "AGO", "AIA", "ATA", "ATG", "ARG", "ARM", "ABW", "AUS", "AUT", "AZE", "BHS", "BHR", "BGD", "BRB", "BLR", "BEL", "BLZ", "BEN", "BMU", "BTN", "BOL", "BES", "BIH", "BWA", "BVT", "BRA", "IOT", "BRN", "BGR", "BFA", "BDI", "KHM", "CMR", "CAN", "CPV", "CYM", "CAF", "TCD", "CHL", "CHN", "CXR", "CCK", "COL", "COM", "COG", "COD", "COK", "CRI", "CIV", "HRV", "CUB", "CUW", "CYP", "CZE", "DNK", "DJI", "DMA", "DOM", "ECU", "EGY", "SLV", "GNQ", "ERI", "EST", "ETH", "FLK", "FRO", "FJI", "FIN", "FRA", "GUF", "PYF", "ATF", "GAB", "GMB", "GEO", "DEU", "GHA", "GIB", "GRC", "GRL", "GRD", "GLP", "GUM", "GTM", "GGY", "GIN", "GNB", "GUY", "HTI", "HMD", "VAT", "HND", "HKG", "HUN", "ISL", "IND", "IDN", "IRN", "IRQ", "IRL", "IMN", "ISR", "ITA", "JAM", "JPN", "JEY", "JOR", "KAZ", "KEN", "KIR", "PRK", "KOR", "KWT", "KGZ", "LAO", "LVA", "LBN", "LSO", "LBR", "LBY", "LIE", "LTU", "LUX", "MAC", "MKD", "MDG", "MWI", "MYS", "MDV", "MLI", "MLT", "MHL", "MTQ", "MRT", "MUS", "MYT", "MEX", "FSM", "MDA", "MCO", "MNG", "MNE", "MSR", "MAR", "MOZ", "MMR", "NAM", "NRU", "NPL", "NLD", "NCL", "NZL", "NIC", "NER", "NGA", "NIU", "NFK", "MNP", "NOR", "OMN", "PAK", "PLW", "PSE", "PAN", "PNG", "PRY", "PER", "PHL", "PCN", "POL", "PRT", "PRI", "QAT", "REU", "ROU", "RUS", "RWA", "BLM", "SHN", "KNA", "LCA", "MAF", "SPM", "VCT", "WSM", "SMR", "STP", "SAU", "SEN", "SRB", "SYC", "SLE", "SGP", "SXM", "SVK", "SVN", "SLB", "SOM", "ZAF", "SGS", "SSD", "ESP", "LKA", "SDN", "SUR", "SJM", "SWZ", "SWE", "CHE", "SYR", "TWN", "TJK", "TZA", "THA", "TLS", "TGO", "TKL", "TON", "TTO", "TUN", "TUR", "TKM", "TCA", "TUV", "UGA", "UKR", "ARE", "GBR", "USA", "UMI", "URY", "UZB", "VUT", "VEN", "VNM", "VGB", "VIR", "WLF", "ESH", "YEM", "ZMB", "ZWE"]);
    function a(i) {
      return (0, r.default)(i), d.has(i.toUpperCase());
    }
    t.exports = e.default, t.exports.default = e.default;
  }(zt, zt.exports)), zt.exports;
}
var Hf = /* @__PURE__ */ F1();
const Gf = /* @__PURE__ */ B(Hf);
var w1 = "isISO31661Alpha3";
function B1(t) {
  return typeof t == "string" && Gf(t);
}
function jf(t) {
  return N({
    name: w1,
    validator: {
      validate: function(e, r) {
        return B1(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a valid ISO31661 Alpha3 code";
      }, t)
    }
  }, t);
}
var Jt = { exports: {} }, Ad;
function U1() {
  return Ad || (Ad = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ u0());
    function d(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function a(i) {
      return (0, r.default)(i), (0, n.default)(i) && i.length === 24;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Jt, Jt.exports)), Jt.exports;
}
var Vf = /* @__PURE__ */ U1();
const Wf = /* @__PURE__ */ B(Vf);
var q1 = "isMongoId";
function Z1(t) {
  return typeof t == "string" && Wf(t);
}
function Kf(t) {
  return N({
    name: q1,
    validator: {
      validate: function(e, r) {
        return Z1(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a mongodb id";
      }, t)
    }
  }, t);
}
var Xt = { exports: {} }, Sd;
function k1() {
  return Sd || (Sd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /[^\x00-\x7F]/;
    function a(i) {
      return (0, r.default)(i), d.test(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Xt, Xt.exports)), Xt.exports;
}
var Yf = /* @__PURE__ */ k1();
const zf = /* @__PURE__ */ B(Yf);
var H1 = "isMultibyte";
function G1(t) {
  return typeof t == "string" && zf(t);
}
function Jf(t) {
  return N({
    name: H1,
    validator: {
      validate: function(e, r) {
        return G1(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must contain one or more multibyte chars";
      }, t)
    }
  }, t);
}
var Qt = { exports: {} }, bd;
function j1() {
  return bd || (bd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
    function a(i) {
      return (0, r.default)(i), d.test(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Qt, Qt.exports)), Qt.exports;
}
var Xf = /* @__PURE__ */ j1();
const Qf = /* @__PURE__ */ B(Xf);
var V1 = "isSurrogatePair";
function W1(t) {
  return typeof t == "string" && Qf(t);
}
function e3(t) {
  return N({
    name: V1,
    validator: {
      validate: function(e, r) {
        return W1(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must contain any surrogate pairs chars";
      }, t)
    }
  }, t);
}
var er = { exports: {} }, Md;
function K1() {
  return Md || (Md = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = h;
    var r = u(/* @__PURE__ */ D()), n = u(/* @__PURE__ */ Hu()), d = u(/* @__PURE__ */ gn()), a = u(/* @__PURE__ */ st()), i = u(/* @__PURE__ */ ee());
    function u(g) {
      return g && g.__esModule ? g : { default: g };
    }
    function o(g, A) {
      return _(g) || l(g, A) || c(g, A) || s();
    }
    function s() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function c(g, A) {
      if (g) {
        if (typeof g == "string") return f(g, A);
        var R = {}.toString.call(g).slice(8, -1);
        return R === "Object" && g.constructor && (R = g.constructor.name), R === "Map" || R === "Set" ? Array.from(g) : R === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(R) ? f(g, A) : void 0;
      }
    }
    function f(g, A) {
      (A == null || A > g.length) && (A = g.length);
      for (var R = 0, y = Array(A); R < A; R++) y[R] = g[R];
      return y;
    }
    function l(g, A) {
      var R = g == null ? null : typeof Symbol < "u" && g[Symbol.iterator] || g["@@iterator"];
      if (R != null) {
        var y, S, O, P, b = [], I = !0, E = !1;
        try {
          if (O = (R = R.call(g)).next, A !== 0) for (; !(I = (y = O.call(R)).done) && (b.push(y.value), b.length !== A); I = !0) ;
        } catch (T) {
          E = !0, S = T;
        } finally {
          try {
            if (!I && R.return != null && (P = R.return(), Object(P) !== P)) return;
          } finally {
            if (E) throw S;
          }
        }
        return b;
      }
    }
    function _(g) {
      if (Array.isArray(g)) return g;
    }
    var p = {
      protocols: ["http", "https", "ftp"],
      require_tld: !0,
      require_protocol: !1,
      require_host: !0,
      require_port: !1,
      require_valid_protocol: !0,
      allow_underscores: !1,
      allow_trailing_dot: !1,
      allow_protocol_relative_urls: !1,
      allow_fragments: !0,
      allow_query_components: !0,
      validate_length: !0,
      max_allowed_length: 2084
    }, $ = /^\[([^\]]+)\](?::([0-9]+))?$/;
    function h(g, A) {
      if ((0, r.default)(g), !g || /[\s<>]/.test(g) || g.indexOf("mailto:") === 0 || (A = (0, i.default)(A, p), A.validate_length && g.length > A.max_allowed_length) || !A.allow_fragments && g.includes("#") || !A.allow_query_components && (g.includes("?") || g.includes("&")))
        return !1;
      var R, y, S, O, P, b, I, E;
      if (I = g.split("#"), g = I.shift(), I = g.split("?"), g = I.shift(), I = g.split("://"), I.length > 1) {
        if (R = I.shift().toLowerCase(), A.require_valid_protocol && A.protocols.indexOf(R) === -1)
          return !1;
      } else {
        if (A.require_protocol)
          return !1;
        if (g.slice(0, 2) === "//") {
          if (!A.allow_protocol_relative_urls)
            return !1;
          I[0] = g.slice(2);
        }
      }
      if (g = I.join("://"), g === "")
        return !1;
      if (I = g.split("/"), g = I.shift(), g === "" && !A.require_host)
        return !0;
      if (I = g.split("@"), I.length > 1) {
        if (A.disallow_auth || I[0] === "" || (y = I.shift(), y.indexOf(":") >= 0 && y.split(":").length > 2))
          return !1;
        var T = y.split(":"), U = o(T, 2), Z = U[0], H = U[1];
        if (Z === "" && H === "")
          return !1;
      }
      O = I.join("@"), b = null, E = null;
      var W = O.match($);
      if (W ? (S = "", E = W[1], b = W[2] || null) : (I = O.split(":"), S = I.shift(), I.length && (b = I.join(":"))), b !== null && b.length > 0) {
        if (P = parseInt(b, 10), !/^[0-9]+$/.test(b) || P <= 0 || P > 65535)
          return !1;
      } else if (A.require_port)
        return !1;
      return A.host_whitelist ? (0, n.default)(S, A.host_whitelist) : S === "" && !A.require_host ? !0 : !(!(0, a.default)(S) && !(0, d.default)(S, A) && (!E || !(0, a.default)(E, 6)) || (S = S || E, A.host_blacklist && (0, n.default)(S, A.host_blacklist)));
    }
    t.exports = e.default, t.exports.default = e.default;
  }(er, er.exports)), er.exports;
}
var t3 = /* @__PURE__ */ K1();
const r3 = /* @__PURE__ */ B(t3);
var Y1 = "isUrl";
function z1(t, e) {
  return typeof t == "string" && r3(t, e);
}
function n3(t, e) {
  return N({
    name: Y1,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return z1(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a URL address";
      }, e)
    }
  }, e);
}
var tr = { exports: {} }, Ed;
function J1() {
  return Ed || (Ed = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = {
      1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      6: /^[0-9A-F]{8}-[0-9A-F]{4}-6[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      7: /^[0-9A-F]{8}-[0-9A-F]{4}-7[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      8: /^[0-9A-F]{8}-[0-9A-F]{4}-8[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      nil: /^00000000-0000-0000-0000-000000000000$/i,
      max: /^ffffffff-ffff-ffff-ffff-ffffffffffff$/i,
      // From https://github.com/uuidjs/uuid/blob/main/src/regex.js
      all: /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i
    };
    function a(i, u) {
      return (0, r.default)(i), u == null && (u = "all"), u in d ? d[u].test(i) : !1;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(tr, tr.exports)), tr.exports;
}
var d3 = /* @__PURE__ */ J1();
const a3 = /* @__PURE__ */ B(d3);
var X1 = "isUuid";
function Q1(t, e) {
  return typeof t == "string" && a3(t, e);
}
function i3(t, e) {
  return N({
    name: X1,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Q1(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a UUID";
      }, e)
    }
  }, e);
}
var eo = "IsFirebasePushId";
function to(t) {
  var e = /^[a-zA-Z0-9_-]*$/;
  return typeof t == "string" && t.length === 20 && e.test(t);
}
function u3(t) {
  return N({
    name: eo,
    validator: {
      validate: function(e, r) {
        return to(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a Firebase Push Id";
      }, t)
    }
  }, t);
}
var rr = { exports: {} }, Rd;
function ro() {
  return Rd || (Rd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a), a === a.toUpperCase();
    }
    t.exports = e.default, t.exports.default = e.default;
  }(rr, rr.exports)), rr.exports;
}
var o3 = /* @__PURE__ */ ro();
const s3 = /* @__PURE__ */ B(o3);
var no = "isUppercase";
function ao(t) {
  return typeof t == "string" && s3(t);
}
function l3(t) {
  return N({
    name: no,
    validator: {
      validate: function(e, r) {
        return ao(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be uppercase";
      }, t)
    }
  }, t);
}
var nr = { exports: {} }, Pd;
function io() {
  return Pd || (Pd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function d(i) {
      "@babel/helpers - typeof";
      return d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
        return typeof u;
      } : function(u) {
        return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
      }, d(i);
    }
    function a(i, u) {
      (0, r.default)(i);
      var o, s;
      d(u) === "object" ? (o = u.min || 0, s = u.max) : (o = arguments[1] || 0, s = arguments[2]);
      var c = i.match(/(\uFE0F|\uFE0E)/g) || [], f = i.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [], l = i.length - c.length - f.length, _ = l >= o && (typeof s > "u" || l <= s);
      return _ && Array.isArray(u == null ? void 0 : u.discreteLengths) ? u.discreteLengths.some(function(p) {
        return p === l;
      }) : _;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(nr, nr.exports)), nr.exports;
}
var f3 = /* @__PURE__ */ io();
const f0 = /* @__PURE__ */ B(f3);
var uo = "isLength";
function oo(t, e, r) {
  return typeof t == "string" && f0(t, { min: e, max: r });
}
function c3(t, e, r) {
  return N({
    name: uo,
    constraints: [t, e],
    validator: {
      validate: function(n, d) {
        return oo(n, d == null ? void 0 : d.constraints[0], d == null ? void 0 : d.constraints[1]);
      },
      defaultMessage: C(function(n, d) {
        var a = (d == null ? void 0 : d.constraints[0]) !== null && (d == null ? void 0 : d.constraints[0]) !== void 0, i = (d == null ? void 0 : d.constraints[1]) !== null && (d == null ? void 0 : d.constraints[1]) !== void 0;
        return a && (!d.value || d.value.length < (d == null ? void 0 : d.constraints[0])) ? n + "$property must be longer than or equal to $constraint1 characters" : i && d.value.length > (d == null ? void 0 : d.constraints[1]) ? n + "$property must be shorter than or equal to $constraint2 characters" : n + "$property must be longer than or equal to $constraint1 and shorter than or equal to $constraint2 characters";
      }, r)
    }
  }, r);
}
var so = "maxLength";
function lo(t, e) {
  return typeof t == "string" && f0(t, { min: 0, max: e });
}
function $3(t, e) {
  return N({
    name: so,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return lo(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be shorter than or equal to $constraint1 characters";
      }, e)
    }
  }, e);
}
var fo = "minLength";
function co(t, e) {
  return typeof t == "string" && f0(t, { min: e });
}
function v3(t, e) {
  return N({
    name: fo,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return co(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be longer than or equal to $constraint1 characters";
      }, e)
    }
  }, e);
}
var dr = { exports: {} }, Cd;
function $o() {
  return Cd || (Cd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, i, u) {
      return (0, r.default)(a), Object.prototype.toString.call(i) !== "[object RegExp]" && (i = new RegExp(i, u)), !!a.match(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(dr, dr.exports)), dr.exports;
}
var p3 = /* @__PURE__ */ $o();
const vo = /* @__PURE__ */ B(p3);
var po = "matches";
function ho(t, e, r) {
  return typeof t == "string" && vo(t, e, r);
}
function h3(t, e, r) {
  var n;
  return e && e instanceof Object && !r ? r = e : n = e, N({
    name: po,
    constraints: [t, n],
    validator: {
      validate: function(d, a) {
        return ho(d, a == null ? void 0 : a.constraints[0], a == null ? void 0 : a.constraints[1]);
      },
      defaultMessage: C(function(d, a) {
        return d + "$property must match $constraint1 regular expression";
      }, r)
    }
  }, r);
}
const g3 = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [["6[2-467]\\d{3}", [5]], ["4\\d{4}", [5]], 0, 0, 0, 0, ["(?:0[1-9]|[1589]\\d)\\d{4}", [6]]]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [["[78]\\d{5}", [6]], ["690\\d{6}|[356]\\d{5}", [6, 9]], ["180[02]\\d{4}", [8]], ["[19]\\d{5}", [6]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[2-4679][2-8]\\d{6}", [8]], ["5[024-68]\\d{7}", [9]], ["400\\d{6}|800\\d{2,9}"], ["900[02]\\d{5}", [9]], 0, 0, ["600[25]\\d{5}", [9]], 0, 0, ["700[05]\\d{5}", [9]]]], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"], ["7\\d{8}"]]], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"], ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["26840[69]\\d{4}"], ["26848[01]\\d{4}"]]], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [["264(?:292|4(?:6[12]|9[78]))\\d{4}"], ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["264724\\d{4}"]]], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", [8]], ["6(?:[78][2-9]|9\\d)\\d{6}", [9]], ["800\\d{4}", [7]], ["900[1-9]\\d\\d", [6]], ["700[2-9]\\d{4}", [8]], 0, 0, 0, 0, ["808[1-9]\\d\\d", [6]]]], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"], ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"], ["800\\d{5}"], ["90[016]\\d{5}"], 0, 0, 0, 0, ["60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}"], ["80[1-4]\\d{5}"]]], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"], ["9[1-79]\\d{7}"]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [["3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68])))\\d{6}|(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", [10]], ["93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"], ["800\\d{7,8}"], ["60[04579]\\d{7}", [10]], 0, 0, ["810\\d{7}", [10]]]], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [["6846(?:22|33|44|55|77|88|9[19])\\d{4}"], ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:11\\d|[2-9]\\d{3,11})|(?:316|463)\\d{3,10}|648[34]\\d{3,9}|(?:51|66|73)2\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-7]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"], ["6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}", [7, 8, 9, 10, 11, 12, 13]], ["800\\d{6,10}", [9, 10, 11, 12, 13]], ["(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", [9, 10, 11, 12, 13]], 0, 0, 0, 0, ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]], ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]]], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [["5(?:2\\d|8[1-9])\\d{4}"], ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"], ["800\\d{4}"], ["900\\d{4}"], 0, 0, 0, 0, ["(?:28\\d|501)\\d{4}"]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [["18[1-8]\\d{3,6}", [6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}"], ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"], ["88\\d{7}"], ["900200\\d{3}"]]], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", [8]], ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"], ["8[08]\\d{6}", [8]], ["9[0246]\\d{6}", [8]], 0, 0, ["703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", [8]], 0, 0, ["8[12]\\d{6}", [8]]]], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [["246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"], ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:246976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}"], 0, ["24631\\d{5}"]]], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"], ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]], ["80[03]\\d{7}", [10]], 0, 0, 0, 0, 0, ["96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", [10]]]], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]], ["4[5-9]\\d{7}", [9]], ["800[1-9]\\d{4}", [8]], ["(?:70(?:2[0-57]|3[04-7]|44|6[04-69]|7[0579])|90\\d\\d)\\d{4}", [8]], 0, 0, ["78(?:0[578]|1[014-8]|2[25]|3[15-8]|48|5[05]|60|7[06-8]|9\\d)\\d{4}", [8]], 0, 0, ["7879\\d{4}", [8]]]], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"], ["(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}"]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]], ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]], ["(?:00800\\d\\d|800)\\d{5}", [8, 12]], ["90\\d{6}", [8]], 0, 0, 0, 0, 0, ["700\\d{5}", [8]]]], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}"], ["(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}"], ["8[02369]\\d{6}"], ["(?:87|9[0-8])\\d{6}"], 0, 0, 0, 0, 0, ["84\\d{6}"]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [["(?:22|31)\\d{6}"], ["(?:29|[67][125-9])\\d{6}"]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]], 0, 0, 0, 0, 0, 0, [["2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}"], ["(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}"], 0, 0, 0, 0, ["81\\d{6}", [8]], 0, ["857[58]\\d{4}", [8]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"], ["441(?:[2378]\\d|5[0-39]|9[02])\\d{5}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"], ["(?:22[89]|[78]\\d\\d)\\d{4}"], 0, 0, 0, 0, 0, 0, ["5[34]\\d{5}"]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [["(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", [8]], ["[67]\\d{7}", [8]], ["8001[07]\\d{4}", [9]], 0, 0, 0, 0, 0, ["50\\d{6}", [8]]]], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"], ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", [10]], ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]], ["800\\d{6,7}", [9, 10]], ["300\\d{6}|[59]00\\d{6,7}", [9, 10]], 0, 0, 0, 0, 0, ["(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", [8, 10]]]], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"], ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}"], ["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["242225\\d{4}"]]], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", [7]], ["(?:1[67]|77)\\d{6}", [8]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}", [7]], ["(?:321|7[1-8]\\d)\\d{5}", [8]], ["(?:0800|800\\d)\\d{6}", [10]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}", [8]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [["(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", [9]], ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]], ["800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"], ["(?:810|902)\\d{7}", [10]], 0, 0, 0, 0, ["249\\d{6}", [9]]], "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", [7]], ["6[0-35-7]\\d{5}", [7]], ["0800\\d{7}", [11]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}"], ["88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", [7, 9]]]], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [["2[12]\\d{6}"], ["7[024-7]\\d{6}"], 0, ["8776\\d{4}"]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [["222[1-589]\\d{5}"], ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"], 0, ["80[0-2]\\d{6}"]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", [9]], ["(?:6[89]|7[235-9])\\d{7}", [9]], ["800\\d{6}", [9]], ["90[016]\\d{6}", [9]], ["878\\d{6}", [9]], ["860\\d{9}", [12]], ["5[18]\\d{7}", [9]], ["74[0248]\\d{6}", [9]], 0, ["84[0248]\\d{6}", [9]]]], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [["2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"], ["0[157]\\d{8}"]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[13-7]|4[1-5])\\d{3}"], ["[578]\\d{4}"]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", [9]], ["", [9]], ["(?:123|8)00\\d{6}", [9, 11]], 0, 0, 0, 0, 0, ["44\\d{7}", [9]], ["600\\d{7,8}", [10, 11]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [["2(?:22|33)\\d{6}", [9]], ["(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", [9]], ["88\\d{6,7}"]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [["(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", [7, 8, 9, 10, 11]], ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]], ["(?:(?:10|21)8|8)00\\d{7}", [10, 12]], ["16[08]\\d{5}", [8]], 0, 0, 0, 0, 0, ["10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", [7, 8, 9, 10, 11]]], "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?", 0, 0, 0, [["601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[124-7][2-9]|8[1-9]))\\d{6}", [8, 10]], ["333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", [10]], ["1800\\d{7}", [11]], ["(?:19(?:0[01]|4[78])|901)\\d{7}", [10, 11]]]], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [["210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", [8]], ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]], ["800\\d{7}", [10]], ["90[059]\\d{7}", [10]], 0, 0, 0, 0, ["(?:210[0-6]|4\\d{3}|5100)\\d{4}", [8]]]], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"], ["(?:5\\d|6[2-4])\\d{6}", [8]], ["800\\d{7}", [10]], 0, 0, 0, 0, 0, 0, ["807\\d{7}", [10]]]], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"], ["(?:36|5[1-389]|9\\d)\\d{5}"], ["800\\d{4}"], 0, 0, 0, 0, 0, ["(?:3[3-5]|4[356])\\d{5}"]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"], ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"], 0, 0, 0, 0, 0, ["955\\d{5}", [8]], 0, ["60[0-2]\\d{4}", [7]]]], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}"], ["9(?:10|[4-79]\\d)\\d{5}"], ["800\\d{5}"], ["90[09]\\d{5}"], ["700\\d{5}"], 0, ["(?:50|77)\\d{6}"], 0, 0, ["80[1-9]\\d{5}"]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", [9]], ["(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[0-2]|[2379]\\d\\d))\\d{5}", [9]], ["800\\d{6}", [9]], ["9(?:0[05689]|76)\\d{6}", [9]], ["70[01]\\d{6}", [9]], ["9(?:3\\d{9}|6\\d{7,10})"], ["9(?:5\\d|7[2-4])\\d{6}", [9]], 0, ["9[17]0\\d{6}", [9]], ["8[134]\\d{7}", [9]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [["32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]], ["1(?:(?:5(?:[0-25-9]\\d\\d|310)|76\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}", [10, 11]], ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]], ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]], ["700\\d{8}", [11]], ["1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}", [12, 13]], ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]], ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], 0, ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]]], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [["2(?:1[2-5]|7[45])\\d{5}"], ["77\\d{6}"]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}"], ["(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}"], ["80\\d{6}"], ["90\\d{6}"]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"], ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"], ["8[024]9[2-9]\\d{6}"], ["8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}"], ["(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["80[3-689]1\\d{5}", [9]], 0, 0, 0, 0, ["98[23]\\d{6}", [9]], ["80[12]1\\d{5}", [9]]]], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["[2-7][2-7]\\d{6}", [8]], ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]], ["1800\\d{7}|1[78]00\\d{6}", [10, 11]], 0, 0, 0, 0, 0, ["[2-7]890\\d{4}", [8]]]], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]], ["(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]], ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"], ["(?:40\\d\\d|900)\\d{4}", [7, 8]], ["70[0-2]\\d{5}", [8]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", [8, 9]], ["1[0-25]\\d{8}", [10]], ["800\\d{7}", [10]], ["900\\d{7}", [10]]]], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"], ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"], ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"], ["[89]00\\d{6}"], ["80[367]\\d{6}"], ["70\\d{7}"], 0, ["51\\d{7}"], 0, 0, ["90[12]\\d{6}"]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"], ["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [["1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}", [5, 6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [["603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", [7]], ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]], ["0800\\d{7}", [11]]], "00"], FK: ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [["[2-47]\\d{4}"], ["[56]\\d{4}"]]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"], ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [["(?:20|[34]\\d|8[19])\\d{4}"], ["(?:[27][1-9]|5\\d|9[16])\\d{4}"], ["80[257-9]\\d{3}"], ["90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"], 0, 0, 0, 0, ["(?:6[0-36]|88)\\d{4}"]]], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}"], ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"], ["80[0-5]\\d{6}"], ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"], 0, 0, ["80[6-9]\\d{6}"], 0, ["9\\d{8}"], ["8(?:1[01]|2[0156]|4[024]|84)\\d{6}"]]], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [["[01]1\\d{6}", [8]], ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[59]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"], ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"], ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["70[67]\\d{6}"]]], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}"], ["(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:396|76\\d)\\d|476[0-6])\\d{4}"]]], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", [9]], ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]], ["800\\d{5}", [8]]]], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [["2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}"], ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}"], ["[245]\\d{5}"], ["80\\d{4}"], 0, 0, 0, 0, 0, ["3[89]\\d{4}"]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"], ["(?:[23679]\\d|4[015]|5[0-489])\\d{5}"]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", [8]], ["6[0-356]\\d{7}", [9]], 0, 0, 0, 0, 0, 0, ["722\\d{6}", [9]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"], ["(?:222|55\\d)\\d{6}"], ["80\\d[1-9]\\d{5}"], ["90\\d[1-9]\\d{5}"]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", [10]], ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]], ["800\\d{7,9}"], ["90[19]\\d{7}", [10]], ["70\\d{8}", [10]], 0, ["5005000\\d{3}", [10]], 0, 0, ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["[267][2-9]\\d{6}", [8]], ["(?:[3-5]\\d\\d|80[0-4])\\d{5}", [8]], ["18[01]\\d{8}", [11]], ["19\\d{9}", [11]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671", [["671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [["443\\d{6}", [9]], ["9(?:5\\d|6[569]|77)\\d{6}", [9]], 0, 0, 0, 0, 0, 0, ["40\\d{5}", [7]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}"], ["(?:510|6\\d\\d|7(?:[0-5]\\d|6[01]))\\d{4}"], ["(?:289|8(?:00|6[28]|88|99))\\d{4}"], ["9008\\d{3}"], 0, 0, 0, 0, ["515\\d{4}"]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}", [8]], ["(?:4(?:44[0-35-9]|6(?:1[0-79]|4[0-57-9]|6[0-4])|7(?:[26][0-5]|4[0-28]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3]|78[0-5])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[015])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]], ["800\\d{6}", [9]], ["900(?:[0-24-9]\\d{7}|3\\d{1,4})", [5, 6, 7, 8, 11]], ["8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", [8]], 0, ["30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", [8]], ["7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", [8]]], "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", [8]], ["[37-9]\\d{7}", [8]], ["8002\\d{7}", [11]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]], ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}", [8, 9]], ["80\\d{5,7}"], ["6[01459]\\d{6}|6[01]\\d{5}", [7, 8]], ["7[45]\\d{6}", [8]], 0, ["62\\d{6,7}|72\\d{6}", [8, 9]]]], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2\\d|5[1-5]|81|9[149])\\d{5}"], ["(?:[34]\\d|55)\\d{6}"], ["8\\d{7}"], 0, 0, 0, 0, 0, ["9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]], ["(?:[257]0|3[01])\\d{7}", [9]], ["(?:[48]0\\d|680[29])\\d{5}"], ["9[01]\\d{6}", [8]], 0, 0, ["38\\d{7}", [9]], 0, ["21\\d{7}", [9]]]], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", [7, 8, 9, 10, 11]], ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]], ["00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], ["809\\d{7}", [10]], 0, 0, ["(?:1500|8071\\d{3})\\d{3}", [7, 10]], 0, 0, ["804\\d{7}", [10]]]], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"], ["8(?:22|[35-9]\\d)\\d{6}", [9]], ["1800\\d{6}", [10]], ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]], ["700\\d{6}", [9]], ["88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", [10]], ["818\\d{6}", [9]], 0, ["76\\d{7}", [9]], ["18[59]0\\d{6}", [10]]]], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [["153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", [8, 11, 12]], ["55(?:4(?:[01]0|5[0-2])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]], ["1(?:255|80[019]\\d{3})\\d{3}", [7, 10]], ["1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", [8, 10]], 0, ["151\\d{8,9}", [11, 12]], ["1599\\d{6}", [10]], 0, ["7(?:38(?:0\\d|5[0-3569]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", [9]], ["1700\\d{6}", [10]]]], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24", [["1624(?:230|[5-8]\\d\\d)\\d{3}"], ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"], ["808162\\d{4}"], ["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"], ["70\\d{8}"], 0, ["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"], 0, ["56\\d{8}"]]], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [["2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", [10]], ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]], ["000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"], ["186[12]\\d{9}", [13]], 0, 0, ["140\\d{7}", [10]], 0, 0, ["1860\\d{7}", [11]]]], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [["37\\d{5}"], ["38\\d{5}"]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", [8, 9]], ["7[3-9]\\d{8}", [10]]]], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", [6, 7, 10]], ["9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", [10]], 0, 0, 0, 0, ["96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", [4, 5]]]], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", [7]], ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"], ["80[0-8]\\d{4}", [7]], ["90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", [7]], 0, ["(?:689|8(?:7[18]|80)|95[48])\\d{4}", [7]], ["809\\d{4}", [7]], 0, ["49[0-24-79]\\d{4}", [7]]], "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [["8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"], ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}", [8]], ["7(?:[78][0-25-9]|9\\d)\\d{6}", [9]], ["80\\d{6}", [8]], ["9\\d{7}", [8]], ["70\\d{7}", [9]], 0, ["8(?:10|8\\d)\\d{5}", [8]], ["74(?:66|77)\\d{5}", [9]], 0, ["85\\d{6}", [8]]]], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", 0, 0, [["(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", [9]], ["[7-9]0[1-9]\\d{7}", [10]], ["00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"], ["990\\d{6}", [9]], ["60\\d{7}", [9]], 0, ["570\\d{6}", [9]], ["20\\d{8}", [10]], ["50[1-9]\\d{7}", [10]]]], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}", [7, 8, 9]], ["(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", [9]], ["800[02-8]\\d{5,6}", [9, 10]], ["900[02-9]\\d{5}", [9]]]], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", [9]], ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", [9]], ["800\\d{6,7}"]]], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", [8, 9]], ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]], ["1800(?:1\\d|2[019])\\d{4}", [10]], ["1900(?:1\\d|2[09])\\d{4}", [10]]]], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [["(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"], ["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}", [8]], 0, 0, 0, 0, 0, 0, ["30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", [8]]]], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [["7[4-7]\\d{5}"], ["[34]\\d{6}"], 0, ["8\\d{6}"]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [["869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"], ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"], ["19[1-3]\\d{7}", [10]]]], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [["(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", [5, 6, 8, 9, 10]], ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]], ["00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", [9, 11, 12, 13, 14]], ["60[2-9]\\d{6}", [9]], ["50\\d{8,9}", [10, 11]], 0, ["1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", [8]], ["15\\d{7,8}", [9, 10]], ["70\\d{8}", [10]]]], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", [8]], ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]], ["18\\d{5}", [7]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}"], ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:345976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", [["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", [10]], ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]], ["8(?:00|108\\d{3})\\d{7}"], ["809\\d{7}", [10]], ["808\\d{7}", [10]], 0, 0, 0, ["751\\d{7}", [10]]], "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", [8]], ["208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}", [10]], 0, 0, 0, 0, ["30[0135-9]\\d{6}", [9]]]], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [["7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"], ["793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"], 0, ["9[01]\\d{6}", [8]], 0, 0, 0, 0, 0, ["80\\d{6}", [8]]]], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"], ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [["(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", [7]], ["(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"], ["8002[28]\\d\\d|80(?:05\\d|9)\\d{4}"], ["90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", [7]], 0, ["697(?:42|56|[78]\\d)\\d{4}", [9]], ["870(?:28|87)\\d\\d", [7]]]], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"], ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"], 0, 0, 0, 0, ["1973\\d{5}"]]], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{7}", [8]], ["(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", [7, 9]], 0, ["332(?:02|[34]\\d)\\d{4}", [9]]]], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["[56]\\d{7}"], ["800[1256]\\d{4}"]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]", 0, 0, 0, [["(?:3[1478]|4[124-6]|52)\\d{6}"], ["6\\d{7}"], ["80[02]\\d{5}"], ["9(?:0[0239]|10)\\d{5}"], ["70[05]\\d{5}"], 0, ["70[67]\\d{5}"], 0, ["[89]01\\d{5}"], ["808\\d{5}"]]], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"], ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]], ["800\\d{5}", [8]], ["90[015]\\d{5}", [8]], 0, 0, 0, 0, ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]], ["801\\d{5}", [8]]]], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], 0, 0, 0, 0, 0, 0, [["6\\d{7}"], ["2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"], ["9[1-6]\\d{7}"]]], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:870|9[2-47-9]\\d)\\d{5}", [8]], ["4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"], ["(?:800|90\\d)\\d{5}", [8]]]], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"], ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"], ["800\\d{5}"], ["90[056]\\d{5}"], 0, 0, ["803\\d{5}"], 0, ["3[08]\\d{6}"], ["808\\d{5}"]]], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", [8]], ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]], ["80(?:[0-2578]|9\\d)\\d{5}"], ["9(?:4[1568]|5[178])\\d{5}", [8]], 0, 0, ["77[1-9]\\d{5}", [8]], 0, ["78[1-49]\\d{5}", [8]]]], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [["2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}"], ["3[2-47-9]\\d{7}"], 0, 0, 0, 0, 0, 0, ["22\\d{7}"]]], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [["(?:247|528|625)\\d{4}"], ["(?:(?:23|54)5|329|45[35-8])\\d{4}"], 0, 0, 0, 0, 0, 0, ["635\\d{4}"]]], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"], ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"], ["800\\d{5}"], ["5\\d{7}"], 0, 0, 0, 0, 0, ["8(?:0[1-9]|[1-9]\\d)\\d{5}"]]], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-59]))\\d{5}"], ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-59])\\d{6}"], ["80\\d{6}"]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|22|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", [6, 7, 8, 9]], ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]], ["80080(?:0[1-9]|2\\d)\\d{3}", [10]], 0, 0, 0, 0, 0, ["1333\\d{4}", [8]]]], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"], ["(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|72|8[015689]|9[013-9])\\d{6}", [8]], 0, 0, 0, 0, 0, 0, ["712[0-79]\\d{4}|7(?:1[013-9]|[5-9]\\d)\\d{5}", [8]]]], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [["(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", [8]], ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]], ["0800\\d{3}", [7]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}"], ["(?:69[67]\\d\\d|7091[0-3])\\d{4}"], ["80[0-5]\\d{6}"], ["8[129]\\d{7}"], 0, 0, 0, 0, ["9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}"]]], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [["(?:25[08]|35\\d|45[1-7])\\d{5}"], ["[2-4][0-46-9]\\d{6}"], ["800\\d{5}"]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [["6644(?:1[0-3]|91)\\d{4}"], ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [["20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}"], ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"], ["800(?:02|[3467]\\d)\\d{3}"], ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"], 0, 0, ["501\\d{5}"], ["7117\\d{4}"], ["3550\\d{4}"]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", [7, 8]], ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}", [8]], ["802\\d{7}|80[0-2]\\d{4}", [7, 10]], ["30\\d{5}", [7]], 0, 0, 0, 0, ["3(?:20|9\\d)\\d{4}", [7]]], "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", [7]], ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]], ["800\\d{7}", [10]], ["900\\d{7}", [10]], 0, 0, ["4(?:0[01]|50)\\d{4}", [7]]], "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[2-9]|2[12]\\d\\d)\\d{5}"], ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["8(?:00|88)\\d{7}"], ["900\\d{7}"], ["500\\d{7}"], 0, 0, 0, 0, ["300\\d{7}"]], "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", [8, 9]], ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]], ["1[378]00\\d{6}", [10]], ["1600\\d{6}", [10]], 0, 0, 0, 0, ["15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", [10]]]], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", [8]], ["8[2-79]\\d{7}", [9]], ["800\\d{6}", [9]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"], ["(?:60|8[1245])\\d{7}", [9]], ["80\\d{7}", [9]], ["8701\\d{5}", [9]], 0, 0, 0, 0, ["8(?:3\\d\\d|86)\\d{5}"]]], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"], ["(?:[579]\\d|8[0-79])\\d{4}"], ["050\\d{3}"], ["36\\d{4}"]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"], ["(?:23|7[0467]|[89]\\d)\\d{6}"], ["08\\d{6}"], ["09\\d{6}"]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [["(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"], ["(?:14|3[58])\\d{4}"]]], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])|38)\\d{6}", [8, 10]], ["(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", [10]], ["800\\d{7,11}", [10, 11, 12, 13, 14]], 0, 0, 0, ["700\\d{7,11}", [10, 11, 12, 13, 14]]]], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"], ["1800\\d{4}"]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", [9]], ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]], ["800\\d{4,7}", [7, 8, 9, 10]], ["90[069]\\d{4,7}", [7, 8, 9, 10]], 0, 0, ["140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", [5, 6, 9]], ["66\\d{7}", [9]], ["(?:85|91)\\d{7}", [9]]]], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", [8]], ["9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}", [10]], ["1(?:66001|800\\d\\d)\\d{5}", [11]]]], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["444\\d{4}"], ["(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}"]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["[47]\\d{3}", [4]], ["(?:[56]|888[1-9])\\d{3}"]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", [8]], ["2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", [8, 9, 10]], ["508\\d{6,7}|80\\d{6,8}", [8, 9, 10]], ["(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", [7, 8, 9, 10]], ["70\\d{7}", [9]], 0, ["8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}"]], "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [["2[1-6]\\d{6}", [8]], ["(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}", [8]], ["8007\\d{4,5}|(?:500|800[05])\\d{4}"], ["900\\d{5}", [8]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[07-9]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", [7]], ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]], ["800\\d{4,5}|(?:00800|800\\d)\\d{6}"], ["(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", [7]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", [8]], ["9\\d{8}", [9]], ["800\\d{5}", [8]], ["805\\d{5}", [8]], ["80[24]\\d{5}", [8]], 0, 0, 0, 0, ["801\\d{5}", [8]]], "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["4(?:0[4-689]|9[4-68])\\d{5}", [8]], ["8[7-9]\\d{6}", [8]], ["80[0-5]\\d{6}", [9]], 0, 0, 0, ["44\\d{4}", [6]], 0, ["499\\d{5}", [8]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", [7]], ["(?:7\\d|8[1-38])\\d{6}", [8]], ["180\\d{4}", [7]], 0, 0, 0, 0, ["27[01]\\d{4}", [7]], ["2(?:0[0-57]|7[568])\\d{4}", [7]]], "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", [6, 8, 9, 10]], ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]], ["1800\\d{7,9}", [11, 12, 13]]]], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", [9, 10]], ["3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", [10]], ["800\\d{5}(?:\\d{3})?", [8, 11]], ["900\\d{5}", [8]], ["122\\d{6}", [9]], 0, ["(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", [11, 12]]]], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", [7, 9]], ["2131[89]\\d{4}|21(?:1[013-5]|2\\d|3[2-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]], ["800\\d{6,7}", [9, 10]], ["70[01346-8]\\d{6}", [9]], 0, 0, ["804\\d{6}", [9]], ["64\\d{4,7}", [6, 7, 8, 9]], ["39\\d{7}", [9]], ["801\\d{6}", [9]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}"], ["(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}"], ["80[0-5]\\d{6}", [9]], ["8[129]\\d{7}", [9]]]], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [["(?:787|939)[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", [8]], ["5[69]\\d{7}", [9]], ["1800\\d{6}", [10]], 0, 0, 0, 0, 0, 0, ["1700\\d{6}", [10]]]], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}"], ["6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"], ["80[02]\\d{6}"], ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"], ["884[0-4689]\\d{5}"], ["600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}"], ["70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}"], ["6(?:222\\d|8988)\\d{4}"], ["30\\d{7}"], ["80(?:8\\d|9[1579])\\d{5}"]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"], ["(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}"]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}", [7, 8, 9]], ["9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", [9]], ["9800\\d{5,7}", [9, 10, 11]], 0, 0, 0, ["[2-9]0\\d{4,7}", [6, 7, 8, 9]], 0, ["8700[0-4]\\d{4}", [9]]]], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [["4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}", [8]], ["[35-7]\\d{7}", [8]], ["800\\d{4}|(?:0080[01]|800)\\d{6}", [7, 9, 11]], 0, 0, 0, 0, ["2[16]\\d{5}", [7]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"], ["(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", [9]], ["800\\d{6}", [9]], ["90[0136]\\d{6}", [9]], 0, 0, ["(?:37\\d|80[578])\\d{6}", [9]], 0, 0, ["801\\d{6}", [9]]], 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", [7, 8, 9, 10, 11, 12]], ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]], ["800\\d{3,9}"], ["(?:78\\d|90[0169])\\d{3,7}", [6, 7, 8, 9, 10]], 0, 0, ["7[06]\\d{4,10}"]]], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", [["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:06|2[23568]\\d)\\d{6}"], ["7[237-9]\\d{7}", [9]], ["800\\d{6}", [9]], ["900\\d{6}", [9]]]], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [["1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", [9]], ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}", [9]], ["800\\d{7}", [10]], ["925\\d{6}", [9]], 0, 0, ["811\\d{7}", [10]], 0, 0, ["920\\d{6}", [9]]]], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [["(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", [5]], ["48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"], ["1[38]\\d{3}", [5]], 0, 0, 0, 0, 0, ["5[12]\\d{3}", [5]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [["4[2-46]\\d{5}"], ["2[125-8]\\d{5}"], ["800[08]\\d{3}"], ["85\\d{5}"], 0, 0, 0, 0, ["971\\d{4}|(?:64|95)\\d{5}"]], "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:5\\d|8[35-7])\\d{6}"], ["(?:1[0-2]|9[0-3569])\\d{7}"]]], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", [7, 8, 9]], ["7[02369]\\d{7}", [9]], ["20\\d{4,7}", [6, 7, 8, 9]], ["649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]], ["75[1-8]\\d{6}", [9]], ["(?:25[245]|67[3-68])\\d{9}", [12]], ["10[1-8]\\d{6}", [9]], ["74[02-9]\\d{6}", [9]], 0, ["77[0-7]\\d{6}", [9]]]], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}", [8]], ["896[0-8]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-5])|9[0-8]\\d)\\d{5}", [8]], ["(?:18|8)00\\d{7}", [10, 11]], ["1900\\d{7}", [11]], 0, 0, ["7000\\d{7}", [11]], 0, ["(?:3[12]\\d|666)\\d{5}", [8]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [["2(?:[0-57-9]\\d|6[4-9])\\d\\d"], ["[56]\\d{4}", [5]], 0, 0, 0, 0, 0, 0, ["262\\d\\d", [5]]]], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]], ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]], ["80\\d{4,6}", [6, 7, 8]], ["89[1-3]\\d{2,5}|90\\d{4,6}"], 0, 0, 0, 0, ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]], "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [["79\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"], ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:00|[78]\\d)\\d{6}", [9]], 0, 0, ["96\\d{7}", [9]], ["9090\\d{3}", [7]], ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]], ["8[5-9]\\d{7}", [9]]]], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["22[2-4][2-9]\\d{4}"], ["(?:25|3[0-5]|66|7[1-9]|8[08]|9[09])\\d{6}"]]], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [["0549(?:8[0157-9]|9\\d)\\d{4}", [10]], ["6[16]\\d{6}", [8]], 0, ["7[178]\\d{6}", [8]], 0, 0, 0, 0, ["5[158]\\d{6}", [8]]]], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"], ["7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[356]|[4-7]\\d|8[35]))\\d{5}"], ["800\\d{6}"], ["88[4689]\\d{6}"], 0, 0, 0, 0, ["(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"], ["81[02468]\\d{6}"]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}", [6, 7]], ["(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"], ["(?:7[124-7]|8[1-9])\\d{5}", [7]], 0, 0, 0, 0, 0, 0, ["56\\d{4}", [6]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1[89]\\d{7}"], ["(?:12|9[1257-9])\\d{7}"]]], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["22\\d{5}"], ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}", [8]], ["[67]\\d{7}", [8]], ["800\\d{8}|80[01]\\d{4}", [7, 11]], ["900\\d{4}(?:\\d{4})?", [7, 11]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [["7215(?:4[2-8]|8[239]|9[056])\\d{4}"], ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"], ["(?:50|9[1-689])\\d{7}", [9]]]], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [["[23][2-5]\\d{6}", [8]], ["7[6-9]\\d{6}", [8]], ["0800\\d{4}", [8]], ["900\\d{6}", [9]], 0, 0, 0, 0, ["70\\d{6}", [8]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8", [["8\\d{3}"]]], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [["649(?:266|712|9(?:4\\d|50))\\d{4}"], ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["649(?:71[01]|966)\\d{4}"]]], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, [["22(?:[37-9]0|5[0-5]|6[89])\\d{4}"], ["(?:[69]\\d|77|8[56])\\d{6}"]], "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"], ["(?:7[0-29]|9[0-36-9])\\d{6}"]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", [8]], ["67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]], ["(?:001800\\d|1800)\\d{6}", [10, 13]], ["1900\\d{6}", [10]], 0, 0, 0, 0, ["6[08]\\d{7}", [9]]]], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"], ["(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|[34]0|5[05]|7[01578]|8[078])\\d{7}"]], "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [["(?:2[2-4]|[34]\\d)\\d{2,5}"], ["7[2-4]\\d{2,5}"]]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", [7]], ["7[2-8]\\d{6}", [8]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], ["70\\d{5}", [7]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"], ["(?:6\\d|71)\\d{6}"]], "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [["81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"], ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"], ["8010\\d{4}"], ["88\\d{6}"], 0, 0, 0, 0, 0, ["8[12]10\\d{4}"]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", [5]], ["(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]], ["0800\\d{3}", [7]], 0, 0, 0, 0, 0, ["55[0-37-9]\\d{4}", [7]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", [10]], ["561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]], ["8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", [10, 12, 13]], ["(?:8[89]8|900)\\d{7}", [10]], ["592(?:21[12]|461)\\d{4}", [10]], 0, ["444\\d{4}", [7]], ["512\\d{7}", [10]], ["850\\d{7}", [10]]]], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [["868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"], ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], ["868619\\d{4}"]]], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["2[02-9]\\d{3}", [5]], ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}", [8, 9]], ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]], ["80[0-79]\\d{6}|800\\d{5}", [8, 9]], ["20(?:[013-9]\\d\\d|2)\\d{4}", [7, 9]], ["99\\d{7}", [9]], 0, ["50[0-46-9]\\d{6}", [9]], 0, ["7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", [10, 11]]], 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[2-8]\\d{7}"], ["(?:6[125-9]|7[13-9])\\d{7}"], ["80[08]\\d{6}"], ["90\\d{7}"], 0, 0, 0, 0, ["41\\d{7}"], ["8(?:40|6[01])\\d{6}"]]], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", [9]], ["790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", [9]], ["800[1-8]\\d{5,6}"], ["900[239]\\d{5,6}"], 0, 0, 0, 0, ["89[1-579]\\d{6}", [9]]], "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"], ["72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-8]|9[089])\\d{6}"], ["800[1-3]\\d{5}"], ["90[1-3]\\d{6}"]]], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [["(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", [8]], ["9[1-9]\\d{6}", [8]], ["0004\\d{2,9}|(?:405|80[05])\\d{4}"], ["90[0-8]\\d{4}", [7]]], "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|[168]\\d\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}"], ["(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698", [["06698\\d{1,6}", [6, 7, 8, 9, 10, 11]], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"], ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["78451[0-2]\\d{4}"]]], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"], ["4(?:1[24-8]|2[246])\\d{7}"], ["800\\d{7}"], ["90[01]\\d{7}"], 0, 0, ["501\\d{7}"]]], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [["284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"], ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [["340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", [10]], ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]], ["1800\\d{4,6}|12(?:0[13]|28)\\d{4}", [8, 9, 10]], ["1900\\d{4,6}", [8, 9, 10]], 0, 0, ["(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", [7, 8]], 0, ["672\\d{6}", [9]]]], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", [5]], ["(?:[58]\\d|7[013-7])\\d{5}", [7]], ["81[18]\\d\\d", [5]], 0, 0, 0, ["(?:3[03]|900\\d)\\d{3}"], 0, ["9(?:0[1-9]|1[01])\\d{4}", [7]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["72\\d{4}", [6]], ["(?:72|8[23])\\d{4}", [6]], ["80[0-5]\\d{6}", [9]], 0, 0, ["[48]0\\d{4}", [6]], 0, 0, ["9[23]\\d{4}", [6]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", [5, 6]], ["(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]], ["800\\d{3}", [6]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0", 0, 0, 0, 0, 0, [["38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})"], ["4[3-9]\\d{6}", [8]], ["800\\d{5}", [8]], ["900\\d{5}", [8]]]], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", [7, 8]], ["7[01378]\\d{7}", [9]]]], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", [9]], ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]], ["80\\d{7}", [9]], ["(?:86[2-9]|9[0-2]\\d)\\d{6}", [9]], 0, 0, ["861\\d{6,7}", [9, 10]], 0, ["87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", [9]], ["860\\d{6}", [9]]]], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["21[1-8]\\d{6}"], ["(?:[59][5-8]|7[5-9])\\d{7}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["63\\d{7}"]]], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"], ["7(?:[1278]\\d|3[1-9])\\d{6}", [9]], ["80(?:[01]\\d|20|8[0-8])\\d{3}", [7]], 0, 0, 0, 0, 0, ["86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", [10]]]] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function y3(t, e) {
  var r = Array.prototype.slice.call(e);
  return r.push(g3), t.apply(this, r);
}
function Nd(t, e) {
  t = t.split("-"), e = e.split("-");
  for (var r = t[0].split("."), n = e[0].split("."), d = 0; d < 3; d++) {
    var a = Number(r[d]), i = Number(n[d]);
    if (a > i) return 1;
    if (i > a) return -1;
    if (!isNaN(a) && isNaN(i)) return 1;
    if (isNaN(a) && !isNaN(i)) return -1;
  }
  return t[1] && e[1] ? t[1] > e[1] ? 1 : t[1] < e[1] ? -1 : 0 : !t[1] && e[1] ? 1 : t[1] && !e[1] ? -1 : 0;
}
var m3 = {}.constructor;
function ze(t) {
  return t != null && t.constructor === m3;
}
function Wn(t) {
  "@babel/helpers - typeof";
  return Wn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Wn(t);
}
function yn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _3(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function mn(t, e, r) {
  return e && _3(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var I3 = "1.2.0", A3 = "1.7.35", Od = " ext. ", S3 = /^\d+$/, te = /* @__PURE__ */ function() {
  function t(e) {
    yn(this, t), go(e), this.metadata = e, yo.call(this, e);
  }
  return mn(t, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(r) {
        return r !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(r) {
      return this.metadata.countries[r];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(r) {
      return this.getCountryMetadata(r) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(r) {
      if (this.getCountryCodesForCallingCode(r))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[r])
          return !0;
      } else {
        var n = this.countryCallingCodes()[r];
        if (n && n.length === 1 && n[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(r) {
      return this.nonGeographic() ? !!this.nonGeographic()[r] : !this.getCountryCodesForCallingCode(r);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(r, n) {
      if (r && S3.test(r) && (n = r, r = null), r && r !== "001") {
        if (!this.hasCountry(r))
          throw new Error("Unknown country: ".concat(r));
        this.numberingPlan = new xd(this.getCountryMetadata(r), this);
      } else if (n) {
        if (!this.hasCallingCode(n))
          throw new Error("Unknown calling code: ".concat(n));
        this.numberingPlan = new xd(this.getNumberingPlanMetadata(n), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(r) {
      var n = this.countryCallingCodes()[r];
      if (n)
        return n.length === 1 && n[0].length === 3 ? void 0 : n;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(r) {
      var n = this.getCountryCodesForCallingCode(r);
      if (n)
        return n[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(r) {
      var n = this.getCountryCodeForCallingCode(r);
      if (n)
        return this.getCountryMetadata(n);
      if (this.nonGeographic()) {
        var d = this.nonGeographic()[r];
        if (d)
          return d;
      } else {
        var a = this.countryCallingCodes()[r];
        if (a && a.length === 1 && a[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(r) {
      return this.numberingPlan.type(r);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), t;
}(), xd = /* @__PURE__ */ function() {
  function t(e, r) {
    yn(this, t), this.globalMetadataObject = r, this.metadata = e, yo.call(this, r.metadata);
  }
  return mn(t, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(r) {
      return r[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var r = this, n = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return n.map(function(d) {
        return new b3(d, r);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(r) {
      return r[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(r) {
      if (this.hasTypes() && Dd(this.types(), r))
        return new E3(Dd(this.types(), r), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? Od : this.metadata[13] || Od;
    }
  }]), t;
}(), b3 = /* @__PURE__ */ function() {
  function t(e, r) {
    yn(this, t), this._format = e, this.metadata = r;
  }
  return mn(t, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !M3.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), t;
}(), M3 = /^\(?\$1\)?$/, E3 = /* @__PURE__ */ function() {
  function t(e, r) {
    yn(this, t), this.type = e, this.metadata = r;
  }
  return mn(t, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), t;
}();
function Dd(t, e) {
  switch (e) {
    case "FIXED_LINE":
      return t[0];
    case "MOBILE":
      return t[1];
    case "TOLL_FREE":
      return t[2];
    case "PREMIUM_RATE":
      return t[3];
    case "PERSONAL_NUMBER":
      return t[4];
    case "VOICEMAIL":
      return t[5];
    case "UAN":
      return t[6];
    case "PAGER":
      return t[7];
    case "VOIP":
      return t[8];
    case "SHARED_COST":
      return t[9];
  }
}
function go(t) {
  if (!t)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!ze(t) || !ze(t.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(ze(t) ? "an object of shape: { " + Object.keys(t).join(", ") + " }" : "a " + R3(t) + ": " + t, "."));
}
var R3 = function(e) {
  return Wn(e);
};
function c0(t, e) {
  if (e = new te(e), e.hasCountry(t))
    return e.country(t).countryCallingCode();
  throw new Error("Unknown country: ".concat(t));
}
function yo(t) {
  var e = t.version;
  typeof e == "number" ? (this.v1 = e === 1, this.v2 = e === 2, this.v3 = e === 3, this.v4 = e === 4) : e ? Nd(e, I3) === -1 ? this.v2 = !0 : Nd(e, A3) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function $0(t, e) {
  return P3(t, void 0, e);
}
function P3(t, e, r) {
  var n = r.type(e), d = n && n.possibleLengths() || r.possibleLengths();
  if (!d)
    return "IS_POSSIBLE";
  var a = t.length, i = d[0];
  return i === a ? "IS_POSSIBLE" : i > a ? "TOO_SHORT" : d[d.length - 1] < a ? "TOO_LONG" : d.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function C3(t, e, r) {
  if (e === void 0 && (e = {}), r = new te(r), e.v2) {
    if (!t.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(t.countryCallingCode);
  } else {
    if (!t.phone)
      return !1;
    if (t.country) {
      if (!r.hasCountry(t.country))
        throw new Error("Unknown country: ".concat(t.country));
      r.country(t.country);
    } else {
      if (!t.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(t.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return mo(t.phone || t.nationalNumber, r);
  if (t.countryCallingCode && r.isNonGeographicCallingCode(t.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function mo(t, e) {
  switch ($0(t, e)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function he(t, e) {
  return t = t || "", new RegExp("^(?:" + e + ")$").test(t);
}
function N3(t, e) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r) return (r = r.call(t)).next.bind(r);
  if (Array.isArray(t) || (r = O3(t)) || e) {
    r && (t = r);
    var n = 0;
    return function() {
      return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function O3(t, e) {
  if (t) {
    if (typeof t == "string") return Td(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Td(t, e);
  }
}
function Td(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
var x3 = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function v0(t, e, r) {
  if (e = e || {}, !(!t.country && !t.countryCallingCode)) {
    r = new te(r), r.selectNumberingPlan(t.country, t.countryCallingCode);
    var n = e.v2 ? t.nationalNumber : t.phone;
    if (he(n, r.nationalNumberPattern())) {
      if (wn(n, "FIXED_LINE", r))
        return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || wn(n, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var d = N3(x3), a; !(a = d()).done; ) {
        var i = a.value;
        if (wn(n, i, r))
          return i;
      }
    }
  }
}
function wn(t, e, r) {
  return e = r.type(e), !e || !e.pattern() || e.possibleLengths() && e.possibleLengths().indexOf(t.length) < 0 ? !1 : he(t, e.pattern());
}
function D3(t, e, r) {
  if (e = e || {}, r = new te(r), r.selectNumberingPlan(t.country, t.countryCallingCode), r.hasTypes())
    return v0(t, e, r.metadata) !== void 0;
  var n = e.v2 ? t.nationalNumber : t.phone;
  return he(n, r.nationalNumberPattern());
}
function T3(t, e, r) {
  var n = new te(r), d = n.getCountryCodesForCallingCode(t);
  return d ? d.filter(function(a) {
    return L3(e, a, r);
  }) : [];
}
function L3(t, e, r) {
  var n = new te(r);
  return n.selectNumberingPlan(e), n.numberingPlan.possibleLengths().indexOf(t.length) >= 0;
}
var p0 = 2, F3 = 17, w3 = 3, se = "0-9０-９٠-٩۰-۹", B3 = "-‐-―−ー－", U3 = "／/", q3 = "．.", Z3 = "  ­​⁠　", k3 = "()（）［］\\[\\]", H3 = "~⁓∼～", $n = "".concat(B3).concat(U3).concat(q3).concat(Z3).concat(k3).concat(H3), h0 = "+＋", G3 = new RegExp("([" + se + "])");
function j3(t, e, r, n) {
  if (e) {
    var d = new te(n);
    d.selectNumberingPlan(e, r);
    var a = new RegExp(d.IDDPrefix());
    if (t.search(a) === 0) {
      t = t.slice(t.match(a)[0].length);
      var i = t.match(G3);
      if (!(i && i[1] != null && i[1].length > 0 && i[1] === "0"))
        return t;
    }
  }
}
function V3(t, e) {
  if (t && e.numberingPlan.nationalPrefixForParsing()) {
    var r = new RegExp("^(?:" + e.numberingPlan.nationalPrefixForParsing() + ")"), n = r.exec(t);
    if (n) {
      var d, a, i = n.length - 1, u = i > 0 && n[i];
      if (e.nationalPrefixTransformRule() && u)
        d = t.replace(r, e.nationalPrefixTransformRule()), i > 1 && (a = n[1]);
      else {
        var o = n[0];
        d = t.slice(o.length), u && (a = n[1]);
      }
      var s;
      if (u) {
        var c = t.indexOf(n[1]), f = t.slice(0, c);
        f === e.numberingPlan.nationalPrefix() && (s = e.numberingPlan.nationalPrefix());
      } else
        s = n[0];
      return {
        nationalNumber: d,
        nationalPrefix: s,
        carrierCode: a
      };
    }
  }
  return {
    nationalNumber: t
  };
}
function Kn(t, e) {
  var r = V3(t, e), n = r.carrierCode, d = r.nationalNumber;
  if (d !== t) {
    if (!W3(t, d, e))
      return {
        nationalNumber: t
      };
    if (e.possibleLengths() && !K3(d, e))
      return {
        nationalNumber: t
      };
  }
  return {
    nationalNumber: d,
    carrierCode: n
  };
}
function W3(t, e, r) {
  return !(he(t, r.nationalNumberPattern()) && !he(e, r.nationalNumberPattern()));
}
function K3(t, e) {
  switch ($0(t, e)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function Y3(t, e, r, n) {
  var d = e ? c0(e, n) : r;
  if (t.indexOf(d) === 0) {
    n = new te(n), n.selectNumberingPlan(e, r);
    var a = t.slice(d.length), i = Kn(a, n), u = i.nationalNumber, o = Kn(t, n), s = o.nationalNumber;
    if (!he(s, n.nationalNumberPattern()) && he(u, n.nationalNumberPattern()) || $0(s, n) === "TOO_LONG")
      return {
        countryCallingCode: d,
        number: a
      };
  }
  return {
    number: t
  };
}
function _o(t, e, r, n) {
  if (!t)
    return {};
  var d;
  if (t[0] !== "+") {
    var a = j3(t, e, r, n);
    if (a && a !== t)
      d = !0, t = "+" + a;
    else {
      if (e || r) {
        var i = Y3(t, e, r, n), u = i.countryCallingCode, o = i.number;
        if (u)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: u,
            number: o
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: t
      };
    }
  }
  if (t[1] === "0")
    return {};
  n = new te(n);
  for (var s = 2; s - 1 <= w3 && s <= t.length; ) {
    var c = t.slice(1, s);
    if (n.hasCallingCode(c))
      return n.selectNumberingPlan(c), {
        countryCallingCodeSource: d ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: c,
        number: t.slice(s)
      };
    s++;
  }
  return {};
}
function z3(t) {
  return t.replace(new RegExp("[".concat($n, "]+"), "g"), " ").trim();
}
var J3 = /(\$\d)/;
function X3(t, e, r) {
  var n = r.useInternationalFormat, d = r.withNationalPrefix, a = t.replace(new RegExp(e.pattern()), n ? e.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    d && e.nationalPrefixFormattingRule() ? e.format().replace(J3, e.nationalPrefixFormattingRule()) : e.format()
  ));
  return n ? z3(a) : a;
}
var Q3 = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function e4(t, e, r) {
  var n = new te(r);
  if (n.selectNumberingPlan(t, e), n.defaultIDDPrefix())
    return n.defaultIDDPrefix();
  if (Q3.test(n.IDDPrefix()))
    return n.IDDPrefix();
}
var t4 = ";ext=", qe = function(e) {
  return "([".concat(se, "]{1,").concat(e, "})");
};
function Io(t) {
  var e = "20", r = "15", n = "9", d = "6", a = "[  \\t,]*", i = "[:\\.．]?[  \\t,-]*", u = "#?", o = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", s = "(?:[xｘ#＃~～]|int|ｉｎｔ)", c = "[- ]+", f = "[  \\t]*", l = "(?:,{2}|;)", _ = t4 + qe(e), p = a + o + i + qe(e) + u, $ = a + s + i + qe(n) + u, h = c + qe(d) + "#", g = f + l + i + qe(r) + u, A = f + "(?:,)+" + i + qe(n) + u;
  return _ + "|" + p + "|" + $ + "|" + h + "|" + g + "|" + A;
}
var r4 = "[" + se + "]{" + p0 + "}", n4 = "[" + h0 + "]{0,1}(?:[" + $n + "]*[" + se + "]){3,}[" + $n + se + "]*", d4 = new RegExp("^[" + h0 + "]{0,1}(?:[" + $n + "]*[" + se + "]){1,2}$", "i"), a4 = n4 + // Phone number extensions
"(?:" + Io() + ")?", i4 = new RegExp(
  // Either a short two-digit-only phone number
  "^" + r4 + "$|^" + a4 + "$",
  "i"
);
function u4(t) {
  return t.length >= p0 && i4.test(t);
}
function o4(t) {
  return d4.test(t);
}
function s4(t) {
  var e = t.number, r = t.ext;
  if (!e)
    return "";
  if (e[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(e).concat(r ? ";ext=" + r : "");
}
function l4(t, e) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r) return (r = r.call(t)).next.bind(r);
  if (Array.isArray(t) || (r = f4(t)) || e) {
    r && (t = r);
    var n = 0;
    return function() {
      return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function f4(t, e) {
  if (t) {
    if (typeof t == "string") return Ld(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ld(t, e);
  }
}
function Ld(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function Fd(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(d) {
      return Object.getOwnPropertyDescriptor(t, d).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wd(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Fd(Object(r), !0).forEach(function(n) {
      c4(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Fd(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function c4(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var Bd = {
  formatExtension: function(e, r, n) {
    return "".concat(e).concat(n.ext()).concat(r);
  }
};
function $4(t, e, r, n) {
  if (r ? r = wd(wd({}, Bd), r) : r = Bd, n = new te(n), t.country && t.country !== "001") {
    if (!n.hasCountry(t.country))
      throw new Error("Unknown country: ".concat(t.country));
    n.country(t.country);
  } else if (t.countryCallingCode)
    n.selectNumberingPlan(t.countryCallingCode);
  else return t.phone || "";
  var d = n.countryCallingCode(), a = r.v2 ? t.nationalNumber : t.phone, i;
  switch (e) {
    case "NATIONAL":
      return a ? (i = vn(a, t.carrierCode, "NATIONAL", n, r), Bn(i, t.ext, n, r.formatExtension)) : "";
    case "INTERNATIONAL":
      return a ? (i = vn(a, null, "INTERNATIONAL", n, r), i = "+".concat(d, " ").concat(i), Bn(i, t.ext, n, r.formatExtension)) : "+".concat(d);
    case "E.164":
      return "+".concat(d).concat(a);
    case "RFC3966":
      return s4({
        number: "+".concat(d).concat(a),
        ext: t.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!r.fromCountry)
        return;
      var u = p4(a, t.carrierCode, d, r.fromCountry, n);
      return Bn(u, t.ext, n, r.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(e, '"'));
  }
}
function vn(t, e, r, n, d) {
  var a = v4(n.formats(), t);
  return a ? X3(t, a, {
    useInternationalFormat: r === "INTERNATIONAL",
    withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && d && d.nationalPrefix === !1)
  }) : t;
}
function v4(t, e) {
  for (var r = l4(t), n; !(n = r()).done; ) {
    var d = n.value;
    if (d.leadingDigitsPatterns().length > 0) {
      var a = d.leadingDigitsPatterns()[d.leadingDigitsPatterns().length - 1];
      if (e.search(a) !== 0)
        continue;
    }
    if (he(e, d.pattern()))
      return d;
  }
}
function Bn(t, e, r, n) {
  return e ? n(t, e, r) : t;
}
function p4(t, e, r, n, d) {
  var a = c0(n, d.metadata);
  if (a === r) {
    var i = vn(t, e, "NATIONAL", d);
    return r === "1" ? r + " " + i : i;
  }
  var u = e4(n, void 0, d.metadata);
  if (u)
    return "".concat(u, " ").concat(r, " ").concat(vn(t, null, "INTERNATIONAL", d));
}
function Ud(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(d) {
      return Object.getOwnPropertyDescriptor(t, d).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qd(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ud(Object(r), !0).forEach(function(n) {
      h4(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ud(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function h4(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function g4(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function y4(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function m4(t, e, r) {
  return e && y4(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var _4 = /* @__PURE__ */ function() {
  function t(e, r, n) {
    if (g4(this, t), !e)
      throw new TypeError("First argument is required");
    if (typeof e != "string")
      throw new TypeError("First argument must be a string");
    if (typeof e == "string") {
      if (e[0] === "+" && !r)
        throw new TypeError("`metadata` argument not passed");
      if (ze(r) && ze(r.countries)) {
        n = r;
        var d = e;
        if (!S4.test(d))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var a = _o(d, void 0, void 0, n), i = a.countryCallingCode, u = a.number;
        if (r = u, e = i, !r)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!r)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof r != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    go(n);
    var o = A4(e, n), s = o.country, c = o.countryCallingCode;
    this.country = s, this.countryCallingCode = c, this.nationalNumber = r, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return n;
    };
  }
  return m4(t, [{
    key: "setExt",
    value: function(r) {
      this.ext = r;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : T3(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return C3(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return D3(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var r = new te(this.getMetadata());
      return r.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(r) {
      return this.number === r.number && this.ext === r.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return v0(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(r, n) {
      return $4(this, r, n ? qd(qd({}, n), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(r) {
      return this.format("NATIONAL", r);
    }
  }, {
    key: "formatInternational",
    value: function(r) {
      return this.format("INTERNATIONAL", r);
    }
  }, {
    key: "getURI",
    value: function(r) {
      return this.format("RFC3966", r);
    }
  }]), t;
}(), I4 = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function A4(t, e) {
  var r, n, d = new te(e);
  return I4(t) ? (r = t, d.selectNumberingPlan(r), n = d.countryCallingCode()) : n = t, {
    country: r,
    countryCallingCode: n
  };
}
var S4 = /^\+\d+$/;
function Yn(t) {
  "@babel/helpers - typeof";
  return Yn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Yn(t);
}
function b4(t, e, r) {
  return Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function M4(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function E4(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && it(t, e);
}
function R4(t) {
  var e = So();
  return function() {
    var n = ut(t), d;
    if (e) {
      var a = ut(this).constructor;
      d = Reflect.construct(n, arguments, a);
    } else
      d = n.apply(this, arguments);
    return P4(this, d);
  };
}
function P4(t, e) {
  if (e && (Yn(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ao(t);
}
function Ao(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function zn(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return zn = function(n) {
    if (n === null || !C4(n)) return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(n)) return e.get(n);
      e.set(n, d);
    }
    function d() {
      return cn(n, arguments, ut(this).constructor);
    }
    return d.prototype = Object.create(n.prototype, { constructor: { value: d, enumerable: !1, writable: !0, configurable: !0 } }), it(d, n);
  }, zn(t);
}
function cn(t, e, r) {
  return So() ? cn = Reflect.construct : cn = function(d, a, i) {
    var u = [null];
    u.push.apply(u, a);
    var o = Function.bind.apply(d, u), s = new o();
    return i && it(s, i.prototype), s;
  }, cn.apply(null, arguments);
}
function So() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function C4(t) {
  return Function.toString.call(t).indexOf("[native code]") !== -1;
}
function it(t, e) {
  return it = Object.setPrototypeOf || function(n, d) {
    return n.__proto__ = d, n;
  }, it(t, e);
}
function ut(t) {
  return ut = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ut(t);
}
var ye = /* @__PURE__ */ function(t) {
  E4(r, t);
  var e = R4(r);
  function r(n) {
    var d;
    return M4(this, r), d = e.call(this, n), Object.setPrototypeOf(Ao(d), r.prototype), d.name = d.constructor.name, d;
  }
  return b4(r);
}(/* @__PURE__ */ zn(Error)), Zd = new RegExp("(?:" + Io() + ")$", "i");
function N4(t) {
  var e = t.search(Zd);
  if (e < 0)
    return {};
  for (var r = t.slice(0, e), n = t.match(Zd), d = 1; d < n.length; ) {
    if (n[d])
      return {
        number: r,
        ext: n[d]
      };
    d++;
  }
}
var O4 = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function x4(t) {
  return O4[t];
}
function D4(t, e) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r) return (r = r.call(t)).next.bind(r);
  if (Array.isArray(t) || (r = T4(t)) || e) {
    r && (t = r);
    var n = 0;
    return function() {
      return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function T4(t, e) {
  if (t) {
    if (typeof t == "string") return kd(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return kd(t, e);
  }
}
function kd(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function Hd(t) {
  for (var e = "", r = D4(t.split("")), n; !(n = r()).done; ) {
    var d = n.value;
    e += L4(d, e) || "";
  }
  return e;
}
function L4(t, e, r) {
  return t === "+" ? e ? void 0 : "+" : x4(t);
}
function F4(t, e) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r) return (r = r.call(t)).next.bind(r);
  if (Array.isArray(t) || (r = w4(t)) || e) {
    r && (t = r);
    var n = 0;
    return function() {
      return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function w4(t, e) {
  if (t) {
    if (typeof t == "string") return Gd(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Gd(t, e);
  }
}
function Gd(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function B4(t, e) {
  var r = e.countries, n = e.metadata;
  n = new te(n);
  for (var d = F4(r), a; !(a = d()).done; ) {
    var i = a.value;
    if (n.country(i), n.leadingDigits()) {
      if (t && t.search(n.leadingDigits()) === 0)
        return i;
    } else if (v0({
      phone: t,
      country: i
    }, void 0, n.metadata))
      return i;
  }
}
function U4(t, e) {
  var r = e.nationalNumber, n = e.metadata, d = n.getCountryCodesForCallingCode(t);
  if (d)
    return d.length === 1 ? d[0] : B4(r, {
      countries: d,
      metadata: n.metadata
    });
}
var bo = "+", q4 = "[\\-\\.\\(\\)]?", jd = "([" + se + "]|" + q4 + ")", Z4 = "^\\" + bo + jd + "*[" + se + "]" + jd + "*$", k4 = new RegExp(Z4, "g"), Jn = se, H4 = "[" + Jn + "]+((\\-)*[" + Jn + "])*", G4 = "a-zA-Z", j4 = "[" + G4 + "]+((\\-)*[" + Jn + "])*", V4 = "^(" + H4 + "\\.)*" + j4 + "\\.?$", W4 = new RegExp(V4, "g"), Vd = "tel:", Xn = ";phone-context=", K4 = ";isub=";
function Y4(t) {
  var e = t.indexOf(Xn);
  if (e < 0)
    return null;
  var r = e + Xn.length;
  if (r >= t.length)
    return "";
  var n = t.indexOf(";", r);
  return n >= 0 ? t.substring(r, n) : t.substring(r);
}
function z4(t) {
  return t === null ? !0 : t.length === 0 ? !1 : k4.test(t) || W4.test(t);
}
function J4(t, e) {
  var r = e.extractFormattedPhoneNumber, n = Y4(t);
  if (!z4(n))
    throw new ye("NOT_A_NUMBER");
  var d;
  if (n === null)
    d = r(t) || "";
  else {
    d = "", n.charAt(0) === bo && (d += n);
    var a = t.indexOf(Vd), i;
    a >= 0 ? i = a + Vd.length : i = 0;
    var u = t.indexOf(Xn);
    d += t.substring(i, u);
  }
  var o = d.indexOf(K4);
  if (o > 0 && (d = d.substring(0, o)), d !== "")
    return d;
}
var X4 = 250, Q4 = new RegExp("[" + h0 + se + "]"), ec = new RegExp("[^" + se + "#]+$");
function tc(t, e, r) {
  if (e = e || {}, r = new te(r), e.defaultCountry && !r.hasCountry(e.defaultCountry))
    throw e.v2 ? new ye("INVALID_COUNTRY") : new Error("Unknown country: ".concat(e.defaultCountry));
  var n = nc(t, e.v2, e.extract), d = n.number, a = n.ext, i = n.error;
  if (!d) {
    if (e.v2)
      throw i === "TOO_SHORT" ? new ye("TOO_SHORT") : new ye("NOT_A_NUMBER");
    return {};
  }
  var u = ac(d, e.defaultCountry, e.defaultCallingCode, r), o = u.country, s = u.nationalNumber, c = u.countryCallingCode, f = u.countryCallingCodeSource, l = u.carrierCode;
  if (!r.hasSelectedNumberingPlan()) {
    if (e.v2)
      throw new ye("INVALID_COUNTRY");
    return {};
  }
  if (!s || s.length < p0) {
    if (e.v2)
      throw new ye("TOO_SHORT");
    return {};
  }
  if (s.length > F3) {
    if (e.v2)
      throw new ye("TOO_LONG");
    return {};
  }
  if (e.v2) {
    var _ = new _4(c, s, r.metadata);
    return o && (_.country = o), l && (_.carrierCode = l), a && (_.ext = a), _.__countryCallingCodeSource = f, _;
  }
  var p = (e.extended ? r.hasSelectedNumberingPlan() : o) ? he(s, r.nationalNumberPattern()) : !1;
  return e.extended ? {
    country: o,
    countryCallingCode: c,
    carrierCode: l,
    valid: p,
    possible: p ? !0 : !!(e.extended === !0 && r.possibleLengths() && mo(s, r)),
    phone: s,
    ext: a
  } : p ? dc(o, s, a) : {};
}
function rc(t, e, r) {
  if (t) {
    if (t.length > X4) {
      if (r)
        throw new ye("TOO_LONG");
      return;
    }
    if (e === !1)
      return t;
    var n = t.search(Q4);
    if (!(n < 0))
      return t.slice(n).replace(ec, "");
  }
}
function nc(t, e, r) {
  var n = J4(t, {
    extractFormattedPhoneNumber: function(i) {
      return rc(i, r, e);
    }
  });
  if (!n)
    return {};
  if (!u4(n))
    return o4(n) ? {
      error: "TOO_SHORT"
    } : {};
  var d = N4(n);
  return d.ext ? d : {
    number: n
  };
}
function dc(t, e, r) {
  var n = {
    country: t,
    phone: e
  };
  return r && (n.ext = r), n;
}
function ac(t, e, r, n) {
  var d = _o(Hd(t), e, r, n.metadata), a = d.countryCallingCodeSource, i = d.countryCallingCode, u = d.number, o;
  if (i)
    n.selectNumberingPlan(i);
  else if (u && (e || r))
    n.selectNumberingPlan(e, r), e && (o = e), i = r || c0(e, n.metadata);
  else return {};
  if (!u)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: i
    };
  var s = Kn(Hd(u), n), c = s.nationalNumber, f = s.carrierCode, l = U4(i, {
    nationalNumber: c,
    metadata: n
  });
  return l && (o = l, l === "001" || n.country(o)), {
    country: o,
    countryCallingCode: i,
    countryCallingCodeSource: a,
    nationalNumber: c,
    carrierCode: f
  };
}
function Wd(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(d) {
      return Object.getOwnPropertyDescriptor(t, d).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Kd(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Wd(Object(r), !0).forEach(function(n) {
      ic(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Wd(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function ic(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function uc(t, e, r) {
  return tc(t, Kd(Kd({}, e), {}, {
    v2: !0
  }), r);
}
function Yd(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(d) {
      return Object.getOwnPropertyDescriptor(t, d).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function oc(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Yd(Object(r), !0).forEach(function(n) {
      sc(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Yd(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function sc(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function lc(t, e) {
  return vc(t) || $c(t, e) || cc(t, e) || fc();
}
function fc() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cc(t, e) {
  if (t) {
    if (typeof t == "string") return zd(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return zd(t, e);
  }
}
function zd(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function $c(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n = [], d = !0, a = !1, i, u;
    try {
      for (r = r.call(t); !(d = (i = r.next()).done) && (n.push(i.value), !(e && n.length === e)); d = !0)
        ;
    } catch (o) {
      a = !0, u = o;
    } finally {
      try {
        !d && r.return != null && r.return();
      } finally {
        if (a) throw u;
      }
    }
    return n;
  }
}
function vc(t) {
  if (Array.isArray(t)) return t;
}
function pc(t) {
  var e = Array.prototype.slice.call(t), r = lc(e, 4), n = r[0], d = r[1], a = r[2], i = r[3], u, o, s;
  if (typeof n == "string")
    u = n;
  else throw new TypeError("A text for parsing must be a string.");
  if (!d || typeof d == "string")
    i ? (o = a, s = i) : (o = void 0, s = a), d && (o = oc({
      defaultCountry: d
    }, o));
  else if (ze(d))
    a ? (o = d, s = a) : s = d;
  else throw new Error("Invalid second argument: ".concat(d));
  return {
    text: u,
    options: o,
    metadata: s
  };
}
function hc() {
  var t = pc(arguments), e = t.text, r = t.options, n = t.metadata;
  return uc(e, r, n);
}
function gc() {
  return y3(hc, arguments);
}
var Mo = "isPhoneNumber";
function Eo(t, e) {
  if (typeof t != "string" || t.trim() !== t)
    return !1;
  try {
    var r = gc(t, e);
    return e && r.country !== e ? !1 : r.isValid();
  } catch {
    return !1;
  }
}
function yc(t, e) {
  return N({
    name: Mo,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Eo(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a valid phone number";
      }, e)
    }
  }, e);
}
var Ro = "isMilitaryTime";
function Po(t) {
  var e = /^([01]\d|2[0-3]):?([0-5]\d)$/;
  return typeof t == "string" && vo(t, e);
}
function mc(t) {
  return N({
    name: Ro,
    validator: {
      validate: function(e, r) {
        return Po(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a valid representation of military time in the format HH:MM";
      }, t)
    }
  }, t);
}
var ar = { exports: {} }, Jd;
function Co() {
  return Jd || (Jd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = {
      md5: 32,
      md4: 32,
      sha1: 40,
      sha256: 64,
      sha384: 96,
      sha512: 128,
      ripemd128: 32,
      ripemd160: 40,
      tiger128: 32,
      tiger160: 40,
      tiger192: 48,
      crc32: 8,
      crc32b: 8
    };
    function a(i, u) {
      (0, r.default)(i);
      var o = new RegExp("^[a-fA-F0-9]{".concat(d[u], "}$"));
      return o.test(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(ar, ar.exports)), ar.exports;
}
var _c = /* @__PURE__ */ Co();
const Ic = /* @__PURE__ */ B(_c);
var No = "isHash";
function Oo(t, e) {
  return typeof t == "string" && Ic(t, e);
}
function Ac(t, e) {
  return N({
    name: No,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Oo(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a hash of type $constraint1";
      }, e)
    }
  }, e);
}
var ir = { exports: {} }, Xd;
function xo() {
  return Xd || (Xd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = "^\\d{4}-?\\d{3}[\\dX]$";
    function a(i) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, r.default)(i);
      var o = d;
      if (o = u.require_hyphen ? o.replace("?", "") : o, o = u.case_sensitive ? new RegExp(o) : new RegExp(o, "i"), !o.test(i))
        return !1;
      for (var s = i.replace("-", "").toUpperCase(), c = 0, f = 0; f < s.length; f++) {
        var l = s[f];
        c += (l === "X" ? 10 : +l) * (8 - f);
      }
      return c % 11 === 0;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(ir, ir.exports)), ir.exports;
}
var Sc = /* @__PURE__ */ xo();
const bc = /* @__PURE__ */ B(Sc);
var Do = "isISSN";
function To(t, e) {
  return typeof t == "string" && bc(t, e);
}
function Mc(t, e) {
  return N({
    name: Do,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return To(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a ISSN";
      }, e)
    }
  }, e);
}
var Lo = "isDateString";
function Fo(t, e) {
  return s0(t, e);
}
function Ec(t, e) {
  return N({
    name: Lo,
    constraints: [t],
    validator: {
      validate: function(r) {
        return Fo(r, t);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a valid ISO 8601 date string";
      }, e)
    }
  }, e);
}
var ur = { exports: {} }, Qd;
function wo() {
  return Qd || (Qd = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = u;
    var r = n(/* @__PURE__ */ D());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = {
      loose: !1
    }, a = ["true", "false", "1", "0"], i = [].concat(a, ["yes", "no"]);
    function u(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : d;
      return (0, r.default)(o), s.loose ? i.includes(o.toLowerCase()) : a.includes(o);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(ur, ur.exports)), ur.exports;
}
var Rc = /* @__PURE__ */ wo();
const Pc = /* @__PURE__ */ B(Rc);
var Bo = "isBooleanString";
function Uo(t) {
  return typeof t == "string" && Pc(t);
}
function Cc(t) {
  return N({
    name: Bo,
    validator: {
      validate: function(e, r) {
        return Uo(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a boolean string";
      }, t)
    }
  }, t);
}
var or = { exports: {} }, ea;
function qo() {
  return ea || (ea = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = d(/* @__PURE__ */ D()), n = /* @__PURE__ */ ot();
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = /^[0-9]+$/;
    function i(u, o) {
      return (0, r.default)(u), o && o.no_symbols ? a.test(u) : new RegExp("^[+-]?([0-9]*[".concat((o || {}).locale ? n.decimal[o.locale] : ".", "])?[0-9]+$")).test(u);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(or, or.exports)), or.exports;
}
var Nc = /* @__PURE__ */ qo();
const Oc = /* @__PURE__ */ B(Nc);
var Zo = "isNumberString";
function ko(t, e) {
  return typeof t == "string" && Oc(t, e);
}
function xc(t, e) {
  return N({
    name: Zo,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return ko(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a number string";
      }, e)
    }
  }, e);
}
var sr = { exports: {} }, ta;
function Ho() {
  return ta || (ta = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = o;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ ee());
    function d(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var a = /^[A-Z2-7]+=*$/, i = /^[A-HJKMNP-TV-Z0-9]+$/, u = {
      crockford: !1
    };
    function o(s, c) {
      if ((0, r.default)(s), c = (0, n.default)(c, u), c.crockford)
        return i.test(s);
      var f = s.length;
      return !!(f % 8 === 0 && a.test(s));
    }
    t.exports = e.default, t.exports.default = e.default;
  }(sr, sr.exports)), sr.exports;
}
var Dc = /* @__PURE__ */ Ho();
const Tc = /* @__PURE__ */ B(Dc);
var Go = "isBase32";
function jo(t) {
  return typeof t == "string" && Tc(t);
}
function Lc(t) {
  return N({
    name: Go,
    validator: {
      validate: function(e, r) {
        return jo(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be base32 encoded";
      }, t)
    }
  }, t);
}
var lr = { exports: {} }, ra;
function Vo() {
  return ra || (ra = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = d(/* @__PURE__ */ D()), n = /* @__PURE__ */ l0();
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
    function i(u) {
      (0, r.default)(u);
      var o = u.slice(4, 6).toUpperCase();
      return !n.CountryCodes.has(o) && o !== "XK" ? !1 : a.test(u);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(lr, lr.exports)), lr.exports;
}
var Fc = /* @__PURE__ */ Vo();
const wc = /* @__PURE__ */ B(Fc);
var Wo = "isBIC";
function Ko(t) {
  return typeof t == "string" && wc(t);
}
function Bc(t) {
  return N({
    name: Wo,
    validator: {
      validate: function(e, r) {
        return Ko(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a BIC or SWIFT code";
      }, t)
    }
  }, t);
}
var fr = { exports: {} }, na;
function Yo() {
  return na || (na = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = n(/* @__PURE__ */ D());
    function n(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var d = /^(bc1|tb1|bc1p|tb1p)[ac-hj-np-z02-9]{39,58}$/, a = /^(1|2|3|m)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
    function i(u) {
      return (0, r.default)(u), d.test(u) || a.test(u);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(fr, fr.exports)), fr.exports;
}
var Uc = /* @__PURE__ */ Yo();
const qc = /* @__PURE__ */ B(Uc);
var zo = "isBtcAddress";
function Jo(t) {
  return typeof t == "string" && qc(t);
}
function Zc(t) {
  return N({
    name: zo,
    validator: {
      validate: function(e, r) {
        return Jo(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a BTC address";
      }, t)
    }
  }, t);
}
var cr = { exports: {} }, da;
function Xo() {
  return da || (da = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = u;
    var r = n(/* @__PURE__ */ D());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^[a-z]+\/[a-z0-9\-\+\._]+$/i, a = /^[a-z\-]+=[a-z0-9\-]+$/i, i = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
    function u(o) {
      (0, r.default)(o);
      var s = o.split(",");
      if (s.length < 2)
        return !1;
      var c = s.shift().trim().split(";"), f = c.shift();
      if (f.slice(0, 5) !== "data:")
        return !1;
      var l = f.slice(5);
      if (l !== "" && !d.test(l))
        return !1;
      for (var _ = 0; _ < c.length; _++)
        if (!(_ === c.length - 1 && c[_].toLowerCase() === "base64") && !a.test(c[_]))
          return !1;
      for (var p = 0; p < s.length; p++)
        if (!i.test(s[p]))
          return !1;
      return !0;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(cr, cr.exports)), cr.exports;
}
var kc = /* @__PURE__ */ Xo();
const Hc = /* @__PURE__ */ B(kc);
var Qo = "isDataURI";
function e2(t) {
  return typeof t == "string" && Hc(t);
}
function Gc(t) {
  return N({
    name: Qo,
    validator: {
      validate: function(e, r) {
        return e2(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a data uri format";
      }, t)
    }
  }, t);
}
var $r = { exports: {} }, aa;
function t2() {
  return aa || (aa = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = s;
    var r = n(/* @__PURE__ */ D());
    function n(c) {
      return c && c.__esModule ? c : { default: c };
    }
    var d = 8, a = 14, i = /^(\d{8}|\d{13}|\d{14})$/;
    function u(c, f) {
      return c === d || c === a ? f % 2 === 0 ? 3 : 1 : f % 2 === 0 ? 1 : 3;
    }
    function o(c) {
      var f = c.slice(0, -1).split("").map(function(_, p) {
        return Number(_) * u(c.length, p);
      }).reduce(function(_, p) {
        return _ + p;
      }, 0), l = 10 - f % 10;
      return l < 10 ? l : 0;
    }
    function s(c) {
      (0, r.default)(c);
      var f = Number(c.slice(-1));
      return i.test(c) && f === o(c);
    }
    t.exports = e.default, t.exports.default = e.default;
  }($r, $r.exports)), $r.exports;
}
var jc = /* @__PURE__ */ t2();
const Vc = /* @__PURE__ */ B(jc);
var r2 = "isEAN";
function n2(t) {
  return typeof t == "string" && Vc(t);
}
function Wc(t) {
  return N({
    name: r2,
    validator: {
      validate: function(e, r) {
        return n2(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be an EAN (European Article Number)";
      }, t)
    }
  }, t);
}
var vr = { exports: {} }, ia;
function d2() {
  return ia || (ia = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^(0x)[0-9a-f]{40}$/i;
    function a(i) {
      return (0, r.default)(i), d.test(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(vr, vr.exports)), vr.exports;
}
var Kc = /* @__PURE__ */ d2();
const Yc = /* @__PURE__ */ B(Kc);
var a2 = "isEthereumAddress";
function i2(t) {
  return typeof t == "string" && Yc(t);
}
function zc(t) {
  return N({
    name: a2,
    validator: {
      validate: function(e, r) {
        return i2(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be an Ethereum address";
      }, t)
    }
  }, t);
}
var pr = { exports: {} }, ua;
function u2() {
  return ua || (ua = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = n(/* @__PURE__ */ D());
    function n(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var d = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i, a = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
    function i(u) {
      (0, r.default)(u);
      var o = u.replace(/\s+/g, " ").replace(/\s?(hsla?\(|\)|,)\s?/ig, "$1");
      return o.indexOf(",") !== -1 ? d.test(o) : a.test(o);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(pr, pr.exports)), pr.exports;
}
var Jc = /* @__PURE__ */ u2();
const Xc = /* @__PURE__ */ B(Jc);
var o2 = "isHSL";
function s2(t) {
  return typeof t == "string" && Xc(t);
}
function Qc(t) {
  return N({
    name: o2,
    validator: {
      validate: function(e, r) {
        return s2(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a HSL color";
      }, t)
    }
  }, t);
}
var Ze = {}, oa;
function l2() {
  if (oa) return Ze;
  oa = 1, Object.defineProperty(Ze, "__esModule", {
    value: !0
  }), Ze.default = i, Ze.locales = void 0;
  var t = e(/* @__PURE__ */ D());
  function e(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var r = {
    AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
    AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
    AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    AT: /^(AT[0-9]{2})\d{16}$/,
    AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    BA: /^(BA[0-9]{2})\d{16}$/,
    BE: /^(BE[0-9]{2})\d{12}$/,
    BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
    BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
    BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
    BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    CR: /^(CR[0-9]{2})\d{18}$/,
    CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    CZ: /^(CZ[0-9]{2})\d{20}$/,
    DE: /^(DE[0-9]{2})\d{18}$/,
    DK: /^(DK[0-9]{2})\d{14}$/,
    DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
    DZ: /^(DZ\d{24})$/,
    EE: /^(EE[0-9]{2})\d{16}$/,
    EG: /^(EG[0-9]{2})\d{25}$/,
    ES: /^(ES[0-9]{2})\d{20}$/,
    FI: /^(FI[0-9]{2})\d{14}$/,
    FO: /^(FO[0-9]{2})\d{14}$/,
    FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
    GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
    GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
    GL: /^(GL[0-9]{2})\d{14}$/,
    GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
    GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
    HR: /^(HR[0-9]{2})\d{17}$/,
    HU: /^(HU[0-9]{2})\d{24}$/,
    IE: /^(IE[0-9]{2})[A-Z]{4}\d{14}$/,
    IL: /^(IL[0-9]{2})\d{19}$/,
    IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
    IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
    IS: /^(IS[0-9]{2})\d{22}$/,
    IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
    KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
    KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
    LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
    LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    LT: /^(LT[0-9]{2})\d{16}$/,
    LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
    MA: /^(MA[0-9]{26})$/,
    MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
    ME: /^(ME[0-9]{2})\d{18}$/,
    MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
    MR: /^(MR[0-9]{2})\d{23}$/,
    MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
    MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
    MZ: /^(MZ[0-9]{2})\d{21}$/,
    NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
    NO: /^(NO[0-9]{2})\d{11}$/,
    PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
    PL: /^(PL[0-9]{2})\d{24}$/,
    PS: /^(PS[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
    PT: /^(PT[0-9]{2})\d{21}$/,
    QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
    RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
    RS: /^(RS[0-9]{2})\d{18}$/,
    SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
    SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
    SE: /^(SE[0-9]{2})\d{20}$/,
    SI: /^(SI[0-9]{2})\d{15}$/,
    SK: /^(SK[0-9]{2})\d{20}$/,
    SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    TL: /^(TL[0-9]{2})\d{19}$/,
    TN: /^(TN[0-9]{2})\d{20}$/,
    TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
    UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
    VA: /^(VA[0-9]{2})\d{18}$/,
    VG: /^(VG[0-9]{2})[A-Z]{4}\d{16}$/,
    XK: /^(XK[0-9]{2})\d{16}$/
  };
  function n(u) {
    var o = u.filter(function(s) {
      return !(s in r);
    });
    return !(o.length > 0);
  }
  function d(u, o) {
    var s = u.replace(/[\s\-]+/gi, "").toUpperCase(), c = s.slice(0, 2).toUpperCase(), f = c in r;
    if (o.whitelist) {
      if (!n(o.whitelist))
        return !1;
      var l = o.whitelist.includes(c);
      if (!l)
        return !1;
    }
    if (o.blacklist) {
      var _ = o.blacklist.includes(c);
      if (_)
        return !1;
    }
    return f && r[c].test(s);
  }
  function a(u) {
    var o = u.replace(/[^A-Z0-9]+/gi, "").toUpperCase(), s = o.slice(4) + o.slice(0, 4), c = s.replace(/[A-Z]/g, function(l) {
      return l.charCodeAt(0) - 55;
    }), f = c.match(/\d{1,7}/g).reduce(function(l, _) {
      return Number(l + _) % 97;
    }, "");
    return f === 1;
  }
  function i(u) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, t.default)(u), d(u, o) && a(u);
  }
  return Ze.locales = Object.keys(r), Ze;
}
var e6 = /* @__PURE__ */ l2();
const t6 = /* @__PURE__ */ B(e6);
var f2 = "isIBAN";
function c2(t) {
  return typeof t == "string" && t6(t);
}
function r6(t) {
  return N({
    name: f2,
    validator: {
      validate: function(e, r) {
        return c2(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be an IBAN";
      }, t)
    }
  }, t);
}
var hr = { exports: {} }, sa;
function $2() {
  return sa || (sa = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ o0());
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = {
      PL: function(o) {
        (0, r.default)(o);
        var s = {
          1: 1,
          2: 3,
          3: 7,
          4: 9,
          5: 1,
          6: 3,
          7: 7,
          8: 9,
          9: 1,
          10: 3,
          11: 0
        };
        if (o != null && o.length === 11 && (0, n.default)(o, {
          allow_leading_zeroes: !0
        })) {
          var c = o.split("").slice(0, -1), f = c.reduce(function(p, $, h) {
            return p + Number($) * s[h + 1];
          }, 0), l = f % 10, _ = Number(o.charAt(o.length - 1));
          if (l === 0 && _ === 0 || _ === 10 - l)
            return !0;
        }
        return !1;
      },
      ES: function(o) {
        (0, r.default)(o);
        var s = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/, c = {
          X: 0,
          Y: 1,
          Z: 2
        }, f = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"], l = o.trim().toUpperCase();
        if (!s.test(l))
          return !1;
        var _ = l.slice(0, -1).replace(/[X,Y,Z]/g, function(p) {
          return c[p];
        });
        return l.endsWith(f[_ % 23]);
      },
      FI: function(o) {
        if ((0, r.default)(o), o.length !== 11 || !o.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/))
          return !1;
        var s = "0123456789ABCDEFHJKLMNPRSTUVWXY", c = parseInt(o.slice(0, 6), 10) * 1e3 + parseInt(o.slice(7, 10), 10), f = c % 31, l = s[f];
        return l === o.slice(10, 11);
      },
      IN: function(o) {
        var s = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/, c = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], f = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], l = o.trim();
        if (!s.test(l))
          return !1;
        var _ = 0, p = l.replace(/\s/g, "").split("").map(Number).reverse();
        return p.forEach(function($, h) {
          _ = c[_][f[h % 8][$]];
        }), _ === 0;
      },
      IR: function(o) {
        if (!o.match(/^\d{10}$/) || (o = "0000".concat(o).slice(o.length - 6), parseInt(o.slice(3, 9), 10) === 0)) return !1;
        for (var s = parseInt(o.slice(9, 10), 10), c = 0, f = 0; f < 9; f++)
          c += parseInt(o.slice(f, f + 1), 10) * (10 - f);
        return c %= 11, c < 2 && s === c || c >= 2 && s === 11 - c;
      },
      IT: function(o) {
        return o.length !== 9 || o === "CA00000AA" ? !1 : o.search(/C[A-Z]\d{5}[A-Z]{2}/i) > -1;
      },
      NO: function(o) {
        var s = o.trim();
        if (isNaN(Number(s)) || s.length !== 11 || s === "00000000000") return !1;
        var c = s.split("").map(Number), f = (11 - (3 * c[0] + 7 * c[1] + 6 * c[2] + 1 * c[3] + 8 * c[4] + 9 * c[5] + 4 * c[6] + 5 * c[7] + 2 * c[8]) % 11) % 11, l = (11 - (5 * c[0] + 4 * c[1] + 3 * c[2] + 2 * c[3] + 7 * c[4] + 6 * c[5] + 5 * c[6] + 4 * c[7] + 3 * c[8] + 2 * f) % 11) % 11;
        return !(f !== c[9] || l !== c[10]);
      },
      TH: function(o) {
        if (!o.match(/^[1-8]\d{12}$/)) return !1;
        for (var s = 0, c = 0; c < 12; c++)
          s += parseInt(o[c], 10) * (13 - c);
        return o[12] === ((11 - s % 11) % 10).toString();
      },
      LK: function(o) {
        var s = /^[1-9]\d{8}[vx]$/i, c = /^[1-9]\d{11}$/i;
        return o.length === 10 && s.test(o) ? !0 : !!(o.length === 12 && c.test(o));
      },
      "he-IL": function(o) {
        var s = /^\d{9}$/, c = o.trim();
        if (!s.test(c))
          return !1;
        for (var f = c, l = 0, _, p = 0; p < f.length; p++)
          _ = Number(f[p]) * (p % 2 + 1), l += _ > 9 ? _ - 9 : _;
        return l % 10 === 0;
      },
      "ar-LY": function(o) {
        var s = /^(1|2)\d{11}$/, c = o.trim();
        return !!s.test(c);
      },
      "ar-TN": function(o) {
        var s = /^\d{8}$/, c = o.trim();
        return !!s.test(c);
      },
      "zh-CN": function(o) {
        var s = [
          "11",
          // 北京
          "12",
          // 天津
          "13",
          // 河北
          "14",
          // 山西
          "15",
          // 内蒙古
          "21",
          // 辽宁
          "22",
          // 吉林
          "23",
          // 黑龙江
          "31",
          // 上海
          "32",
          // 江苏
          "33",
          // 浙江
          "34",
          // 安徽
          "35",
          // 福建
          "36",
          // 江西
          "37",
          // 山东
          "41",
          // 河南
          "42",
          // 湖北
          "43",
          // 湖南
          "44",
          // 广东
          "45",
          // 广西
          "46",
          // 海南
          "50",
          // 重庆
          "51",
          // 四川
          "52",
          // 贵州
          "53",
          // 云南
          "54",
          // 西藏
          "61",
          // 陕西
          "62",
          // 甘肃
          "63",
          // 青海
          "64",
          // 宁夏
          "65",
          // 新疆
          "71",
          // 台湾
          "81",
          // 香港
          "82",
          // 澳门
          "91"
          // 国外
        ], c = ["7", "9", "10", "5", "8", "4", "2", "1", "6", "3", "7", "9", "10", "5", "8", "4", "2"], f = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"], l = function(y) {
          return s.includes(y);
        }, _ = function(y) {
          var S = parseInt(y.substring(0, 4), 10), O = parseInt(y.substring(4, 6), 10), P = parseInt(y.substring(6), 10), b = new Date(S, O - 1, P);
          return b > /* @__PURE__ */ new Date() ? !1 : b.getFullYear() === S && b.getMonth() === O - 1 && b.getDate() === P;
        }, p = function(y) {
          for (var S = y.substring(0, 17), O = 0, P = 0; P < 17; P++)
            O += parseInt(S.charAt(P), 10) * parseInt(c[P], 10);
          var b = O % 11;
          return f[b];
        }, $ = function(y) {
          return p(y) === y.charAt(17).toUpperCase();
        }, h = function(y) {
          var S = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(y);
          if (!S) return !1;
          var O = y.substring(0, 2);
          if (S = l(O), !S) return !1;
          var P = "19".concat(y.substring(6, 12));
          return S = _(P), !!S;
        }, g = function(y) {
          var S = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(y);
          if (!S) return !1;
          var O = y.substring(0, 2);
          if (S = l(O), !S) return !1;
          var P = y.substring(6, 14);
          return S = _(P), S ? $(y) : !1;
        }, A = function(y) {
          var S = /^\d{15}|(\d{17}(\d|x|X))$/.test(y);
          return S ? y.length === 15 ? h(y) : g(y) : !1;
        };
        return A(o);
      },
      "zh-HK": function(o) {
        o = o.trim();
        var s = /^[A-Z]{1,2}[0-9]{6}((\([0-9A]\))|(\[[0-9A]\])|([0-9A]))$/, c = /^[0-9]$/;
        if (o = o.toUpperCase(), !s.test(o)) return !1;
        o = o.replace(/\[|\]|\(|\)/g, ""), o.length === 8 && (o = "3".concat(o));
        for (var f = 0, l = 0; l <= 7; l++) {
          var _ = void 0;
          c.test(o[l]) ? _ = o[l] : _ = (o[l].charCodeAt(0) - 55) % 11, f += _ * (9 - l);
        }
        f %= 11;
        var p;
        return f === 0 ? p = "0" : f === 1 ? p = "A" : p = String(11 - f), p === o[o.length - 1];
      },
      "zh-TW": function(o) {
        var s = {
          A: 10,
          B: 11,
          C: 12,
          D: 13,
          E: 14,
          F: 15,
          G: 16,
          H: 17,
          I: 34,
          J: 18,
          K: 19,
          L: 20,
          M: 21,
          N: 22,
          O: 35,
          P: 23,
          Q: 24,
          R: 25,
          S: 26,
          T: 27,
          U: 28,
          V: 29,
          W: 32,
          X: 30,
          Y: 31,
          Z: 33
        }, c = o.trim().toUpperCase();
        return /^[A-Z][0-9]{9}$/.test(c) ? Array.from(c).reduce(function(f, l, _) {
          if (_ === 0) {
            var p = s[l];
            return p % 10 * 9 + Math.floor(p / 10);
          }
          return _ === 9 ? (10 - f % 10 - Number(l)) % 10 === 0 : f + Number(l) * (9 - _);
        }, 0) : !1;
      },
      PK: function(o) {
        var s = /^[1-7][0-9]{4}-[0-9]{7}-[1-9]$/, c = o.trim();
        return s.test(c);
      }
    };
    function i(u, o) {
      if ((0, r.default)(u), o in a)
        return a[o](u);
      if (o === "any") {
        for (var s in a)
          if (a.hasOwnProperty(s)) {
            var c = a[s];
            if (c(u))
              return !0;
          }
        return !1;
      }
      throw new Error("Invalid locale '".concat(o, "'"));
    }
    t.exports = e.default, t.exports.default = e.default;
  }(hr, hr.exports)), hr.exports;
}
var n6 = /* @__PURE__ */ $2();
const d6 = /* @__PURE__ */ B(n6);
var v2 = "isIdentityCard";
function p2(t, e) {
  return typeof t == "string" && d6(t, e);
}
function a6(t, e) {
  return N({
    name: v2,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return p2(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a identity card number";
      }, e)
    }
  }, e);
}
var gr = { exports: {} }, la;
function h2() {
  return la || (la = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
    function a(i) {
      return (0, r.default)(i), d.test(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(gr, gr.exports)), gr.exports;
}
var i6 = /* @__PURE__ */ h2();
const u6 = /* @__PURE__ */ B(i6);
var g2 = "isISRC";
function y2(t) {
  return typeof t == "string" && u6(t);
}
function o6(t) {
  return N({
    name: g2,
    validator: {
      validate: function(e, r) {
        return y2(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be an ISRC";
      }, t)
    }
  }, t);
}
var yr = { exports: {} }, fa;
function m2() {
  return fa || (fa = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = A;
    var r = n(/* @__PURE__ */ D());
    function n(R) {
      return R && R.__esModule ? R : { default: R };
    }
    var d = "([A-Za-z]{3}(-[A-Za-z]{3}){0,2})", a = "(([a-zA-Z]{2,3}(-".concat(d, ")?)|([a-zA-Z]{5,8}))"), i = "([A-Za-z]{4})", u = "([A-Za-z]{2}|\\d{3})", o = "([A-Za-z0-9]{5,8}|(\\d[A-Z-a-z0-9]{3}))", s = "(\\d|[A-W]|[Y-Z]|[a-w]|[y-z])", c = "(".concat(s, "(-[A-Za-z0-9]{2,8})+)"), f = "(x(-[A-Za-z0-9]{1,8})+)", l = "((en-GB-oed)|(i-ami)|(i-bnn)|(i-default)|(i-enochian)|(i-hak)|(i-klingon)|(i-lux)|(i-mingo)|(i-navajo)|(i-pwn)|(i-tao)|(i-tay)|(i-tsu)|(sgn-BE-FR)|(sgn-BE-NL)|(sgn-CH-DE))", _ = "((art-lojban)|(cel-gaulish)|(no-bok)|(no-nyn)|(zh-guoyu)|(zh-hakka)|(zh-min)|(zh-min-nan)|(zh-xiang))", p = "(".concat(l, "|").concat(_, ")"), $ = "(-|_)", h = "".concat(a, "(").concat($).concat(i, ")?(").concat($).concat(u, ")?(").concat($).concat(o, ")*(").concat($).concat(c, ")*(").concat($).concat(f, ")?"), g = new RegExp("(^".concat(f, "$)|(^").concat(p, "$)|(^").concat(h, "$)"));
    function A(R) {
      return (0, r.default)(R), g.test(R);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(yr, yr.exports)), yr.exports;
}
var s6 = /* @__PURE__ */ m2();
const l6 = /* @__PURE__ */ B(s6);
var _2 = "isLocale";
function I2(t) {
  return typeof t == "string" && l6(t);
}
function f6(t) {
  return N({
    name: _2,
    validator: {
      validate: function(e, r) {
        return I2(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be locale";
      }, t)
    }
  }, t);
}
var mr = { exports: {} }, ca;
function A2() {
  return ca || (ca = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /(?:^magnet:\?|[^?&]&)xt(?:\.1)?=urn:(?:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?|btmh:1220[a-z0-9]{64})(?:$|&)/i;
    function a(i) {
      return (0, r.default)(i), i.indexOf("magnet:?") !== 0 ? !1 : d.test(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(mr, mr.exports)), mr.exports;
}
var c6 = /* @__PURE__ */ A2();
const $6 = /* @__PURE__ */ B(c6);
var S2 = "isMagnetURI";
function b2(t) {
  return typeof t == "string" && $6(t);
}
function v6(t) {
  return N({
    name: S2,
    validator: {
      validate: function(e, r) {
        return b2(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be magnet uri format";
      }, t)
    }
  }, t);
}
var _r = { exports: {} }, $a;
function M2() {
  return $a || ($a = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = u;
    var r = n(/* @__PURE__ */ D());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+_]{1,100}$/i, a = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i, i = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i;
    function u(o) {
      return (0, r.default)(o), d.test(o) || a.test(o) || i.test(o);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(_r, _r.exports)), _r.exports;
}
var p6 = /* @__PURE__ */ M2();
const h6 = /* @__PURE__ */ B(p6);
var E2 = "isMimeType";
function R2(t) {
  return typeof t == "string" && h6(t);
}
function g6(t) {
  return N({
    name: E2,
    validator: {
      validate: function(e, r) {
        return R2(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be MIME type format";
      }, t)
    }
  }, t);
}
var Ir = { exports: {} }, va;
function P2() {
  return va || (va = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^(0o)?[0-7]+$/i;
    function a(i) {
      return (0, r.default)(i), d.test(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Ir, Ir.exports)), Ir.exports;
}
var y6 = /* @__PURE__ */ P2();
const m6 = /* @__PURE__ */ B(y6);
var C2 = "isOctal";
function N2(t) {
  return typeof t == "string" && m6(t);
}
function _6(t) {
  return N({
    name: C2,
    validator: {
      validate: function(e, r) {
        return N2(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be valid octal number";
      }, t)
    }
  }, t);
}
var ke = {}, pa;
function O2() {
  if (pa) return ke;
  pa = 1, Object.defineProperty(ke, "__esModule", {
    value: !0
  }), ke.default = n, ke.locales = void 0;
  var t = e(/* @__PURE__ */ D());
  function e(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = {
    AM: /^[A-Z]{2}\d{7}$/,
    // ARMENIA
    AR: /^[A-Z]{3}\d{6}$/,
    // ARGENTINA
    AT: /^[A-Z]\d{7}$/,
    // AUSTRIA
    AU: /^[A-Z]\d{7}$/,
    // AUSTRALIA
    AZ: /^[A-Z]{1}\d{8}$/,
    // AZERBAIJAN
    BE: /^[A-Z]{2}\d{6}$/,
    // BELGIUM
    BG: /^\d{9}$/,
    // BULGARIA
    BR: /^[A-Z]{2}\d{6}$/,
    // BRAZIL
    BY: /^[A-Z]{2}\d{7}$/,
    // BELARUS
    CA: /^[A-Z]{2}\d{6}$/,
    // CANADA
    CH: /^[A-Z]\d{7}$/,
    // SWITZERLAND
    CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
    // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
    CY: /^[A-Z](\d{6}|\d{8})$/,
    // CYPRUS
    CZ: /^\d{8}$/,
    // CZECH REPUBLIC
    DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
    // GERMANY
    DK: /^\d{9}$/,
    // DENMARK
    DZ: /^\d{9}$/,
    // ALGERIA
    EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
    // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
    ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
    // SPAIN
    FI: /^[A-Z]{2}\d{7}$/,
    // FINLAND
    FR: /^\d{2}[A-Z]{2}\d{5}$/,
    // FRANCE
    GB: /^\d{9}$/,
    // UNITED KINGDOM
    GR: /^[A-Z]{2}\d{7}$/,
    // GREECE
    HR: /^\d{9}$/,
    // CROATIA
    HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
    // HUNGARY
    IE: /^[A-Z0-9]{2}\d{7}$/,
    // IRELAND
    IN: /^[A-Z]{1}-?\d{7}$/,
    // INDIA
    ID: /^[A-C]\d{7}$/,
    // INDONESIA
    IR: /^[A-Z]\d{8}$/,
    // IRAN
    IS: /^(A)\d{7}$/,
    // ICELAND
    IT: /^[A-Z0-9]{2}\d{7}$/,
    // ITALY
    JM: /^[Aa]\d{7}$/,
    // JAMAICA
    JP: /^[A-Z]{2}\d{7}$/,
    // JAPAN
    KR: /^[MS]\d{8}$/,
    // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
    KZ: /^[a-zA-Z]\d{7}$/,
    // KAZAKHSTAN
    LI: /^[a-zA-Z]\d{5}$/,
    // LIECHTENSTEIN
    LT: /^[A-Z0-9]{8}$/,
    // LITHUANIA
    LU: /^[A-Z0-9]{8}$/,
    // LUXEMBURG
    LV: /^[A-Z0-9]{2}\d{7}$/,
    // LATVIA
    LY: /^[A-Z0-9]{8}$/,
    // LIBYA
    MT: /^\d{7}$/,
    // MALTA
    MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
    // MOZAMBIQUE
    MY: /^[AHK]\d{8}$/,
    // MALAYSIA
    MX: /^\d{10,11}$/,
    // MEXICO
    NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
    // NETHERLANDS
    NZ: /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])\d{6}$/,
    // NEW ZEALAND
    PH: /^([A-Z](\d{6}|\d{7}[A-Z]))|([A-Z]{2}(\d{6}|\d{7}))$/,
    // PHILIPPINES
    PK: /^[A-Z]{2}\d{7}$/,
    // PAKISTAN
    PL: /^[A-Z]{2}\d{7}$/,
    // POLAND
    PT: /^[A-Z]\d{6}$/,
    // PORTUGAL
    RO: /^\d{8,9}$/,
    // ROMANIA
    RU: /^\d{9}$/,
    // RUSSIAN FEDERATION
    SE: /^\d{8}$/,
    // SWEDEN
    SL: /^(P)[A-Z]\d{7}$/,
    // SLOVENIA
    SK: /^[0-9A-Z]\d{7}$/,
    // SLOVAKIA
    TH: /^[A-Z]{1,2}\d{6,7}$/,
    // THAILAND
    TR: /^[A-Z]\d{8}$/,
    // TURKEY
    UA: /^[A-Z]{2}\d{6}$/,
    // UKRAINE
    US: /^\d{9}$/,
    // UNITED STATES
    ZA: /^[TAMD]\d{8}$/
    // SOUTH AFRICA
  };
  ke.locales = Object.keys(r);
  function n(d, a) {
    (0, t.default)(d);
    var i = d.replace(/\s/g, "").toUpperCase();
    return a.toUpperCase() in r && r[a].test(i);
  }
  return ke;
}
var I6 = /* @__PURE__ */ O2();
const A6 = /* @__PURE__ */ B(I6);
var x2 = "isPassportNumber";
function D2(t, e) {
  return typeof t == "string" && A6(t, e);
}
function S6(t, e) {
  return N({
    name: x2,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return D2(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be valid passport number";
      }, e)
    }
  }, e);
}
var He = {}, ha;
function T2() {
  if (ha) return He;
  ha = 1, Object.defineProperty(He, "__esModule", {
    value: !0
  }), He.default = u, He.locales = void 0;
  var t = e(/* @__PURE__ */ D());
  function e(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = /^\d{3}$/, n = /^\d{4}$/, d = /^\d{5}$/, a = /^\d{6}$/, i = {
    AD: /^AD\d{3}$/,
    AT: n,
    AU: n,
    AZ: /^AZ\d{4}$/,
    BA: /^([7-8]\d{4}$)/,
    BE: n,
    BG: n,
    BR: /^\d{5}-?\d{3}$/,
    BY: /^2[1-4]\d{4}$/,
    CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
    CH: n,
    CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
    CO: /^(05|08|11|13|15|17|18|19|20|23|25|27|41|44|47|50|52|54|63|66|68|70|73|76|81|85|86|88|91|94|95|97|99)(\d{4})$/,
    CZ: /^\d{3}\s?\d{2}$/,
    DE: d,
    DK: n,
    DO: d,
    DZ: d,
    EE: d,
    ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
    FI: d,
    FR: /^\d{2}\s?\d{3}$/,
    GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
    GR: /^\d{3}\s?\d{2}$/,
    HR: /^([1-5]\d{4}$)/,
    HT: /^HT\d{4}$/,
    HU: n,
    ID: d,
    IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
    IL: /^(\d{5}|\d{7})$/,
    IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
    IR: /^(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}$/,
    IS: r,
    IT: d,
    JP: /^\d{3}\-\d{4}$/,
    KE: d,
    KR: /^(\d{5}|\d{6})$/,
    LI: /^(948[5-9]|949[0-7])$/,
    LT: /^LT\-\d{5}$/,
    LU: n,
    LV: /^LV\-\d{4}$/,
    LK: d,
    MG: r,
    MX: d,
    MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
    MY: d,
    NL: /^[1-9]\d{3}\s?(?!sa|sd|ss)[a-z]{2}$/i,
    NO: n,
    NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
    NZ: n,
    PL: /^\d{2}\-\d{3}$/,
    PR: /^00[679]\d{2}([ -]\d{4})?$/,
    PT: /^\d{4}\-\d{3}?$/,
    RO: a,
    RU: a,
    SA: d,
    SE: /^[1-9]\d{2}\s?\d{2}$/,
    SG: a,
    SI: n,
    SK: /^\d{3}\s?\d{2}$/,
    TH: d,
    TN: n,
    TW: /^\d{3}(\d{2})?$/,
    UA: d,
    US: /^\d{5}(-\d{4})?$/,
    ZA: n,
    ZM: d
  };
  He.locales = Object.keys(i);
  function u(o, s) {
    if ((0, t.default)(o), s in i)
      return i[s].test(o);
    if (s === "any") {
      for (var c in i)
        if (i.hasOwnProperty(c)) {
          var f = i[c];
          if (f.test(o))
            return !0;
        }
      return !1;
    }
    throw new Error("Invalid locale '".concat(s, "'"));
  }
  return He;
}
var b6 = /* @__PURE__ */ T2();
const M6 = /* @__PURE__ */ B(b6);
var L2 = "isPostalCode";
function F2(t, e) {
  return typeof t == "string" && M6(t, e);
}
function E6(t, e) {
  return N({
    name: L2,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return F2(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a postal code";
      }, e)
    }
  }, e);
}
var Ar = { exports: {} }, ga;
function w2() {
  return ga || (ga = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = g;
    var r = n(/* @__PURE__ */ D());
    function n(A) {
      return A && A.__esModule ? A : { default: A };
    }
    var d = /[0-9]{4}/, a = /(0[1-9]|1[0-2])/, i = /([12]\d|0[1-9]|3[01])/, u = /([01][0-9]|2[0-3])/, o = /[0-5][0-9]/, s = /([0-5][0-9]|60)/, c = /(\.[0-9]+)?/, f = new RegExp("[-+]".concat(u.source, ":").concat(o.source)), l = new RegExp("([zZ]|".concat(f.source, ")")), _ = new RegExp("".concat(u.source, ":").concat(o.source, ":").concat(s.source).concat(c.source)), p = new RegExp("".concat(d.source, "-").concat(a.source, "-").concat(i.source)), $ = new RegExp("".concat(_.source).concat(l.source)), h = new RegExp("^".concat(p.source, "[ tT]").concat($.source, "$"));
    function g(A) {
      return (0, r.default)(A), h.test(A);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Ar, Ar.exports)), Ar.exports;
}
var R6 = /* @__PURE__ */ w2();
const P6 = /* @__PURE__ */ B(R6);
var B2 = "isRFC3339";
function U2(t) {
  return typeof t == "string" && P6(t);
}
function C6(t) {
  return N({
    name: B2,
    validator: {
      validate: function(e, r) {
        return U2(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be RFC 3339 date";
      }, t)
    }
  }, t);
}
var Sr = { exports: {} }, ya;
function q2() {
  return ya || (ya = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = c;
    var r = n(/* @__PURE__ */ D());
    function n(f) {
      return f && f.__esModule ? f : { default: f };
    }
    function d(f) {
      "@babel/helpers - typeof";
      return d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
        return typeof l;
      } : function(l) {
        return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
      }, d(f);
    }
    var a = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/, i = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, u = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)$/, o = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, s = /^rgba?/;
    function c(f, l) {
      (0, r.default)(f);
      var _ = !1, p = !0;
      if (d(l) !== "object" ? arguments.length >= 2 && (p = arguments[1]) : (_ = l.allowSpaces !== void 0 ? l.allowSpaces : _, p = l.includePercentValues !== void 0 ? l.includePercentValues : p), _) {
        if (!s.test(f))
          return !1;
        f = f.replace(/\s/g, "");
      }
      return p ? a.test(f) || i.test(f) || u.test(f) || o.test(f) : a.test(f) || i.test(f);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Sr, Sr.exports)), Sr.exports;
}
var N6 = /* @__PURE__ */ q2();
const O6 = /* @__PURE__ */ B(N6);
var Z2 = "isRgbColor";
function k2(t, e) {
  return typeof t == "string" && O6(t, e);
}
function x6(t, e) {
  return N({
    name: Z2,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return k2(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be RGB color";
      }, e)
    }
  }, e);
}
var br = { exports: {} }, Mr = { exports: {} }, ma;
function D6() {
  return ma || (ma = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = r;
    function r(n, d) {
      var a = n.join("");
      return new RegExp(a, d);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Mr, Mr.exports)), Mr.exports;
}
var _a;
function H2() {
  return _a || (_a = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ D6());
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = (0, n.default)(["^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)", "(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))", "?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$"], "i");
    function i(u) {
      return (0, r.default)(u), a.test(u);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(br, br.exports)), br.exports;
}
var T6 = /* @__PURE__ */ H2();
const L6 = /* @__PURE__ */ B(T6);
var G2 = "isSemVer";
function j2(t) {
  return typeof t == "string" && L6(t);
}
function F6(t) {
  return N({
    name: G2,
    validator: {
      validate: function(e, r) {
        return j2(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a Semantic Versioning Specification";
      }, t)
    }
  }, t);
}
var Er = { exports: {} }, Rr = { exports: {} }, Ia;
function g0() {
  return Ia || (Ia = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a), a = Date.parse(a), isNaN(a) ? null : new Date(a);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Rr, Rr.exports)), Rr.exports;
}
var Pr = { exports: {} }, Aa;
function w6() {
  return Aa || (Aa = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, i) {
      return (0, r.default)(a), parseInt(a, i || 10);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Pr, Pr.exports)), Pr.exports;
}
var Cr = { exports: {} }, Sa;
function B6() {
  return Sa || (Sa = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, i) {
      return (0, r.default)(a), i ? a === "1" || /^true$/i.test(a) : a !== "0" && !/^false$/i.test(a) && a !== "";
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Cr, Cr.exports)), Cr.exports;
}
var Nr = { exports: {} }, ba;
function U6() {
  return ba || (ba = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, i) {
      return (0, r.default)(a), a === i;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Nr, Nr.exports)), Nr.exports;
}
var Or = { exports: {} }, Ma;
function q6() {
  return Ma || (Ma = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = o;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ st());
    function d(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var a = /^\d{1,3}$/, i = 32, u = 128;
    function o(s) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      (0, r.default)(s);
      var f = s.split("/");
      if (f.length !== 2 || !a.test(f[1]) || f[1].length > 1 && f[1].startsWith("0"))
        return !1;
      var l = (0, n.default)(f[0], c);
      if (!l)
        return !1;
      var _ = null;
      switch (String(c)) {
        case "4":
          _ = i;
          break;
        case "6":
          _ = u;
          break;
        default:
          _ = (0, n.default)(f[0], "6") ? u : i;
      }
      return f[1] <= _ && f[1] >= 0;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Or, Or.exports)), Or.exports;
}
var xr = { exports: {} }, Ea;
function V2() {
  return Ea || (Ea = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = p;
    var r = n(/* @__PURE__ */ ee());
    function n($) {
      return $ && $.__esModule ? $ : { default: $ };
    }
    function d($, h) {
      return u($) || i($, h) || s($, h) || a();
    }
    function a() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function i($, h) {
      var g = $ == null ? null : typeof Symbol < "u" && $[Symbol.iterator] || $["@@iterator"];
      if (g != null) {
        var A, R, y, S, O = [], P = !0, b = !1;
        try {
          if (y = (g = g.call($)).next, h !== 0) for (; !(P = (A = y.call(g)).done) && (O.push(A.value), O.length !== h); P = !0) ;
        } catch (I) {
          b = !0, R = I;
        } finally {
          try {
            if (!P && g.return != null && (S = g.return(), Object(S) !== S)) return;
          } finally {
            if (b) throw R;
          }
        }
        return O;
      }
    }
    function u($) {
      if (Array.isArray($)) return $;
    }
    function o($, h) {
      var g = typeof Symbol < "u" && $[Symbol.iterator] || $["@@iterator"];
      if (!g) {
        if (Array.isArray($) || (g = s($)) || h) {
          g && ($ = g);
          var A = 0, R = function() {
          };
          return { s: R, n: function() {
            return A >= $.length ? { done: !0 } : { done: !1, value: $[A++] };
          }, e: function(b) {
            throw b;
          }, f: R };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var y, S = !0, O = !1;
      return { s: function() {
        g = g.call($);
      }, n: function() {
        var b = g.next();
        return S = b.done, b;
      }, e: function(b) {
        O = !0, y = b;
      }, f: function() {
        try {
          S || g.return == null || g.return();
        } finally {
          if (O) throw y;
        }
      } };
    }
    function s($, h) {
      if ($) {
        if (typeof $ == "string") return c($, h);
        var g = {}.toString.call($).slice(8, -1);
        return g === "Object" && $.constructor && (g = $.constructor.name), g === "Map" || g === "Set" ? Array.from($) : g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g) ? c($, h) : void 0;
      }
    }
    function c($, h) {
      (h == null || h > $.length) && (h = $.length);
      for (var g = 0, A = Array(h); g < h; g++) A[g] = $[g];
      return A;
    }
    var f = {
      format: "YYYY/MM/DD",
      delimiters: ["/", "-"],
      strictMode: !1
    };
    function l($) {
      return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test($);
    }
    function _($, h) {
      for (var g = [], A = Math.max($.length, h.length), R = 0; R < A; R++)
        g.push([$[R], h[R]]);
      return g;
    }
    function p($, h) {
      if (typeof h == "string" ? h = (0, r.default)({
        format: h
      }, f) : h = (0, r.default)(h, f), typeof $ == "string" && l(h.format)) {
        if (h.strictMode && $.length !== h.format.length) return !1;
        var g = h.delimiters.find(function(W) {
          return h.format.indexOf(W) !== -1;
        }), A = h.strictMode ? g : h.delimiters.find(function(W) {
          return $.indexOf(W) !== -1;
        }), R = _($.split(A), h.format.toLowerCase().split(g)), y = {}, S = o(R), O;
        try {
          for (S.s(); !(O = S.n()).done; ) {
            var P = d(O.value, 2), b = P[0], I = P[1];
            if (!b || !I || b.length !== I.length)
              return !1;
            y[I.charAt(0)] = b;
          }
        } catch (W) {
          S.e(W);
        } finally {
          S.f();
        }
        var E = y.y;
        if (E.startsWith("-"))
          return !1;
        if (y.y.length === 2) {
          var T = parseInt(y.y, 10);
          if (isNaN(T))
            return !1;
          var U = (/* @__PURE__ */ new Date()).getFullYear() % 100;
          T < U ? E = "20".concat(y.y) : E = "19".concat(y.y);
        }
        var Z = y.m;
        y.m.length === 1 && (Z = "0".concat(y.m));
        var H = y.d;
        return y.d.length === 1 && (H = "0".concat(y.d)), new Date("".concat(E, "-").concat(Z, "-").concat(H, "T00:00:00.000Z")).getUTCDate() === +y.d;
      }
      return h.strictMode ? !1 : Object.prototype.toString.call($) === "[object Date]" && isFinite($);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(xr, xr.exports)), xr.exports;
}
var Dr = { exports: {} }, Ra;
function Z6() {
  return Ra || (Ra = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = n(/* @__PURE__ */ ee());
    function n(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var d = {
      hourFormat: "hour24",
      mode: "default"
    }, a = {
      hour24: {
        default: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
        withSeconds: /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/
      },
      hour12: {
        default: /^(0?[1-9]|1[0-2]):([0-5][0-9]) (A|P)M$/,
        withSeconds: /^(0?[1-9]|1[0-2]):([0-5][0-9]):([0-5][0-9]) (A|P)M$/
      }
    };
    function i(u, o) {
      return o = (0, r.default)(o, d), typeof u != "string" ? !1 : a[o.hourFormat][o.mode].test(u);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Dr, Dr.exports)), Dr.exports;
}
var Tr = { exports: {} }, Pa;
function k6() {
  return Pa || (Pa = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^(?!(1[3-9])|(20)|(3[3-9])|(4[0-9])|(5[0-9])|(60)|(7[3-9])|(8[1-9])|(9[0-2])|(9[3-9]))[0-9]{9}$/;
    function a(i) {
      if ((0, r.default)(i), !d.test(i)) return !1;
      for (var u = 0, o = 0; o < i.length; o++)
        o % 3 === 0 ? u += i[o] * 3 : o % 3 === 1 ? u += i[o] * 7 : u += i[o] * 1;
      return u % 10 === 0;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Tr, Tr.exports)), Tr.exports;
}
var Lr = { exports: {} }, Ca;
function H6() {
  return Ca || (Ca = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = n(/* @__PURE__ */ D());
    function n(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var d = /^[0-9]{15}$/, a = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
    function i(u, o) {
      (0, r.default)(u), o = o || {};
      var s = d;
      if (o.allow_hyphens && (s = a), !s.test(u))
        return !1;
      u = u.replace(/-/g, "");
      for (var c = 0, f = 2, l = 14, _ = 0; _ < l; _++) {
        var p = u.substring(l - _ - 1, l - _), $ = parseInt(p, 10) * f;
        $ >= 10 ? c += $ % 10 + 1 : c += $, f === 1 ? f += 1 : f -= 1;
      }
      var h = (10 - c % 10) % 10;
      return h === parseInt(u.substring(14, 15), 10);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Lr, Lr.exports)), Lr.exports;
}
var Fr = { exports: {} }, Na;
function G6() {
  return Na || (Na = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^[a-f0-9]{32}$/;
    function a(i) {
      return (0, r.default)(i), d.test(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Fr, Fr.exports)), Fr.exports;
}
var wr = { exports: {} }, Oa;
function j6() {
  return Oa || (Oa = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ ee());
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = {
      ignore_whitespace: !1
    };
    function i(u, o) {
      return (0, r.default)(u), o = (0, n.default)(o, a), (o.ignore_whitespace ? u.trim().length : u.length) === 0;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(wr, wr.exports)), wr.exports;
}
var Br = { exports: {} }, xa;
function V6() {
  return xa || (xa = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a), /^[0-7][0-9A-HJKMNP-TV-Z]{25}$/i.test(a);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Br, Br.exports)), Br.exports;
}
var Ur = { exports: {} }, Da;
function W6() {
  return Da || (Da = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ g0());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, i) {
      var u = (i == null ? void 0 : i.comparisonDate) || i || Date().toString(), o = (0, r.default)(u), s = (0, r.default)(a);
      return !!(s && o && s > o);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Ur, Ur.exports)), Ur.exports;
}
var qr = { exports: {} }, Ta;
function K6() {
  return Ta || (Ta = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ g0());
    function d(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function a(i) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : String(/* @__PURE__ */ new Date());
      (0, r.default)(i);
      var o = (0, n.default)(u), s = (0, n.default)(i);
      return !!(s && o && s < o);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(qr, qr.exports)), qr.exports;
}
var Zr = { exports: {} }, La;
function Y6() {
  return La || (La = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ $u());
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function a(u) {
      "@babel/helpers - typeof";
      return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
        return typeof o;
      } : function(o) {
        return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, a(u);
    }
    function i(u, o) {
      (0, r.default)(u);
      var s;
      if (Object.prototype.toString.call(o) === "[object Array]") {
        var c = [];
        for (s in o)
          ({}).hasOwnProperty.call(o, s) && (c[s] = (0, n.default)(o[s]));
        return c.indexOf(u) >= 0;
      } else {
        if (a(o) === "object")
          return o.hasOwnProperty(u);
        if (o && typeof o.indexOf == "function")
          return o.indexOf(u) >= 0;
      }
      return !1;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Zr, Zr.exports)), Zr.exports;
}
var kr = { exports: {} }, Ee = {}, Fa;
function W2() {
  if (Fa) return Ee;
  Fa = 1, Object.defineProperty(Ee, "__esModule", {
    value: !0
  }), Ee.iso7064Check = t, Ee.luhnCheck = e, Ee.reverseMultiplyAndSum = r, Ee.verhoeffCheck = n;
  function t(d) {
    for (var a = 10, i = 0; i < d.length - 1; i++)
      a = (parseInt(d[i], 10) + a) % 10 === 0 ? 10 * 2 % 11 : (parseInt(d[i], 10) + a) % 10 * 2 % 11;
    return a = a === 1 ? 0 : 11 - a, a === parseInt(d[10], 10);
  }
  function e(d) {
    for (var a = 0, i = !1, u = d.length - 1; u >= 0; u--) {
      if (i) {
        var o = parseInt(d[u], 10) * 2;
        o > 9 ? a += o.toString().split("").map(function(s) {
          return parseInt(s, 10);
        }).reduce(function(s, c) {
          return s + c;
        }, 0) : a += o;
      } else
        a += parseInt(d[u], 10);
      i = !i;
    }
    return a % 10 === 0;
  }
  function r(d, a) {
    for (var i = 0, u = 0; u < d.length; u++)
      i += d[u] * (a - u);
    return i;
  }
  function n(d) {
    for (var a = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], i = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], u = d.split("").reverse().join(""), o = 0, s = 0; s < u.length; s++)
      o = a[o][i[s % 8][parseInt(u[s], 10)]];
    return o === 0;
  }
  return Ee;
}
var wa;
function K2() {
  return wa || (wa = 1, function(t, e) {
    function r(v) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
        return typeof m;
      } : function(m) {
        return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
      }, r(v);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = xn;
    var n = o(/* @__PURE__ */ D()), d = u(/* @__PURE__ */ W2()), a = o(/* @__PURE__ */ V2());
    function i(v) {
      if (typeof WeakMap != "function") return null;
      var m = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap();
      return (i = function(x) {
        return x ? M : m;
      })(v);
    }
    function u(v, m) {
      if (v && v.__esModule) return v;
      if (v === null || r(v) != "object" && typeof v != "function") return { default: v };
      var M = i(m);
      if (M && M.has(v)) return M.get(v);
      var F = { __proto__: null }, x = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var w in v) if (w !== "default" && {}.hasOwnProperty.call(v, w)) {
        var q = x ? Object.getOwnPropertyDescriptor(v, w) : null;
        q && (q.get || q.set) ? Object.defineProperty(F, w, q) : F[w] = v[w];
      }
      return F.default = v, M && M.set(v, F), F;
    }
    function o(v) {
      return v && v.__esModule ? v : { default: v };
    }
    function s(v) {
      return _(v) || l(v) || f(v) || c();
    }
    function c() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function f(v, m) {
      if (v) {
        if (typeof v == "string") return p(v, m);
        var M = {}.toString.call(v).slice(8, -1);
        return M === "Object" && v.constructor && (M = v.constructor.name), M === "Map" || M === "Set" ? Array.from(v) : M === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(M) ? p(v, m) : void 0;
      }
    }
    function l(v) {
      if (typeof Symbol < "u" && v[Symbol.iterator] != null || v["@@iterator"] != null) return Array.from(v);
    }
    function _(v) {
      if (Array.isArray(v)) return p(v);
    }
    function p(v, m) {
      (m == null || m > v.length) && (m = v.length);
      for (var M = 0, F = Array(m); M < m; M++) F[M] = v[M];
      return F;
    }
    function $(v) {
      var m = v.slice(0, 2), M = parseInt(v.slice(2, 4), 10);
      M > 40 ? (M -= 40, m = "20".concat(m)) : M > 20 ? (M -= 20, m = "18".concat(m)) : m = "19".concat(m), M < 10 && (M = "0".concat(M));
      var F = "".concat(m, "/").concat(M, "/").concat(v.slice(4, 6));
      if (!(0, a.default)(F, "YYYY/MM/DD"))
        return !1;
      for (var x = v.split("").map(function(G) {
        return parseInt(G, 10);
      }), w = [2, 4, 8, 5, 10, 9, 7, 3, 6], q = 0, k = 0; k < w.length; k++)
        q += x[k] * w[k];
      return q = q % 11 === 10 ? 0 : q % 11, q === x[9];
    }
    function h(v) {
      var m = v.split(""), M = m.filter(function(x, w) {
        return w % 2;
      }).map(function(x) {
        return Number(x) * 2;
      }).join("").split(""), F = m.filter(function(x, w) {
        return !(w % 2);
      }).concat(M).map(function(x) {
        return Number(x);
      }).reduce(function(x, w) {
        return x + w;
      });
      return F % 10 === 0;
    }
    function g(v) {
      v = v.replace(/\W/, "");
      var m = parseInt(v.slice(0, 2), 10);
      if (v.length === 10)
        m < 54 ? m = "20".concat(m) : m = "19".concat(m);
      else {
        if (v.slice(6) === "000")
          return !1;
        if (m < 54)
          m = "19".concat(m);
        else
          return !1;
      }
      m.length === 3 && (m = [m.slice(0, 2), "0", m.slice(2)].join(""));
      var M = parseInt(v.slice(2, 4), 10);
      if (M > 50 && (M -= 50), M > 20) {
        if (parseInt(m, 10) < 2004)
          return !1;
        M -= 20;
      }
      M < 10 && (M = "0".concat(M));
      var F = "".concat(m, "/").concat(M, "/").concat(v.slice(4, 6));
      if (!(0, a.default)(F, "YYYY/MM/DD"))
        return !1;
      if (v.length === 10 && parseInt(v, 10) % 11 !== 0) {
        var x = parseInt(v.slice(0, 9), 10) % 11;
        if (parseInt(m, 10) < 1986 && x === 10) {
          if (parseInt(v.slice(9), 10) !== 0)
            return !1;
        } else
          return !1;
      }
      return !0;
    }
    function A(v) {
      return d.luhnCheck(v);
    }
    function R(v) {
      for (var m = v.split("").map(function(G) {
        return parseInt(G, 10);
      }), M = [], F = 0; F < m.length - 1; F++) {
        M.push("");
        for (var x = 0; x < m.length - 1; x++)
          m[F] === m[x] && (M[F] += x);
      }
      if (M = M.filter(function(G) {
        return G.length > 1;
      }), M.length !== 2 && M.length !== 3)
        return !1;
      if (M[0].length === 3) {
        for (var w = M[0].split("").map(function(G) {
          return parseInt(G, 10);
        }), q = 0, k = 0; k < w.length - 1; k++)
          w[k] + 1 === w[k + 1] && (q += 1);
        if (q === 2)
          return !1;
      }
      return d.iso7064Check(v);
    }
    function y(v) {
      v = v.replace(/\W/, "");
      var m = parseInt(v.slice(4, 6), 10), M = v.slice(6, 7);
      switch (M) {
        case "0":
        case "1":
        case "2":
        case "3":
          m = "19".concat(m);
          break;
        case "4":
        case "9":
          m < 37 ? m = "20".concat(m) : m = "19".concat(m);
          break;
        default:
          if (m < 37)
            m = "20".concat(m);
          else if (m > 58)
            m = "18".concat(m);
          else
            return !1;
          break;
      }
      m.length === 3 && (m = [m.slice(0, 2), "0", m.slice(2)].join(""));
      var F = "".concat(m, "/").concat(v.slice(2, 4), "/").concat(v.slice(0, 2));
      if (!(0, a.default)(F, "YYYY/MM/DD"))
        return !1;
      for (var x = v.split("").map(function(G) {
        return parseInt(G, 10);
      }), w = 0, q = 4, k = 0; k < 9; k++)
        w += x[k] * q, q -= 1, q === 1 && (q = 7);
      return w %= 11, w === 1 ? !1 : w === 0 ? x[9] === 0 : x[9] === 11 - w;
    }
    function S(v) {
      for (var m = v.slice(0, 8).split("").map(function(w) {
        return parseInt(w, 10);
      }), M = 0, F = 1; F < m.length; F += 2)
        M += m[F];
      for (var x = 0; x < m.length; x += 2)
        m[x] < 2 ? M += 1 - m[x] : (M += 2 * (m[x] - 2) + 5, m[x] > 4 && (M += 2));
      return String.fromCharCode(M % 26 + 65) === v.charAt(8);
    }
    function O(v) {
      for (var m = v.split("").map(function(x) {
        return parseInt(x, 10);
      }), M = 0, F = 0; F < 8; F++)
        M += m[F] * Math.pow(2, 8 - F);
      return M % 11 % 10 === m[8];
    }
    function P(v) {
      var m = d.reverseMultiplyAndSum(v.split("").slice(0, 7).map(function(M) {
        return parseInt(M, 10);
      }), 8);
      return v.length === 9 && v[8] !== "W" && (m += (v[8].charCodeAt(0) - 64) * 9), m %= 23, m === 0 ? v[7].toUpperCase() === "W" : v[7].toUpperCase() === String.fromCharCode(64 + m);
    }
    var b = {
      andover: ["10", "12"],
      atlanta: ["60", "67"],
      austin: ["50", "53"],
      brookhaven: ["01", "02", "03", "04", "05", "06", "11", "13", "14", "16", "21", "22", "23", "25", "34", "51", "52", "54", "55", "56", "57", "58", "59", "65"],
      cincinnati: ["30", "32", "35", "36", "37", "38", "61"],
      fresno: ["15", "24"],
      internet: ["20", "26", "27", "45", "46", "47"],
      kansas: ["40", "44"],
      memphis: ["94", "95"],
      ogden: ["80", "90"],
      philadelphia: ["33", "39", "41", "42", "43", "46", "48", "62", "63", "64", "66", "68", "71", "72", "73", "74", "75", "76", "77", "81", "82", "83", "84", "85", "86", "87", "88", "91", "92", "93", "98", "99"],
      sba: ["31"]
    };
    function I() {
      var v = [];
      for (var m in b)
        b.hasOwnProperty(m) && v.push.apply(v, s(b[m]));
      return v;
    }
    function E(v) {
      return I().indexOf(v.slice(0, 2)) !== -1;
    }
    function T(v) {
      for (var m = 0, M = v.split(""), F = parseInt(M.pop(), 10), x = 0; x < M.length; x++)
        m += M[9 - x] * (2 + x % 6);
      var w = 11 - m % 11;
      return w === 11 ? w = 0 : w === 10 && (w = 9), F === w;
    }
    function U(v) {
      var m = v.toUpperCase().split("");
      if (isNaN(parseInt(m[0], 10)) && m.length > 1) {
        var M = 0;
        switch (m[0]) {
          case "Y":
            M = 1;
            break;
          case "Z":
            M = 2;
            break;
        }
        m.splice(0, 1, M);
      } else
        for (; m.length < 9; )
          m.unshift(0);
      var F = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"];
      m = m.join("");
      var x = parseInt(m.slice(0, 8), 10) % 23;
      return m[8] === F[x];
    }
    function Z(v) {
      var m = v.slice(1, 3), M = v.slice(0, 1);
      switch (M) {
        case "1":
        case "2":
          m = "18".concat(m);
          break;
        case "3":
        case "4":
          m = "19".concat(m);
          break;
        default:
          m = "20".concat(m);
          break;
      }
      var F = "".concat(m, "/").concat(v.slice(3, 5), "/").concat(v.slice(5, 7));
      if (!(0, a.default)(F, "YYYY/MM/DD"))
        return !1;
      for (var x = v.split("").map(function(z) {
        return parseInt(z, 10);
      }), w = 0, q = 1, k = 0; k < 10; k++)
        w += x[k] * q, q += 1, q === 10 && (q = 1);
      if (w % 11 === 10) {
        w = 0, q = 3;
        for (var G = 0; G < 10; G++)
          w += x[G] * q, q += 1, q === 10 && (q = 1);
        if (w % 11 === 10)
          return x[10] === 0;
      }
      return w % 11 === x[10];
    }
    function H(v) {
      var m = v.slice(4, 6), M = v.slice(6, 7);
      switch (M) {
        case "+":
          m = "18".concat(m);
          break;
        case "-":
          m = "19".concat(m);
          break;
        default:
          m = "20".concat(m);
          break;
      }
      var F = "".concat(m, "/").concat(v.slice(2, 4), "/").concat(v.slice(0, 2));
      if (!(0, a.default)(F, "YYYY/MM/DD"))
        return !1;
      var x = parseInt(v.slice(0, 6) + v.slice(7, 10), 10) % 31;
      if (x < 10)
        return x === parseInt(v.slice(10), 10);
      x -= 10;
      var w = ["A", "B", "C", "D", "E", "F", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y"];
      return w[x] === v.slice(10);
    }
    function W(v) {
      if (v.slice(2, 4) !== "00" || v.slice(4, 6) !== "00") {
        var m = "".concat(v.slice(0, 2), "/").concat(v.slice(2, 4), "/").concat(v.slice(4, 6));
        if (!(0, a.default)(m, "YY/MM/DD"))
          return !1;
      }
      var M = 97 - parseInt(v.slice(0, 9), 10) % 97, F = parseInt(v.slice(9, 11), 10);
      return !(M !== F && (M = 97 - parseInt("2".concat(v.slice(0, 9)), 10) % 97, M !== F));
    }
    function re(v) {
      v = v.replace(/\s/g, "");
      var m = parseInt(v.slice(0, 10), 10) % 511, M = parseInt(v.slice(10, 13), 10);
      return m === M;
    }
    function _e(v) {
      var m = "".concat(v.slice(0, 4), "/").concat(v.slice(4, 6), "/").concat(v.slice(6, 8));
      return !(0, a.default)(m, "YYYY/MM/DD") || !d.luhnCheck(v.slice(0, 12)) ? !1 : d.verhoeffCheck("".concat(v.slice(0, 11)).concat(v[12]));
    }
    function _n(v) {
      return d.iso7064Check(v);
    }
    function In(v) {
      for (var m = v.split("").map(function(x) {
        return parseInt(x, 10);
      }), M = 8, F = 1; F < 9; F++)
        M += m[F] * (F + 1);
      return M % 11 === m[9];
    }
    function lt(v) {
      for (var m = !1, M = !1, F = 0; F < 3; F++)
        if (!m && /[AEIOU]/.test(v[F]))
          m = !0;
        else if (!M && m && v[F] === "X")
          M = !0;
        else if (F > 0 && (m && !M && !/[AEIOU]/.test(v[F]) || M && !/X/.test(v[F])))
          return !1;
      return !0;
    }
    function ft(v) {
      var m = v.toUpperCase().split("");
      if (!lt(m.slice(0, 3)) || !lt(m.slice(3, 6)))
        return !1;
      for (var M = [6, 7, 9, 10, 12, 13, 14], F = {
        L: "0",
        M: "1",
        N: "2",
        P: "3",
        Q: "4",
        R: "5",
        S: "6",
        T: "7",
        U: "8",
        V: "9"
      }, x = 0, w = M; x < w.length; x++) {
        var q = w[x];
        m[q] in F && m.splice(q, 1, F[m[q]]);
      }
      var k = {
        A: "01",
        B: "02",
        C: "03",
        D: "04",
        E: "05",
        H: "06",
        L: "07",
        M: "08",
        P: "09",
        R: "10",
        S: "11",
        T: "12"
      }, G = k[m[8]], z = parseInt(m[9] + m[10], 10);
      z > 40 && (z -= 40), z < 10 && (z = "0".concat(z));
      var Ie = "".concat(m[6]).concat(m[7], "/").concat(G, "/").concat(z);
      if (!(0, a.default)(Ie, "YY/MM/DD"))
        return !1;
      for (var ve = 0, le = 1; le < m.length - 1; le += 2) {
        var Qe = parseInt(m[le], 10);
        isNaN(Qe) && (Qe = m[le].charCodeAt(0) - 65), ve += Qe;
      }
      for (var vt = {
        // Maps of characters at odd places
        A: 1,
        B: 0,
        C: 5,
        D: 7,
        E: 9,
        F: 13,
        G: 15,
        H: 17,
        I: 19,
        J: 21,
        K: 2,
        L: 4,
        M: 18,
        N: 20,
        O: 11,
        P: 3,
        Q: 6,
        R: 8,
        S: 12,
        T: 14,
        U: 16,
        V: 10,
        W: 22,
        X: 25,
        Y: 24,
        Z: 23,
        0: 1,
        1: 0
      }, ge = 0; ge < m.length - 1; ge += 2) {
        var Ne = 0;
        if (m[ge] in vt)
          Ne = vt[m[ge]];
        else {
          var pt = parseInt(m[ge], 10);
          Ne = 2 * pt + 1, pt > 4 && (Ne += 2);
        }
        ve += Ne;
      }
      return String.fromCharCode(65 + ve % 26) === m[15];
    }
    function An(v) {
      v = v.replace(/\W/, "");
      var m = v.slice(0, 2);
      if (m !== "32") {
        var M = v.slice(2, 4);
        if (M !== "00") {
          var F = v.slice(4, 6);
          switch (v[6]) {
            case "0":
              F = "18".concat(F);
              break;
            case "1":
              F = "19".concat(F);
              break;
            default:
              F = "20".concat(F);
              break;
          }
          var x = "".concat(F, "/").concat(v.slice(2, 4), "/").concat(m);
          if (!(0, a.default)(x, "YYYY/MM/DD"))
            return !1;
        }
        for (var w = 1101, q = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2], k = 0; k < v.length - 1; k++)
          w -= parseInt(v[k], 10) * q[k];
        return parseInt(v[10], 10) === w % 11;
      }
      return !0;
    }
    function Sn(v) {
      if (v.length !== 9) {
        for (var m = v.toUpperCase().split(""); m.length < 8; )
          m.unshift(0);
        switch (v[7]) {
          case "A":
          case "P":
            if (parseInt(m[6], 10) === 0)
              return !1;
            break;
          default: {
            var M = parseInt(m.join("").slice(0, 5), 10);
            if (M > 32e3)
              return !1;
            var F = parseInt(m.join("").slice(5, 7), 10);
            if (M === F)
              return !1;
          }
        }
      }
      return !0;
    }
    function bn(v) {
      return d.reverseMultiplyAndSum(v.split("").slice(0, 8).map(function(m) {
        return parseInt(m, 10);
      }), 9) % 11 === parseInt(v[8], 10);
    }
    function Mn(v) {
      if (v.length === 10) {
        for (var m = [6, 5, 7, 2, 3, 4, 5, 6, 7], M = 0, F = 0; F < m.length; F++)
          M += parseInt(v[F], 10) * m[F];
        return M %= 11, M === 10 ? !1 : M === parseInt(v[9], 10);
      }
      var x = v.slice(0, 2), w = parseInt(v.slice(2, 4), 10);
      w > 80 ? (x = "18".concat(x), w -= 80) : w > 60 ? (x = "22".concat(x), w -= 60) : w > 40 ? (x = "21".concat(x), w -= 40) : w > 20 ? (x = "20".concat(x), w -= 20) : x = "19".concat(x), w < 10 && (w = "0".concat(w));
      var q = "".concat(x, "/").concat(w, "/").concat(v.slice(4, 6));
      if (!(0, a.default)(q, "YYYY/MM/DD"))
        return !1;
      for (var k = 0, G = 1, z = 0; z < v.length - 1; z++)
        k += parseInt(v[z], 10) * G % 10, G += 2, G > 10 ? G = 1 : G === 5 && (G += 2);
      return k = 10 - k % 10, k === parseInt(v[10], 10);
    }
    function En(v) {
      if (v.length === 11) {
        var m, M;
        if (m = 0, // Reject known invalid CPFs
        v === "11111111111" || v === "22222222222" || v === "33333333333" || v === "44444444444" || v === "55555555555" || v === "66666666666" || v === "77777777777" || v === "88888888888" || v === "99999999999" || v === "00000000000") return !1;
        for (var F = 1; F <= 9; F++) m += parseInt(v.substring(F - 1, F), 10) * (11 - F);
        if (M = m * 10 % 11, M === 10 && (M = 0), M !== parseInt(v.substring(9, 10), 10)) return !1;
        m = 0;
        for (var x = 1; x <= 10; x++) m += parseInt(v.substring(x - 1, x), 10) * (12 - x);
        return M = m * 10 % 11, M === 10 && (M = 0), M === parseInt(v.substring(10, 11), 10);
      }
      if (
        // Reject know invalid CNPJs
        v === "00000000000000" || v === "11111111111111" || v === "22222222222222" || v === "33333333333333" || v === "44444444444444" || v === "55555555555555" || v === "66666666666666" || v === "77777777777777" || v === "88888888888888" || v === "99999999999999"
      )
        return !1;
      for (var w = v.length - 2, q = v.substring(0, w), k = v.substring(w), G = 0, z = w - 7, Ie = w; Ie >= 1; Ie--)
        G += q.charAt(w - Ie) * z, z -= 1, z < 2 && (z = 9);
      var ve = G % 11 < 2 ? 0 : 11 - G % 11;
      if (ve !== parseInt(k.charAt(0), 10))
        return !1;
      w += 1, q = v.substring(0, w), G = 0, z = w - 7;
      for (var le = w; le >= 1; le--)
        G += q.charAt(w - le) * z, z -= 1, z < 2 && (z = 9);
      return ve = G % 11 < 2 ? 0 : 11 - G % 11, ve === parseInt(k.charAt(1), 10);
    }
    function Rn(v) {
      var m = 11 - d.reverseMultiplyAndSum(v.split("").slice(0, 8).map(function(M) {
        return parseInt(M, 10);
      }), 9) % 11;
      return m > 9 ? parseInt(v[8], 10) === 0 : m === parseInt(v[8], 10);
    }
    function Pn(v) {
      if (v.slice(0, 4) !== "9000") {
        var m = v.slice(1, 3);
        switch (v[0]) {
          case "1":
          case "2":
            m = "19".concat(m);
            break;
          case "3":
          case "4":
            m = "18".concat(m);
            break;
          case "5":
          case "6":
            m = "20".concat(m);
            break;
        }
        var M = "".concat(m, "/").concat(v.slice(3, 5), "/").concat(v.slice(5, 7));
        if (M.length === 8) {
          if (!(0, a.default)(M, "YY/MM/DD"))
            return !1;
        } else if (!(0, a.default)(M, "YYYY/MM/DD"))
          return !1;
        for (var F = v.split("").map(function(k) {
          return parseInt(k, 10);
        }), x = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9], w = 0, q = 0; q < x.length; q++)
          w += F[q] * x[q];
        return w % 11 === 10 ? F[12] === 1 : F[12] === w % 11;
      }
      return !0;
    }
    function Cn(v) {
      if (v.length === 9) {
        if (v = v.replace(/\W/, ""), v.slice(6) === "000")
          return !1;
        var m = parseInt(v.slice(0, 2), 10);
        if (m > 53)
          return !1;
        m < 10 ? m = "190".concat(m) : m = "19".concat(m);
        var M = parseInt(v.slice(2, 4), 10);
        M > 50 && (M -= 50), M < 10 && (M = "0".concat(M));
        var F = "".concat(m, "/").concat(M, "/").concat(v.slice(4, 6));
        if (!(0, a.default)(F, "YYYY/MM/DD"))
          return !1;
      }
      return !0;
    }
    function ct(v) {
      var m = 11 - d.reverseMultiplyAndSum(v.split("").slice(0, 7).map(function(M) {
        return parseInt(M, 10);
      }), 8) % 11;
      return m === 10 ? parseInt(v[7], 10) === 0 : m === parseInt(v[7], 10);
    }
    function Nn(v) {
      var m = v.slice(0);
      v.length > 11 && (m = m.slice(2));
      var M = "", F = m.slice(2, 4), x = parseInt(m.slice(4, 6), 10);
      if (v.length > 11)
        M = v.slice(0, 4);
      else if (M = v.slice(0, 2), v.length === 11 && x < 60) {
        var w = (/* @__PURE__ */ new Date()).getFullYear().toString(), q = parseInt(w.slice(0, 2), 10);
        if (w = parseInt(w, 10), v[6] === "-")
          parseInt("".concat(q).concat(M), 10) > w ? M = "".concat(q - 1).concat(M) : M = "".concat(q).concat(M);
        else if (M = "".concat(q - 1).concat(M), w - parseInt(M, 10) < 100)
          return !1;
      }
      x > 60 && (x -= 60), x < 10 && (x = "0".concat(x));
      var k = "".concat(M, "/").concat(F, "/").concat(x);
      if (k.length === 8) {
        if (!(0, a.default)(k, "YY/MM/DD"))
          return !1;
      } else if (!(0, a.default)(k, "YYYY/MM/DD"))
        return !1;
      return d.luhnCheck(v.replace(/\W/, ""));
    }
    function On(v) {
      for (var m = v.split("").map(function(w) {
        return parseInt(w, 10);
      }), M = [-1, 5, 7, 9, 4, 6, 10, 5, 7], F = 0, x = 0; x < M.length; x++)
        F += m[x] * M[x];
      return F % 11 === 10 ? m[9] === 0 : m[9] === F % 11;
    }
    var de = {
      "bg-BG": /^\d{10}$/,
      "cs-CZ": /^\d{6}\/{0,1}\d{3,4}$/,
      "de-AT": /^\d{9}$/,
      "de-DE": /^[1-9]\d{10}$/,
      "dk-DK": /^\d{6}-{0,1}\d{4}$/,
      "el-CY": /^[09]\d{7}[A-Z]$/,
      "el-GR": /^([0-4]|[7-9])\d{8}$/,
      "en-CA": /^\d{9}$/,
      "en-GB": /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
      "en-IE": /^\d{7}[A-W][A-IW]{0,1}$/i,
      "en-US": /^\d{2}[- ]{0,1}\d{7}$/,
      "es-AR": /(20|23|24|27|30|33|34)[0-9]{8}[0-9]/,
      "es-ES": /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
      "et-EE": /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
      "fi-FI": /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
      "fr-BE": /^\d{11}$/,
      "fr-FR": /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
      // Conforms both to official spec and provided example
      "fr-LU": /^\d{13}$/,
      "hr-HR": /^\d{11}$/,
      "hu-HU": /^8\d{9}$/,
      "it-IT": /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
      "lv-LV": /^\d{6}-{0,1}\d{5}$/,
      // Conforms both to DG TAXUD spec and original research
      "mt-MT": /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
      "nl-NL": /^\d{9}$/,
      "pl-PL": /^\d{10,11}$/,
      "pt-BR": /(?:^\d{11}$)|(?:^\d{14}$)/,
      "pt-PT": /^\d{9}$/,
      "ro-RO": /^\d{13}$/,
      "sk-SK": /^\d{6}\/{0,1}\d{3,4}$/,
      "sl-SI": /^[1-9]\d{7}$/,
      "sv-SE": /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/,
      "uk-UA": /^\d{10}$/
    };
    de["lb-LU"] = de["fr-LU"], de["lt-LT"] = de["et-EE"], de["nl-BE"] = de["fr-BE"], de["fr-CA"] = de["en-CA"];
    var ae = {
      "bg-BG": $,
      "cs-CZ": g,
      "de-AT": A,
      "de-DE": R,
      "dk-DK": y,
      "el-CY": S,
      "el-GR": O,
      "en-CA": h,
      "en-IE": P,
      "en-US": E,
      "es-AR": T,
      "es-ES": U,
      "et-EE": Z,
      "fi-FI": H,
      "fr-BE": W,
      "fr-FR": re,
      "fr-LU": _e,
      "hr-HR": _n,
      "hu-HU": In,
      "it-IT": ft,
      "lv-LV": An,
      "mt-MT": Sn,
      "nl-NL": bn,
      "pl-PL": Mn,
      "pt-BR": En,
      "pt-PT": Rn,
      "ro-RO": Pn,
      "sk-SK": Cn,
      "sl-SI": ct,
      "sv-SE": Nn,
      "uk-UA": On
    };
    ae["lb-LU"] = ae["fr-LU"], ae["lt-LT"] = ae["et-EE"], ae["nl-BE"] = ae["fr-BE"], ae["fr-CA"] = ae["en-CA"];
    var $t = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g, Ce = {
      "de-AT": $t,
      "de-DE": /[\/\\]/g,
      "fr-BE": $t
    };
    Ce["nl-BE"] = Ce["fr-BE"];
    function xn(v) {
      var m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
      (0, n.default)(v);
      var M = v.slice(0);
      if (m in de)
        return m in Ce && (M = M.replace(Ce[m], "")), de[m].test(M) ? m in ae ? ae[m](M) : !0 : !1;
      throw new Error("Invalid locale '".concat(m, "'"));
    }
    t.exports = e.default, t.exports.default = e.default;
  }(kr, kr.exports)), kr.exports;
}
var Ge = {}, Ba;
function z6() {
  if (Ba) return Ge;
  Ba = 1, Object.defineProperty(Ge, "__esModule", {
    value: !0
  }), Ge.isFreightContainerID = void 0, Ge.isISO6346 = d;
  var t = e(/* @__PURE__ */ D());
  function e(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var r = /^[A-Z]{3}(U[0-9]{7})|([J,Z][0-9]{6,7})$/, n = /^[0-9]$/;
  function d(a) {
    if ((0, t.default)(a), a = a.toUpperCase(), !r.test(a)) return !1;
    if (a.length === 11) {
      for (var i = 0, u = 0; u < a.length - 1; u++)
        if (n.test(a[u]))
          i += a[u] * Math.pow(2, u);
        else {
          var o = void 0, s = a.charCodeAt(u) - 55;
          s < 11 ? o = s : s >= 11 && s <= 20 ? o = 12 + s % 11 : s >= 21 && s <= 30 ? o = 23 + s % 21 : o = 34 + s % 31, i += o * Math.pow(2, u);
        }
      var c = i % 11;
      return c === 10 && (c = 0), Number(a[a.length - 1]) === c;
    }
    return !0;
  }
  return Ge.isFreightContainerID = d, Ge;
}
var Hr = { exports: {} }, Ua;
function J6() {
  return Ua || (Ua = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /* @__PURE__ */ new Set(["aa", "ab", "ae", "af", "ak", "am", "an", "ar", "as", "av", "ay", "az", "az", "ba", "be", "bg", "bh", "bi", "bm", "bn", "bo", "br", "bs", "ca", "ce", "ch", "co", "cr", "cs", "cu", "cv", "cy", "da", "de", "dv", "dz", "ee", "el", "en", "eo", "es", "et", "eu", "fa", "ff", "fi", "fj", "fo", "fr", "fy", "ga", "gd", "gl", "gn", "gu", "gv", "ha", "he", "hi", "ho", "hr", "ht", "hu", "hy", "hz", "ia", "id", "ie", "ig", "ii", "ik", "io", "is", "it", "iu", "ja", "jv", "ka", "kg", "ki", "kj", "kk", "kl", "km", "kn", "ko", "kr", "ks", "ku", "kv", "kw", "ky", "la", "lb", "lg", "li", "ln", "lo", "lt", "lu", "lv", "mg", "mh", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my", "na", "nb", "nd", "ne", "ng", "nl", "nn", "no", "nr", "nv", "ny", "oc", "oj", "om", "or", "os", "pa", "pi", "pl", "ps", "pt", "qu", "rm", "rn", "ro", "ru", "rw", "sa", "sc", "sd", "se", "sg", "si", "sk", "sl", "sm", "sn", "so", "sq", "sr", "ss", "st", "su", "sv", "sw", "ta", "te", "tg", "th", "ti", "tk", "tl", "tn", "to", "tr", "ts", "tt", "tw", "ty", "ug", "uk", "ur", "uz", "ve", "vi", "vo", "wa", "wo", "xh", "yi", "yo", "za", "zh", "zu"]);
    function a(i) {
      return (0, r.default)(i), d.has(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Hr, Hr.exports)), Hr.exports;
}
var je = {}, qa;
function X6() {
  if (qa) return je;
  qa = 1, Object.defineProperty(je, "__esModule", {
    value: !0
  }), je.ScriptCodes = void 0, je.default = n;
  var t = e(/* @__PURE__ */ D());
  function e(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = /* @__PURE__ */ new Set(["Adlm", "Afak", "Aghb", "Ahom", "Arab", "Aran", "Armi", "Armn", "Avst", "Bali", "Bamu", "Bass", "Batk", "Beng", "Bhks", "Blis", "Bopo", "Brah", "Brai", "Bugi", "Buhd", "Cakm", "Cans", "Cari", "Cham", "Cher", "Chis", "Chrs", "Cirt", "Copt", "Cpmn", "Cprt", "Cyrl", "Cyrs", "Deva", "Diak", "Dogr", "Dsrt", "Dupl", "Egyd", "Egyh", "Egyp", "Elba", "Elym", "Ethi", "Gara", "Geok", "Geor", "Glag", "Gong", "Gonm", "Goth", "Gran", "Grek", "Gujr", "Gukh", "Guru", "Hanb", "Hang", "Hani", "Hano", "Hans", "Hant", "Hatr", "Hebr", "Hira", "Hluw", "Hmng", "Hmnp", "Hrkt", "Hung", "Inds", "Ital", "Jamo", "Java", "Jpan", "Jurc", "Kali", "Kana", "Kawi", "Khar", "Khmr", "Khoj", "Kitl", "Kits", "Knda", "Kore", "Kpel", "Krai", "Kthi", "Lana", "Laoo", "Latf", "Latg", "Latn", "Leke", "Lepc", "Limb", "Lina", "Linb", "Lisu", "Loma", "Lyci", "Lydi", "Mahj", "Maka", "Mand", "Mani", "Marc", "Maya", "Medf", "Mend", "Merc", "Mero", "Mlym", "Modi", "Mong", "Moon", "Mroo", "Mtei", "Mult", "Mymr", "Nagm", "Nand", "Narb", "Nbat", "Newa", "Nkdb", "Nkgb", "Nkoo", "Nshu", "Ogam", "Olck", "Onao", "Orkh", "Orya", "Osge", "Osma", "Ougr", "Palm", "Pauc", "Pcun", "Pelm", "Perm", "Phag", "Phli", "Phlp", "Phlv", "Phnx", "Plrd", "Piqd", "Prti", "Psin", "Qaaa", "Qaab", "Qaac", "Qaad", "Qaae", "Qaaf", "Qaag", "Qaah", "Qaai", "Qaaj", "Qaak", "Qaal", "Qaam", "Qaan", "Qaao", "Qaap", "Qaaq", "Qaar", "Qaas", "Qaat", "Qaau", "Qaav", "Qaaw", "Qaax", "Qaay", "Qaaz", "Qaba", "Qabb", "Qabc", "Qabd", "Qabe", "Qabf", "Qabg", "Qabh", "Qabi", "Qabj", "Qabk", "Qabl", "Qabm", "Qabn", "Qabo", "Qabp", "Qabq", "Qabr", "Qabs", "Qabt", "Qabu", "Qabv", "Qabw", "Qabx", "Ranj", "Rjng", "Rohg", "Roro", "Runr", "Samr", "Sara", "Sarb", "Saur", "Sgnw", "Shaw", "Shrd", "Shui", "Sidd", "Sidt", "Sind", "Sinh", "Sogd", "Sogo", "Sora", "Soyo", "Sund", "Sunu", "Sylo", "Syrc", "Syre", "Syrj", "Syrn", "Tagb", "Takr", "Tale", "Talu", "Taml", "Tang", "Tavt", "Tayo", "Telu", "Teng", "Tfng", "Tglg", "Thaa", "Thai", "Tibt", "Tirh", "Tnsa", "Todr", "Tols", "Toto", "Tutg", "Ugar", "Vaii", "Visp", "Vith", "Wara", "Wcho", "Wole", "Xpeo", "Xsux", "Yezi", "Yiii", "Zanb", "Zinh", "Zmth", "Zsye", "Zsym", "Zxxx", "Zyyy", "Zzzz"]);
  function n(d) {
    return (0, t.default)(d), r.has(d);
  }
  return je.ScriptCodes = r, je;
}
var Gr = { exports: {} }, Za;
function Q6() {
  return Za || (Za = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /* @__PURE__ */ new Set(["004", "008", "010", "012", "016", "020", "024", "028", "031", "032", "036", "040", "044", "048", "050", "051", "052", "056", "060", "064", "068", "070", "072", "074", "076", "084", "086", "090", "092", "096", "100", "104", "108", "112", "116", "120", "124", "132", "136", "140", "144", "148", "152", "156", "158", "162", "166", "170", "174", "175", "178", "180", "184", "188", "191", "192", "196", "203", "204", "208", "212", "214", "218", "222", "226", "231", "232", "233", "234", "238", "239", "242", "246", "248", "250", "254", "258", "260", "262", "266", "268", "270", "275", "276", "288", "292", "296", "300", "304", "308", "312", "316", "320", "324", "328", "332", "334", "336", "340", "344", "348", "352", "356", "360", "364", "368", "372", "376", "380", "384", "388", "392", "398", "400", "404", "408", "410", "414", "417", "418", "422", "426", "428", "430", "434", "438", "440", "442", "446", "450", "454", "458", "462", "466", "470", "474", "478", "480", "484", "492", "496", "498", "499", "500", "504", "508", "512", "516", "520", "524", "528", "531", "533", "534", "535", "540", "548", "554", "558", "562", "566", "570", "574", "578", "580", "581", "583", "584", "585", "586", "591", "598", "600", "604", "608", "612", "616", "620", "624", "626", "630", "634", "638", "642", "643", "646", "652", "654", "659", "660", "662", "663", "666", "670", "674", "678", "682", "686", "688", "690", "694", "702", "703", "704", "705", "706", "710", "716", "724", "728", "729", "732", "740", "744", "748", "752", "756", "760", "762", "764", "768", "772", "776", "780", "784", "788", "792", "795", "796", "798", "800", "804", "807", "818", "826", "831", "832", "833", "834", "840", "850", "854", "858", "860", "862", "876", "882", "887", "894"]);
    function a(i) {
      return (0, r.default)(i), d.has(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Gr, Gr.exports)), Gr.exports;
}
var Ve = {}, ka;
function Y2() {
  if (ka) return Ve;
  ka = 1, Object.defineProperty(Ve, "__esModule", {
    value: !0
  }), Ve.CurrencyCodes = void 0, Ve.default = n;
  var t = e(/* @__PURE__ */ D());
  function e(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = /* @__PURE__ */ new Set(["AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BOV", "BRL", "BSD", "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHE", "CHF", "CHW", "CLF", "CLP", "CNY", "COP", "COU", "CRC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HTG", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MXV", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLE", "SLL", "SOS", "SRD", "SSP", "STN", "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "USN", "UYI", "UYU", "UYW", "UZS", "VED", "VES", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XBA", "XBB", "XBC", "XBD", "XCD", "XDR", "XOF", "XPD", "XPF", "XPT", "XSU", "XTS", "XUA", "XXX", "YER", "ZAR", "ZMW", "ZWL"]);
  function n(d) {
    return (0, t.default)(d), r.has(d.toUpperCase());
  }
  return Ve.CurrencyCodes = r, Ve;
}
var jr = { exports: {} }, Ha;
function z2() {
  return Ha || (Ha = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^[A-HJ-NP-Za-km-z1-9]*$/;
    function a(i) {
      return (0, r.default)(i), !!d.test(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(jr, jr.exports)), jr.exports;
}
var Vr = { exports: {} }, Wr = { exports: {} }, Kr = { exports: {} }, Ga;
function J2() {
  return Ga || (Ga = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, i) {
      if ((0, r.default)(a), i) {
        var u = new RegExp("[".concat(i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+$"), "g");
        return a.replace(u, "");
      }
      for (var o = a.length - 1; /\s/.test(a.charAt(o)); )
        o -= 1;
      return a.slice(0, o + 1);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Kr, Kr.exports)), Kr.exports;
}
var Yr = { exports: {} }, ja;
function X2() {
  return ja || (ja = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, i) {
      (0, r.default)(a);
      var u = i ? new RegExp("^[".concat(i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+"), "g") : /^\s+/g;
      return a.replace(u, "");
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Yr, Yr.exports)), Yr.exports;
}
var Va;
function Q2() {
  return Va || (Va = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = d(/* @__PURE__ */ J2()), n = d(/* @__PURE__ */ X2());
    function d(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function a(i, u) {
      return (0, r.default)((0, n.default)(i, u), u);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Wr, Wr.exports)), Wr.exports;
}
var Wa;
function e8() {
  return Wa || (Wa = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = p;
    var r = a(/* @__PURE__ */ Q2()), n = a(/* @__PURE__ */ d0()), d = a(/* @__PURE__ */ D());
    function a($) {
      return $ && $.__esModule ? $ : { default: $ };
    }
    function i($, h) {
      return s($) || o($, h) || f($, h) || u();
    }
    function u() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function o($, h) {
      var g = $ == null ? null : typeof Symbol < "u" && $[Symbol.iterator] || $["@@iterator"];
      if (g != null) {
        var A, R, y, S, O = [], P = !0, b = !1;
        try {
          if (y = (g = g.call($)).next, h !== 0) for (; !(P = (A = y.call(g)).done) && (O.push(A.value), O.length !== h); P = !0) ;
        } catch (I) {
          b = !0, R = I;
        } finally {
          try {
            if (!P && g.return != null && (S = g.return(), Object(S) !== S)) return;
          } finally {
            if (b) throw R;
          }
        }
        return O;
      }
    }
    function s($) {
      if (Array.isArray($)) return $;
    }
    function c($, h) {
      var g = typeof Symbol < "u" && $[Symbol.iterator] || $["@@iterator"];
      if (!g) {
        if (Array.isArray($) || (g = f($)) || h) {
          g && ($ = g);
          var A = 0, R = function() {
          };
          return { s: R, n: function() {
            return A >= $.length ? { done: !0 } : { done: !1, value: $[A++] };
          }, e: function(b) {
            throw b;
          }, f: R };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var y, S = !0, O = !1;
      return { s: function() {
        g = g.call($);
      }, n: function() {
        var b = g.next();
        return S = b.done, b;
      }, e: function(b) {
        O = !0, y = b;
      }, f: function() {
        try {
          S || g.return == null || g.return();
        } finally {
          if (O) throw y;
        }
      } };
    }
    function f($, h) {
      if ($) {
        if (typeof $ == "string") return l($, h);
        var g = {}.toString.call($).slice(8, -1);
        return g === "Object" && $.constructor && (g = $.constructor.name), g === "Map" || g === "Set" ? Array.from($) : g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g) ? l($, h) : void 0;
      }
    }
    function l($, h) {
      (h == null || h > $.length) && (h = $.length);
      for (var g = 0, A = Array(h); g < h; g++) A[g] = $[g];
      return A;
    }
    function _($) {
      var h = /* @__PURE__ */ new Set(["subject", "body", "cc", "bcc"]), g = {
        cc: "",
        bcc: ""
      }, A = !1, R = $.split("&");
      if (R.length > 4)
        return !1;
      var y = c(R), S;
      try {
        for (y.s(); !(S = y.n()).done; ) {
          var O = S.value, P = O.split("="), b = i(P, 2), I = b[0], E = b[1];
          if (I && !h.has(I)) {
            A = !0;
            break;
          }
          E && (I === "cc" || I === "bcc") && (g[I] = E), I && h.delete(I);
        }
      } catch (T) {
        y.e(T);
      } finally {
        y.f();
      }
      return A ? !1 : g;
    }
    function p($, h) {
      if ((0, d.default)($), $.indexOf("mailto:") !== 0)
        return !1;
      var g = $.replace("mailto:", "").split("?"), A = i(g, 2), R = A[0], y = A[1], S = y === void 0 ? "" : y;
      if (!R && !S)
        return !0;
      var O = _(S);
      return O ? "".concat(R, ",").concat(O.cc, ",").concat(O.bcc).split(",").every(function(P) {
        return P = (0, r.default)(P, " "), P ? (0, n.default)(P, h) : !0;
      }) : !1;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Vr, Vr.exports)), Vr.exports;
}
var zr = { exports: {} }, Ka;
function t8() {
  return Ka || (Ka = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a), a.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;").replace(/\\/g, "&#x5C;").replace(/`/g, "&#96;");
    }
    t.exports = e.default, t.exports.default = e.default;
  }(zr, zr.exports)), zr.exports;
}
var Jr = { exports: {} }, Ya;
function r8() {
  return Ya || (Ya = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a), a.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#x2F;/g, "/").replace(/&#x5C;/g, "\\").replace(/&#96;/g, "`").replace(/&amp;/g, "&");
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Jr, Jr.exports)), Jr.exports;
}
var Xr = { exports: {} }, Qr = { exports: {} }, za;
function es() {
  return za || (za = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, i) {
      return (0, r.default)(a), a.replace(new RegExp("[".concat(i, "]+"), "g"), "");
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Qr, Qr.exports)), Qr.exports;
}
var Ja;
function n8() {
  return Ja || (Ja = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = d(/* @__PURE__ */ D()), n = d(/* @__PURE__ */ es());
    function d(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function a(i, u) {
      (0, r.default)(i);
      var o = u ? "\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F" : "\\x00-\\x1F\\x7F";
      return (0, n.default)(i, o);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(Xr, Xr.exports)), Xr.exports;
}
var en = { exports: {} }, Xa;
function d8() {
  return Xa || (Xa = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, i) {
      return (0, r.default)(a), a.replace(new RegExp("[^".concat(i, "]+"), "g"), "");
    }
    t.exports = e.default, t.exports.default = e.default;
  }(en, en.exports)), en.exports;
}
var tn = { exports: {} }, Qa;
function a8() {
  return Qa || (Qa = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = d;
    var r = n(/* @__PURE__ */ D());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, i) {
      (0, r.default)(a);
      for (var u = a.length - 1; u >= 0; u--)
        if (i.indexOf(a[u]) === -1)
          return !1;
      return !0;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(tn, tn.exports)), tn.exports;
}
var rn = { exports: {} }, ei;
function i8() {
  return ei || (ei = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = c;
    var r = n(/* @__PURE__ */ ee());
    function n(f) {
      return f && f.__esModule ? f : { default: f };
    }
    var d = {
      // The following options apply to all email addresses
      // Lowercases the local part of the email address.
      // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
      // The domain is always lowercased, as per RFC 1035
      all_lowercase: !0,
      // The following conversions are specific to GMail
      // Lowercases the local part of the GMail address (known to be case-insensitive)
      gmail_lowercase: !0,
      // Removes dots from the local part of the email address, as that's ignored by GMail
      gmail_remove_dots: !0,
      // Removes the subaddress (e.g. "+foo") from the email address
      gmail_remove_subaddress: !0,
      // Conversts the googlemail.com domain to gmail.com
      gmail_convert_googlemaildotcom: !0,
      // The following conversions are specific to Outlook.com / Windows Live / Hotmail
      // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
      outlookdotcom_lowercase: !0,
      // Removes the subaddress (e.g. "+foo") from the email address
      outlookdotcom_remove_subaddress: !0,
      // The following conversions are specific to Yahoo
      // Lowercases the local part of the Yahoo address (known to be case-insensitive)
      yahoo_lowercase: !0,
      // Removes the subaddress (e.g. "-foo") from the email address
      yahoo_remove_subaddress: !0,
      // The following conversions are specific to Yandex
      // Lowercases the local part of the Yandex address (known to be case-insensitive)
      yandex_lowercase: !0,
      // all yandex domains are equal, this explicitly sets the domain to 'yandex.ru'
      yandex_convert_yandexru: !0,
      // The following conversions are specific to iCloud
      // Lowercases the local part of the iCloud address (known to be case-insensitive)
      icloud_lowercase: !0,
      // Removes the subaddress (e.g. "+foo") from the email address
      icloud_remove_subaddress: !0
    }, a = ["icloud.com", "me.com"], i = ["hotmail.at", "hotmail.be", "hotmail.ca", "hotmail.cl", "hotmail.co.il", "hotmail.co.nz", "hotmail.co.th", "hotmail.co.uk", "hotmail.com", "hotmail.com.ar", "hotmail.com.au", "hotmail.com.br", "hotmail.com.gr", "hotmail.com.mx", "hotmail.com.pe", "hotmail.com.tr", "hotmail.com.vn", "hotmail.cz", "hotmail.de", "hotmail.dk", "hotmail.es", "hotmail.fr", "hotmail.hu", "hotmail.id", "hotmail.ie", "hotmail.in", "hotmail.it", "hotmail.jp", "hotmail.kr", "hotmail.lv", "hotmail.my", "hotmail.ph", "hotmail.pt", "hotmail.sa", "hotmail.sg", "hotmail.sk", "live.be", "live.co.uk", "live.com", "live.com.ar", "live.com.mx", "live.de", "live.es", "live.eu", "live.fr", "live.it", "live.nl", "msn.com", "outlook.at", "outlook.be", "outlook.cl", "outlook.co.il", "outlook.co.nz", "outlook.co.th", "outlook.com", "outlook.com.ar", "outlook.com.au", "outlook.com.br", "outlook.com.gr", "outlook.com.pe", "outlook.com.tr", "outlook.com.vn", "outlook.cz", "outlook.de", "outlook.dk", "outlook.es", "outlook.fr", "outlook.hu", "outlook.id", "outlook.ie", "outlook.in", "outlook.it", "outlook.jp", "outlook.kr", "outlook.lv", "outlook.my", "outlook.ph", "outlook.pt", "outlook.sa", "outlook.sg", "outlook.sk", "passport.com"], u = ["rocketmail.com", "yahoo.ca", "yahoo.co.uk", "yahoo.com", "yahoo.de", "yahoo.fr", "yahoo.in", "yahoo.it", "ymail.com"], o = ["yandex.ru", "yandex.ua", "yandex.kz", "yandex.com", "yandex.by", "ya.ru"];
    function s(f) {
      return f.length > 1 ? f : "";
    }
    function c(f, l) {
      l = (0, r.default)(l, d);
      var _ = f.split("@"), p = _.pop(), $ = _.join("@"), h = [$, p];
      if (h[1] = h[1].toLowerCase(), h[1] === "gmail.com" || h[1] === "googlemail.com") {
        if (l.gmail_remove_subaddress && (h[0] = h[0].split("+")[0]), l.gmail_remove_dots && (h[0] = h[0].replace(/\.+/g, s)), !h[0].length)
          return !1;
        (l.all_lowercase || l.gmail_lowercase) && (h[0] = h[0].toLowerCase()), h[1] = l.gmail_convert_googlemaildotcom ? "gmail.com" : h[1];
      } else if (a.indexOf(h[1]) >= 0) {
        if (l.icloud_remove_subaddress && (h[0] = h[0].split("+")[0]), !h[0].length)
          return !1;
        (l.all_lowercase || l.icloud_lowercase) && (h[0] = h[0].toLowerCase());
      } else if (i.indexOf(h[1]) >= 0) {
        if (l.outlookdotcom_remove_subaddress && (h[0] = h[0].split("+")[0]), !h[0].length)
          return !1;
        (l.all_lowercase || l.outlookdotcom_lowercase) && (h[0] = h[0].toLowerCase());
      } else if (u.indexOf(h[1]) >= 0) {
        if (l.yahoo_remove_subaddress) {
          var g = h[0].split("-");
          h[0] = g.length > 1 ? g.slice(0, -1).join("-") : g[0];
        }
        if (!h[0].length)
          return !1;
        (l.all_lowercase || l.yahoo_lowercase) && (h[0] = h[0].toLowerCase());
      } else o.indexOf(h[1]) >= 0 ? ((l.all_lowercase || l.yandex_lowercase) && (h[0] = h[0].toLowerCase()), h[1] = l.yandex_convert_yandexru ? "yandex.ru" : h[1]) : l.all_lowercase && (h[0] = h[0].toLowerCase());
      return h.join("@");
    }
    t.exports = e.default, t.exports.default = e.default;
  }(rn, rn.exports)), rn.exports;
}
var nn = { exports: {} }, ti;
function u8() {
  return ti || (ti = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
    function a(i) {
      return (0, r.default)(i), d.test(i);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(nn, nn.exports)), nn.exports;
}
var dn = { exports: {} }, ri;
function o8() {
  return ri || (ri = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = n(/* @__PURE__ */ D());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = {
      "cs-CZ": function(u) {
        return /^(([ABCDEFHIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(u);
      },
      "de-DE": function(u) {
        return /^((A|AA|AB|AC|AE|AH|AK|AM|AN|AÖ|AP|AS|AT|AU|AW|AZ|B|BA|BB|BC|BE|BF|BH|BI|BK|BL|BM|BN|BO|BÖ|BS|BT|BZ|C|CA|CB|CE|CO|CR|CW|D|DA|DD|DE|DH|DI|DL|DM|DN|DO|DU|DW|DZ|E|EA|EB|ED|EE|EF|EG|EH|EI|EL|EM|EN|ER|ES|EU|EW|F|FB|FD|FF|FG|FI|FL|FN|FO|FR|FS|FT|FÜ|FW|FZ|G|GA|GC|GD|GE|GF|GG|GI|GK|GL|GM|GN|GÖ|GP|GR|GS|GT|GÜ|GV|GW|GZ|H|HA|HB|HC|HD|HE|HF|HG|HH|HI|HK|HL|HM|HN|HO|HP|HR|HS|HU|HV|HX|HY|HZ|IK|IL|IN|IZ|J|JE|JL|K|KA|KB|KC|KE|KF|KG|KH|KI|KK|KL|KM|KN|KO|KR|KS|KT|KU|KW|KY|L|LA|LB|LC|LD|LF|LG|LH|LI|LL|LM|LN|LÖ|LP|LR|LU|M|MA|MB|MC|MD|ME|MG|MH|MI|MK|ML|MM|MN|MO|MQ|MR|MS|MÜ|MW|MY|MZ|N|NB|ND|NE|NF|NH|NI|NK|NM|NÖ|NP|NR|NT|NU|NW|NY|NZ|OA|OB|OC|OD|OE|OF|OG|OH|OK|OL|OP|OS|OZ|P|PA|PB|PE|PF|PI|PL|PM|PN|PR|PS|PW|PZ|R|RA|RC|RD|RE|RG|RH|RI|RL|RM|RN|RO|RP|RS|RT|RU|RV|RW|RZ|S|SB|SC|SE|SG|SI|SK|SL|SM|SN|SO|SP|SR|ST|SU|SW|SY|SZ|TE|TF|TG|TO|TP|TR|TS|TT|TÜ|ÜB|UE|UH|UL|UM|UN|V|VB|VG|VK|VR|VS|W|WA|WB|WE|WF|WI|WK|WL|WM|WN|WO|WR|WS|WT|WÜ|WW|WZ|Z|ZE|ZI|ZP|ZR|ZW|ZZ)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(ABG|ABI|AIB|AIC|ALF|ALZ|ANA|ANG|ANK|APD|ARN|ART|ASL|ASZ|AUR|AZE|BAD|BAR|BBG|BCH|BED|BER|BGD|BGL|BID|BIN|BIR|BIT|BIW|BKS|BLB|BLK|BNA|BOG|BOH|BOR|BOT|BRA|BRB|BRG|BRK|BRL|BRV|BSB|BSK|BTF|BÜD|BUL|BÜR|BÜS|BÜZ|CAS|CHA|CLP|CLZ|COC|COE|CUX|DAH|DAN|DAU|DBR|DEG|DEL|DGF|DIL|DIN|DIZ|DKB|DLG|DON|DUD|DÜW|EBE|EBN|EBS|ECK|EIC|EIL|EIN|EIS|EMD|EMS|ERB|ERH|ERK|ERZ|ESB|ESW|FDB|FDS|FEU|FFB|FKB|FLÖ|FOR|FRG|FRI|FRW|FTL|FÜS|GAN|GAP|GDB|GEL|GEO|GER|GHA|GHC|GLA|GMN|GNT|GOA|GOH|GRA|GRH|GRI|GRM|GRZ|GTH|GUB|GUN|GVM|HAB|HAL|HAM|HAS|HBN|HBS|HCH|HDH|HDL|HEB|HEF|HEI|HER|HET|HGN|HGW|HHM|HIG|HIP|HMÜ|HOG|HOH|HOL|HOM|HOR|HÖS|HOT|HRO|HSK|HST|HVL|HWI|IGB|ILL|JÜL|KEH|KEL|KEM|KIB|KLE|KLZ|KÖN|KÖT|KÖZ|KRU|KÜN|KUS|KYF|LAN|LAU|LBS|LBZ|LDK|LDS|LEO|LER|LEV|LIB|LIF|LIP|LÖB|LOS|LRO|LSZ|LÜN|LUP|LWL|MAB|MAI|MAK|MAL|MED|MEG|MEI|MEK|MEL|MER|MET|MGH|MGN|MHL|MIL|MKK|MOD|MOL|MON|MOS|MSE|MSH|MSP|MST|MTK|MTL|MÜB|MÜR|MYK|MZG|NAB|NAI|NAU|NDH|NEA|NEB|NEC|NEN|NES|NEW|NMB|NMS|NOH|NOL|NOM|NOR|NVP|NWM|OAL|OBB|OBG|OCH|OHA|ÖHR|OHV|OHZ|OPR|OSL|OVI|OVL|OVP|PAF|PAN|PAR|PCH|PEG|PIR|PLÖ|PRÜ|QFT|QLB|RDG|REG|REH|REI|RID|RIE|ROD|ROF|ROK|ROL|ROS|ROT|ROW|RSL|RÜD|RÜG|SAB|SAD|SAN|SAW|SBG|SBK|SCZ|SDH|SDL|SDT|SEB|SEE|SEF|SEL|SFB|SFT|SGH|SHA|SHG|SHK|SHL|SIG|SIM|SLE|SLF|SLK|SLN|SLS|SLÜ|SLZ|SMÜ|SOB|SOG|SOK|SÖM|SON|SPB|SPN|SRB|SRO|STA|STB|STD|STE|STL|SUL|SÜW|SWA|SZB|TBB|TDO|TET|TIR|TÖL|TUT|UEM|UER|UFF|USI|VAI|VEC|VER|VIB|VIE|VIT|VOH|WAF|WAK|WAN|WAR|WAT|WBS|WDA|WEL|WEN|WER|WES|WHV|WIL|WIS|WIT|WIZ|WLG|WMS|WND|WOB|WOH|WOL|WOR|WOS|WRN|WSF|WST|WSW|WTL|WTM|WUG|WÜM|WUN|WUR|WZL|ZEL|ZIG)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(u);
      },
      "de-LI": function(u) {
        return /^FL[- ]?\d{1,5}[UZ]?$/.test(u);
      },
      "en-IN": function(u) {
        return /^[A-Z]{2}[ -]?[0-9]{1,2}(?:[ -]?[A-Z])(?:[ -]?[A-Z]*)?[ -]?[0-9]{4}$/.test(u);
      },
      "en-SG": function(u) {
        return /^[A-Z]{3}[ -]?[\d]{4}[ -]?[A-Z]{1}$/.test(u);
      },
      "es-AR": function(u) {
        return /^(([A-Z]{2} ?[0-9]{3} ?[A-Z]{2})|([A-Z]{3} ?[0-9]{3}))$/.test(u);
      },
      "fi-FI": function(u) {
        return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(u);
      },
      "hu-HU": function(u) {
        return /^((((?!AAA)(([A-NPRSTVZWXY]{1})([A-PR-Z]{1})([A-HJ-NPR-Z]))|(A[ABC]I)|A[ABC]O|A[A-W]Q|BPI|BPO|UCO|UDO|XAO)-(?!000)\d{3})|(M\d{6})|((CK|DT|CD|HC|H[ABEFIKLMNPRSTVX]|MA|OT|R[A-Z]) \d{2}-\d{2})|(CD \d{3}-\d{3})|(C-(C|X) \d{4})|(X-(A|B|C) \d{4})|(([EPVZ]-\d{5}))|(S A[A-Z]{2} \d{2})|(SP \d{2}-\d{2}))$/.test(u);
      },
      "pt-BR": function(u) {
        return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(u);
      },
      "pt-PT": function(u) {
        return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(u);
      },
      "sq-AL": function(u) {
        return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(u);
      },
      "sv-SE": function(u) {
        return /^[A-HJ-PR-UW-Z]{3} ?[\d]{2}[A-HJ-PR-UW-Z1-9]$|(^[A-ZÅÄÖ ]{2,7}$)/.test(u.trim());
      },
      "en-PK": function(u) {
        return /(^[A-Z]{2}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{3}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{4}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]((\s|-){0,1})[0-9]{4}((\s|-)[0-9]{2}){0,1}$)/.test(u.trim());
      }
    };
    function a(i, u) {
      if ((0, r.default)(i), u in d)
        return d[u](i);
      if (u === "any") {
        for (var o in d) {
          var s = d[o];
          if (s(i))
            return !0;
        }
        return !1;
      }
      throw new Error("Invalid locale '".concat(u, "'"));
    }
    t.exports = e.default, t.exports.default = e.default;
  }(dn, dn.exports)), dn.exports;
}
var an = { exports: {} }, ni;
function s8() {
  return ni || (ni = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = _;
    var r = d(/* @__PURE__ */ ee()), n = d(/* @__PURE__ */ D());
    function d(p) {
      return p && p.__esModule ? p : { default: p };
    }
    var a = /^[A-Z]$/, i = /^[a-z]$/, u = /^[0-9]$/, o = /^[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/\\ ]$/, s = {
      minLength: 8,
      minLowercase: 1,
      minUppercase: 1,
      minNumbers: 1,
      minSymbols: 1,
      returnScore: !1,
      pointsPerUnique: 1,
      pointsPerRepeat: 0.5,
      pointsForContainingLower: 10,
      pointsForContainingUpper: 10,
      pointsForContainingNumber: 10,
      pointsForContainingSymbol: 10
    };
    function c(p) {
      var $ = {};
      return Array.from(p).forEach(function(h) {
        var g = $[h];
        g ? $[h] += 1 : $[h] = 1;
      }), $;
    }
    function f(p) {
      var $ = c(p), h = {
        length: p.length,
        uniqueChars: Object.keys($).length,
        uppercaseCount: 0,
        lowercaseCount: 0,
        numberCount: 0,
        symbolCount: 0
      };
      return Object.keys($).forEach(function(g) {
        a.test(g) ? h.uppercaseCount += $[g] : i.test(g) ? h.lowercaseCount += $[g] : u.test(g) ? h.numberCount += $[g] : o.test(g) && (h.symbolCount += $[g]);
      }), h;
    }
    function l(p, $) {
      var h = 0;
      return h += p.uniqueChars * $.pointsPerUnique, h += (p.length - p.uniqueChars) * $.pointsPerRepeat, p.lowercaseCount > 0 && (h += $.pointsForContainingLower), p.uppercaseCount > 0 && (h += $.pointsForContainingUpper), p.numberCount > 0 && (h += $.pointsForContainingNumber), p.symbolCount > 0 && (h += $.pointsForContainingSymbol), h;
    }
    function _(p) {
      var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      (0, n.default)(p);
      var h = f(p);
      return $ = (0, r.default)($ || {}, s), $.returnScore ? l(h, $) : h.length >= $.minLength && h.lowercaseCount >= $.minLowercase && h.uppercaseCount >= $.minUppercase && h.numberCount >= $.minNumbers && h.symbolCount >= $.minSymbols;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(an, an.exports)), an.exports;
}
var We = {}, di;
function l8() {
  if (di) return We;
  di = 1;
  function t(f) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
      return typeof l;
    } : function(l) {
      return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
    }, t(f);
  }
  Object.defineProperty(We, "__esModule", {
    value: !0
  }), We.default = c, We.vatMatchers = void 0;
  var e = a(/* @__PURE__ */ D()), r = d(/* @__PURE__ */ W2());
  function n(f) {
    if (typeof WeakMap != "function") return null;
    var l = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap();
    return (n = function($) {
      return $ ? _ : l;
    })(f);
  }
  function d(f, l) {
    if (f && f.__esModule) return f;
    if (f === null || t(f) != "object" && typeof f != "function") return { default: f };
    var _ = n(l);
    if (_ && _.has(f)) return _.get(f);
    var p = { __proto__: null }, $ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var h in f) if (h !== "default" && {}.hasOwnProperty.call(f, h)) {
      var g = $ ? Object.getOwnPropertyDescriptor(f, h) : null;
      g && (g.get || g.set) ? Object.defineProperty(p, h, g) : p[h] = f[h];
    }
    return p.default = f, _ && _.set(f, p), p;
  }
  function a(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var i = function(l) {
    var _ = l.match(/^(AU)?(\d{11})$/);
    if (!_)
      return !1;
    var p = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    l = l.replace(/^AU/, "");
    for (var $ = (parseInt(l.slice(0, 1), 10) - 1).toString() + l.slice(1), h = 0, g = 0; g < 11; g++)
      h += p[g] * $.charAt(g);
    return h !== 0 && h % 89 === 0;
  }, u = function(l) {
    var _ = function($) {
      var h = $.pop(), g = [5, 4, 3, 2, 7, 6, 5, 4], A = (11 - $.reduce(function(R, y, S) {
        return R + y * g[S];
      }, 0) % 11) % 11;
      return h === A;
    };
    return /^(CHE[- ]?)?(\d{9}|(\d{3}\.\d{3}\.\d{3})|(\d{3} \d{3} \d{3})) ?(TVA|MWST|IVA)?$/.test(l) && _(l.match(/\d/g).map(function(p) {
      return +p;
    }));
  }, o = function(l) {
    var _ = l.match(/^(PT)?(\d{9})$/);
    if (!_)
      return !1;
    var p = _[2], $ = 11 - r.reverseMultiplyAndSum(p.split("").slice(0, 8).map(function(h) {
      return parseInt(h, 10);
    }), 9) % 11;
    return $ > 9 ? parseInt(p[8], 10) === 0 : $ === parseInt(p[8], 10);
  }, s = We.vatMatchers = {
    /**
     * European Union VAT identification numbers
     */
    AT: function(l) {
      return /^(AT)?U\d{8}$/.test(l);
    },
    BE: function(l) {
      return /^(BE)?\d{10}$/.test(l);
    },
    BG: function(l) {
      return /^(BG)?\d{9,10}$/.test(l);
    },
    HR: function(l) {
      return /^(HR)?\d{11}$/.test(l);
    },
    CY: function(l) {
      return /^(CY)?\w{9}$/.test(l);
    },
    CZ: function(l) {
      return /^(CZ)?\d{8,10}$/.test(l);
    },
    DK: function(l) {
      return /^(DK)?\d{8}$/.test(l);
    },
    EE: function(l) {
      return /^(EE)?\d{9}$/.test(l);
    },
    FI: function(l) {
      return /^(FI)?\d{8}$/.test(l);
    },
    FR: function(l) {
      return /^(FR)?\w{2}\d{9}$/.test(l);
    },
    DE: function(l) {
      return /^(DE)?\d{9}$/.test(l);
    },
    EL: function(l) {
      return /^(EL)?\d{9}$/.test(l);
    },
    HU: function(l) {
      return /^(HU)?\d{8}$/.test(l);
    },
    IE: function(l) {
      return /^(IE)?\d{7}\w{1}(W)?$/.test(l);
    },
    IT: function(l) {
      return /^(IT)?\d{11}$/.test(l);
    },
    LV: function(l) {
      return /^(LV)?\d{11}$/.test(l);
    },
    LT: function(l) {
      return /^(LT)?\d{9,12}$/.test(l);
    },
    LU: function(l) {
      return /^(LU)?\d{8}$/.test(l);
    },
    MT: function(l) {
      return /^(MT)?\d{8}$/.test(l);
    },
    NL: function(l) {
      return /^(NL)?\d{9}B\d{2}$/.test(l);
    },
    PL: function(l) {
      return /^(PL)?(\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3}))$/.test(l);
    },
    PT: o,
    RO: function(l) {
      return /^(RO)?\d{2,10}$/.test(l);
    },
    SK: function(l) {
      return /^(SK)?\d{10}$/.test(l);
    },
    SI: function(l) {
      return /^(SI)?\d{8}$/.test(l);
    },
    ES: function(l) {
      return /^(ES)?\w\d{7}[A-Z]$/.test(l);
    },
    SE: function(l) {
      return /^(SE)?\d{12}$/.test(l);
    },
    /**
     * VAT numbers of non-EU countries
     */
    AL: function(l) {
      return /^(AL)?\w{9}[A-Z]$/.test(l);
    },
    MK: function(l) {
      return /^(MK)?\d{13}$/.test(l);
    },
    AU: i,
    BY: function(l) {
      return /^(УНП )?\d{9}$/.test(l);
    },
    CA: function(l) {
      return /^(CA)?\d{9}$/.test(l);
    },
    IS: function(l) {
      return /^(IS)?\d{5,6}$/.test(l);
    },
    IN: function(l) {
      return /^(IN)?\d{15}$/.test(l);
    },
    ID: function(l) {
      return /^(ID)?(\d{15}|(\d{2}.\d{3}.\d{3}.\d{1}-\d{3}.\d{3}))$/.test(l);
    },
    IL: function(l) {
      return /^(IL)?\d{9}$/.test(l);
    },
    KZ: function(l) {
      return /^(KZ)?\d{12}$/.test(l);
    },
    NZ: function(l) {
      return /^(NZ)?\d{9}$/.test(l);
    },
    NG: function(l) {
      return /^(NG)?(\d{12}|(\d{8}-\d{4}))$/.test(l);
    },
    NO: function(l) {
      return /^(NO)?\d{9}MVA$/.test(l);
    },
    PH: function(l) {
      return /^(PH)?(\d{12}|\d{3} \d{3} \d{3} \d{3})$/.test(l);
    },
    RU: function(l) {
      return /^(RU)?(\d{10}|\d{12})$/.test(l);
    },
    SM: function(l) {
      return /^(SM)?\d{5}$/.test(l);
    },
    SA: function(l) {
      return /^(SA)?\d{15}$/.test(l);
    },
    RS: function(l) {
      return /^(RS)?\d{9}$/.test(l);
    },
    CH: u,
    TR: function(l) {
      return /^(TR)?\d{10}$/.test(l);
    },
    UA: function(l) {
      return /^(UA)?\d{12}$/.test(l);
    },
    GB: function(l) {
      return /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/.test(l);
    },
    UZ: function(l) {
      return /^(UZ)?\d{9}$/.test(l);
    },
    /**
     * VAT numbers of Latin American countries
     */
    AR: function(l) {
      return /^(AR)?\d{11}$/.test(l);
    },
    BO: function(l) {
      return /^(BO)?\d{7}$/.test(l);
    },
    BR: function(l) {
      return /^(BR)?((\d{2}.\d{3}.\d{3}\/\d{4}-\d{2})|(\d{3}.\d{3}.\d{3}-\d{2}))$/.test(l);
    },
    CL: function(l) {
      return /^(CL)?\d{8}-\d{1}$/.test(l);
    },
    CO: function(l) {
      return /^(CO)?\d{10}$/.test(l);
    },
    CR: function(l) {
      return /^(CR)?\d{9,12}$/.test(l);
    },
    EC: function(l) {
      return /^(EC)?\d{13}$/.test(l);
    },
    SV: function(l) {
      return /^(SV)?\d{4}-\d{6}-\d{3}-\d{1}$/.test(l);
    },
    GT: function(l) {
      return /^(GT)?\d{7}-\d{1}$/.test(l);
    },
    HN: function(l) {
      return /^(HN)?$/.test(l);
    },
    MX: function(l) {
      return /^(MX)?\w{3,4}\d{6}\w{3}$/.test(l);
    },
    NI: function(l) {
      return /^(NI)?\d{3}-\d{6}-\d{4}\w{1}$/.test(l);
    },
    PA: function(l) {
      return /^(PA)?$/.test(l);
    },
    PY: function(l) {
      return /^(PY)?\d{6,8}-\d{1}$/.test(l);
    },
    PE: function(l) {
      return /^(PE)?\d{11}$/.test(l);
    },
    DO: function(l) {
      return /^(DO)?(\d{11}|(\d{3}-\d{7}-\d{1})|[1,4,5]{1}\d{8}|([1,4,5]{1})-\d{2}-\d{5}-\d{1})$/.test(l);
    },
    UY: function(l) {
      return /^(UY)?\d{12}$/.test(l);
    },
    VE: function(l) {
      return /^(VE)?[J,G,V,E]{1}-(\d{9}|(\d{8}-\d{1}))$/.test(l);
    }
  };
  function c(f, l) {
    if ((0, e.default)(f), (0, e.default)(l), l in s)
      return s[l](f);
    throw new Error("Invalid country code: '".concat(l, "'"));
  }
  return We;
}
var ai;
function f8() {
  return ai || (ai = 1, function(t, e) {
    function r(J) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(fe) {
        return typeof fe;
      } : function(fe) {
        return fe && typeof Symbol == "function" && fe.constructor === Symbol && fe !== Symbol.prototype ? "symbol" : typeof fe;
      }, r(J);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = L(/* @__PURE__ */ g0()), d = L(/* @__PURE__ */ Ji()), a = L(/* @__PURE__ */ w6()), i = L(/* @__PURE__ */ B6()), u = L(/* @__PURE__ */ U6()), o = L(/* @__PURE__ */ vu()), s = L(/* @__PURE__ */ $o()), c = L(/* @__PURE__ */ d0()), f = L(/* @__PURE__ */ K1()), l = L(/* @__PURE__ */ i1()), _ = L(/* @__PURE__ */ st()), p = L(/* @__PURE__ */ q6()), $ = L(/* @__PURE__ */ gn()), h = L(/* @__PURE__ */ V2()), g = L(/* @__PURE__ */ Z6()), A = L(/* @__PURE__ */ wo()), R = L(/* @__PURE__ */ m2()), y = L(/* @__PURE__ */ k6()), S = Ae(/* @__PURE__ */ _u()), O = Ae(/* @__PURE__ */ Su()), P = L(/* @__PURE__ */ qo()), b = Ae(/* @__PURE__ */ O2()), I = L(/* @__PURE__ */ f1()), E = L(/* @__PURE__ */ P1()), T = L(/* @__PURE__ */ ro()), U = L(/* @__PURE__ */ H6()), Z = L(/* @__PURE__ */ Cu()), H = L(/* @__PURE__ */ a0()), W = L(/* @__PURE__ */ i0()), re = L(/* @__PURE__ */ Xu()), _e = L(/* @__PURE__ */ k1()), _n = L(/* @__PURE__ */ H2()), In = L(/* @__PURE__ */ j1()), lt = L(/* @__PURE__ */ o0()), ft = Ae(/* @__PURE__ */ zi()), An = L(/* @__PURE__ */ Eu()), Sn = L(/* @__PURE__ */ u0()), bn = L(/* @__PURE__ */ P2()), Mn = L(/* @__PURE__ */ Xi()), En = L(/* @__PURE__ */ t1()), Rn = L(/* @__PURE__ */ q2()), Pn = L(/* @__PURE__ */ u2()), Cn = L(/* @__PURE__ */ h2()), ct = Ae(/* @__PURE__ */ l2()), Nn = L(/* @__PURE__ */ Vo()), On = L(/* @__PURE__ */ G6()), de = L(/* @__PURE__ */ Co()), ae = L(/* @__PURE__ */ M1()), $t = L(/* @__PURE__ */ A1()), Ce = L(/* @__PURE__ */ j6()), xn = L(/* @__PURE__ */ io()), v = L(/* @__PURE__ */ n0()), m = L(/* @__PURE__ */ V6()), M = L(/* @__PURE__ */ J1()), F = L(/* @__PURE__ */ U1()), x = L(/* @__PURE__ */ W6()), w = L(/* @__PURE__ */ K6()), q = L(/* @__PURE__ */ Y6()), k = L(/* @__PURE__ */ Fu()), G = L(/* @__PURE__ */ wu()), z = L(/* @__PURE__ */ $2()), Ie = L(/* @__PURE__ */ t2()), ve = L(/* @__PURE__ */ g1()), le = L(/* @__PURE__ */ v1()), Qe = L(/* @__PURE__ */ xo()), vt = L(/* @__PURE__ */ K2()), ge = Ae(/* @__PURE__ */ O1()), Ne = L(/* @__PURE__ */ d2()), pt = L(/* @__PURE__ */ qu()), Zs = L(/* @__PURE__ */ Yo()), m0 = /* @__PURE__ */ z6(), ks = L(/* @__PURE__ */ J6()), Hs = L(/* @__PURE__ */ _1()), Gs = L(/* @__PURE__ */ w2()), js = L(/* @__PURE__ */ X6()), Vs = L(/* @__PURE__ */ l0()), Ws = L(/* @__PURE__ */ F1()), Ks = L(/* @__PURE__ */ Q6()), Ys = L(/* @__PURE__ */ Y2()), zs = L(/* @__PURE__ */ Ho()), Js = L(/* @__PURE__ */ z2()), Xs = L(/* @__PURE__ */ r0()), Qs = L(/* @__PURE__ */ Xo()), e9 = L(/* @__PURE__ */ A2()), t9 = L(/* @__PURE__ */ e8()), r9 = L(/* @__PURE__ */ M2()), n9 = L(/* @__PURE__ */ Oi()), _0 = Ae(/* @__PURE__ */ T2()), d9 = L(/* @__PURE__ */ X2()), a9 = L(/* @__PURE__ */ J2()), i9 = L(/* @__PURE__ */ Q2()), u9 = L(/* @__PURE__ */ t8()), o9 = L(/* @__PURE__ */ r8()), s9 = L(/* @__PURE__ */ n8()), l9 = L(/* @__PURE__ */ d8()), f9 = L(/* @__PURE__ */ es()), c9 = L(/* @__PURE__ */ a8()), $9 = L(/* @__PURE__ */ i8()), v9 = L(/* @__PURE__ */ u8()), p9 = L(/* @__PURE__ */ o8()), h9 = L(/* @__PURE__ */ s8()), g9 = L(/* @__PURE__ */ l8());
    function I0(J) {
      if (typeof WeakMap != "function") return null;
      var fe = /* @__PURE__ */ new WeakMap(), Se = /* @__PURE__ */ new WeakMap();
      return (I0 = function(Dn) {
        return Dn ? Se : fe;
      })(J);
    }
    function Ae(J, fe) {
      if (J && J.__esModule) return J;
      if (J === null || r(J) != "object" && typeof J != "function") return { default: J };
      var Se = I0(fe);
      if (Se && Se.has(J)) return Se.get(J);
      var Oe = { __proto__: null }, Dn = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var xe in J) if (xe !== "default" && {}.hasOwnProperty.call(J, xe)) {
        var ht = Dn ? Object.getOwnPropertyDescriptor(J, xe) : null;
        ht && (ht.get || ht.set) ? Object.defineProperty(Oe, xe, ht) : Oe[xe] = J[xe];
      }
      return Oe.default = J, Se && Se.set(J, Oe), Oe;
    }
    function L(J) {
      return J && J.__esModule ? J : { default: J };
    }
    var y9 = "13.15.0", m9 = {
      version: y9,
      toDate: n.default,
      toFloat: d.default,
      toInt: a.default,
      toBoolean: i.default,
      equals: u.default,
      contains: o.default,
      matches: s.default,
      isEmail: c.default,
      isURL: f.default,
      isMACAddress: l.default,
      isIP: _.default,
      isIPRange: p.default,
      isFQDN: $.default,
      isBoolean: A.default,
      isIBAN: ct.default,
      isBIC: Nn.default,
      isAbaRouting: y.default,
      isAlpha: S.default,
      isAlphaLocales: S.locales,
      isAlphanumeric: O.default,
      isAlphanumericLocales: O.locales,
      isNumeric: P.default,
      isPassportNumber: b.default,
      passportNumberLocales: b.locales,
      isPort: I.default,
      isLowercase: E.default,
      isUppercase: T.default,
      isAscii: Z.default,
      isFullWidth: H.default,
      isHalfWidth: W.default,
      isVariableWidth: re.default,
      isMultibyte: _e.default,
      isSemVer: _n.default,
      isSurrogatePair: In.default,
      isInt: lt.default,
      isIMEI: U.default,
      isFloat: ft.default,
      isFloatLocales: ft.locales,
      isDecimal: An.default,
      isHexadecimal: Sn.default,
      isOctal: bn.default,
      isDivisibleBy: Mn.default,
      isHexColor: En.default,
      isRgbColor: Rn.default,
      isHSL: Pn.default,
      isISRC: Cn.default,
      isMD5: On.default,
      isHash: de.default,
      isJWT: ae.default,
      isJSON: $t.default,
      isEmpty: Ce.default,
      isLength: xn.default,
      isLocale: R.default,
      isByteLength: v.default,
      isULID: m.default,
      isUUID: M.default,
      isMongoId: F.default,
      isAfter: x.default,
      isBefore: w.default,
      isIn: q.default,
      isLuhnNumber: k.default,
      isCreditCard: G.default,
      isIdentityCard: z.default,
      isEAN: Ie.default,
      isISIN: ve.default,
      isISBN: le.default,
      isISSN: Qe.default,
      isMobilePhone: ge.default,
      isMobilePhoneLocales: ge.locales,
      isPostalCode: _0.default,
      isPostalCodeLocales: _0.locales,
      isEthereumAddress: Ne.default,
      isCurrency: pt.default,
      isBtcAddress: Zs.default,
      isISO6346: m0.isISO6346,
      isFreightContainerID: m0.isFreightContainerID,
      isISO6391: ks.default,
      isISO8601: Hs.default,
      isISO15924: js.default,
      isRFC3339: Gs.default,
      isISO31661Alpha2: Vs.default,
      isISO31661Alpha3: Ws.default,
      isISO31661Numeric: Ks.default,
      isISO4217: Ys.default,
      isBase32: zs.default,
      isBase58: Js.default,
      isBase64: Xs.default,
      isDataURI: Qs.default,
      isMagnetURI: e9.default,
      isMailtoURI: t9.default,
      isMimeType: r9.default,
      isLatLong: n9.default,
      ltrim: d9.default,
      rtrim: a9.default,
      trim: i9.default,
      escape: u9.default,
      unescape: o9.default,
      stripLow: s9.default,
      whitelist: l9.default,
      blacklist: f9.default,
      isWhitelisted: c9.default,
      normalizeEmail: $9.default,
      toString,
      isSlug: v9.default,
      isStrongPassword: h9.default,
      isTaxID: vt.default,
      isDate: h.default,
      isTime: g.default,
      isLicensePlate: p9.default,
      isVAT: g9.default,
      ibanLocales: ct.locales
    };
    e.default = m9, t.exports = e.default, t.exports.default = e.default;
  }(Er, Er.exports)), Er.exports;
}
var c8 = /* @__PURE__ */ f8(), ts = "isStrongPassword";
function rs(t, e) {
  return typeof t == "string" && c8.isStrongPassword(t, e);
}
function $8(t, e) {
  return N({
    name: ts,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return rs(r, n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property is not strong enough";
      }, e)
    }
  }, e);
}
var ns = "isTimeZone";
function ds(t) {
  try {
    return typeof t != "string" ? !1 : (Intl.DateTimeFormat(void 0, { timeZone: t }), !0);
  } catch {
    return !1;
  }
}
function v8(t) {
  return N({
    name: ns,
    validator: {
      validate: function(e, r) {
        return ds(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a valid IANA time-zone";
      }, t)
    }
  }, t);
}
var p8 = /* @__PURE__ */ z2();
const h8 = /* @__PURE__ */ B(p8);
var as = "isBase58";
function is(t) {
  return typeof t == "string" && h8(t);
}
function g8(t) {
  return N({
    name: as,
    validator: {
      validate: function(e, r) {
        return is(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be base58 encoded";
      }, t)
    }
  }, t);
}
var y8 = /* @__PURE__ */ K2();
const m8 = /* @__PURE__ */ B(y8);
var us = "isTaxId";
function os(t, e) {
  return typeof t == "string" && m8(t, e || "en-US");
}
function _8(t, e) {
  return N({
    name: us,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return os(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a Tax Identification Number";
      }, e)
    }
  }, e);
}
var I8 = /* @__PURE__ */ Y2();
const A8 = /* @__PURE__ */ B(I8);
var ss = "isISO4217CurrencyCode";
function ls(t) {
  return typeof t == "string" && A8(t);
}
function S8(t) {
  return N({
    name: ss,
    validator: {
      validate: function(e, r) {
        return ls(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a valid ISO4217 currency code";
      }, t)
    }
  }, t);
}
var fs = "isBoolean";
function cs(t) {
  return t instanceof Boolean || typeof t == "boolean";
}
function b8(t) {
  return N({
    name: fs,
    validator: {
      validate: function(e, r) {
        return cs(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a boolean value";
      }, t)
    }
  }, t);
}
var $s = "isDate";
function vs(t) {
  return t instanceof Date && !isNaN(t.getTime());
}
function M8(t) {
  return N({
    name: $s,
    validator: {
      validate: function(e, r) {
        return vs(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a Date instance";
      }, t)
    }
  }, t);
}
var ps = "isNumber";
function hs(t, e) {
  if (e === void 0 && (e = {}), typeof t != "number")
    return !1;
  if (t === 1 / 0 || t === -1 / 0)
    return !!e.allowInfinity;
  if (Number.isNaN(t))
    return !!e.allowNaN;
  if (e.maxDecimalPlaces !== void 0) {
    var r = 0;
    if (t % 1 !== 0 && (r = t.toString().split(".")[1].length), r > e.maxDecimalPlaces)
      return !1;
  }
  return Number.isFinite(t);
}
function E8(t, e) {
  return t === void 0 && (t = {}), N({
    name: ps,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return hs(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a number conforming to the specified constraints";
      }, e)
    }
  }, e);
}
var ii = function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), d, a = [], i;
  try {
    for (; (e === void 0 || e-- > 0) && !(d = n.next()).done; ) a.push(d.value);
  } catch (u) {
    i = { error: u };
  } finally {
    try {
      d && !d.done && (r = n.return) && r.call(n);
    } finally {
      if (i) throw i.error;
    }
  }
  return a;
}, gs = "isEnum";
function ys(t, e) {
  var r = Object.keys(e).map(function(n) {
    return e[n];
  });
  return r.includes(t);
}
function R8(t) {
  return Object.entries(t).filter(function(e) {
    var r = ii(e, 2), n = r[0];
    return r[1], isNaN(parseInt(n));
  }).map(function(e) {
    var r = ii(e, 2);
    r[0];
    var n = r[1];
    return n;
  });
}
function P8(t, e) {
  return N({
    name: gs,
    constraints: [t, R8(t)],
    validator: {
      validate: function(r, n) {
        return ys(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be one of the following values: $constraint2";
      }, e)
    }
  }, e);
}
var ms = "isInt";
function _s(t) {
  return typeof t == "number" && Number.isInteger(t);
}
function C8(t) {
  return N({
    name: ms,
    validator: {
      validate: function(e, r) {
        return _s(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be an integer number";
      }, t)
    }
  }, t);
}
var Is = "isString";
function As(t) {
  return t instanceof String || typeof t == "string";
}
function N8(t) {
  return N({
    name: Is,
    validator: {
      validate: function(e, r) {
        return As(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be a string";
      }, t)
    }
  }, t);
}
var Ss = "isArray";
function bs(t) {
  return Array.isArray(t);
}
function O8(t) {
  return N({
    name: Ss,
    validator: {
      validate: function(e, r) {
        return bs(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be an array";
      }, t)
    }
  }, t);
}
var Ms = "isObject";
function y0(t) {
  return t != null && (typeof t == "object" || typeof t == "function") && !Array.isArray(t);
}
function x8(t) {
  return N({
    name: Ms,
    validator: {
      validate: function(e, r) {
        return y0(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property must be an object";
      }, t)
    }
  }, t);
}
var Es = "arrayContains";
function Rs(t, e) {
  return Array.isArray(t) ? e.every(function(r) {
    return t.indexOf(r) !== -1;
  }) : !1;
}
function D8(t, e) {
  return N({
    name: Es,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Rs(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must contain $constraint1 values";
      }, e)
    }
  }, e);
}
var Ps = "arrayNotContains";
function Cs(t, e) {
  return Array.isArray(t) ? e.every(function(r) {
    return t.indexOf(r) === -1;
  }) : !1;
}
function T8(t, e) {
  return N({
    name: Ps,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Cs(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property should not contain $constraint1 values";
      }, e)
    }
  }, e);
}
var Ns = "arrayNotEmpty";
function Os(t) {
  return Array.isArray(t) && t.length > 0;
}
function L8(t) {
  return N({
    name: Ns,
    validator: {
      validate: function(e, r) {
        return Os(e);
      },
      defaultMessage: C(function(e) {
        return e + "$property should not be empty";
      }, t)
    }
  }, t);
}
var xs = "arrayMinSize";
function Ds(t, e) {
  return Array.isArray(t) && t.length >= e;
}
function F8(t, e) {
  return N({
    name: xs,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Ds(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must contain at least $constraint1 elements";
      }, e)
    }
  }, e);
}
var Ts = "arrayMaxSize";
function Ls(t, e) {
  return Array.isArray(t) && t.length <= e;
}
function w8(t, e) {
  return N({
    name: Ts,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Ls(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must contain no more than $constraint1 elements";
      }, e)
    }
  }, e);
}
var Fs = "arrayUnique";
function ws(t, e) {
  if (!Array.isArray(t))
    return !1;
  e && (t = t.map(function(n) {
    return n != null ? e(n) : n;
  }));
  var r = t.filter(function(n, d, a) {
    return a.indexOf(n) === d;
  });
  return t.length === r.length;
}
function B8(t, e) {
  var r = typeof t == "function" ? t : void 0, n = typeof t != "function" ? t : e;
  return N({
    name: Fs,
    validator: {
      validate: function(d, a) {
        return ws(d, r);
      },
      defaultMessage: C(function(d) {
        return d + "All $property's elements must be unique";
      }, n)
    }
  }, n);
}
var Bs = "isNotEmptyObject";
function Us(t, e) {
  if (!y0(t))
    return !1;
  if ((e == null ? void 0 : e.nullable) === !1)
    return !Object.values(t).every(function(n) {
      return n == null;
    });
  for (var r in t)
    if (t.hasOwnProperty(r))
      return !0;
  return !1;
}
function U8(t, e) {
  return N({
    name: Bs,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return Us(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r) {
        return r + "$property must be a non-empty object";
      }, e)
    }
  }, e);
}
var Qn = "isInstance";
function qs(t, e) {
  return e && typeof e == "function" && t instanceof e;
}
function q8(t, e) {
  return N({
    name: Qn,
    constraints: [t],
    validator: {
      validate: function(r, n) {
        return qs(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: C(function(r, n) {
        return n != null && n.constraints[0] ? r + "$property must be an instance of ".concat(n == null ? void 0 : n.constraints[0].name) : r + "".concat(Qn, " decorator expects and object as value, but got falsy value.");
      }, e)
    }
  }, e);
}
function Z8(t, e, r) {
  return typeof t == "string" ? pe(Pe).validate(t, e, r) : pe(Pe).validate(t, e);
}
function k8(t, e, r) {
  return typeof t == "string" ? pe(Pe).validateOrReject(t, e, r) : pe(Pe).validateOrReject(t, e);
}
function H8(t, e, r) {
  return typeof t == "string" ? pe(Pe).validateSync(t, e, r) : pe(Pe).validateSync(t, e);
}
function G8(t) {
  ie().addValidationSchema(t);
}
const j8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ARRAY_CONTAINS: Es,
  ARRAY_MAX_SIZE: Ts,
  ARRAY_MIN_SIZE: xs,
  ARRAY_NOT_CONTAINS: Ps,
  ARRAY_NOT_EMPTY: Ns,
  ARRAY_UNIQUE: Fs,
  Allow: q9,
  ArrayContains: D8,
  ArrayMaxSize: w8,
  ArrayMinSize: F8,
  ArrayNotContains: T8,
  ArrayNotEmpty: L8,
  ArrayUnique: B8,
  CONTAINS: hu,
  Contains: pl,
  EQUALS: wi,
  Equals: Q9,
  IS_ALPHA: Iu,
  IS_ALPHANUMERIC: bu,
  IS_ARRAY: Ss,
  IS_ASCII: Nu,
  IS_BASE32: Go,
  IS_BASE58: as,
  IS_BASE64: xu,
  IS_BIC: Wo,
  IS_BOOLEAN: fs,
  IS_BOOLEAN_STRING: Bo,
  IS_BTC_ADDRESS: zo,
  IS_BYTE_LENGTH: Tu,
  IS_CREDIT_CARD: Bu,
  IS_CURRENCY: Zu,
  IS_DATA_URI: Qo,
  IS_DATE: $s,
  IS_DATE_STRING: Lo,
  IS_DECIMAL: Ru,
  IS_DEFINED: Pi,
  IS_DIVISIBLE_BY: Qi,
  IS_EAN: r2,
  IS_EMAIL: Gu,
  IS_EMPTY: Zi,
  IS_ENUM: gs,
  IS_ETHEREUM_ADDRESS: a2,
  IS_FIREBASE_PUSH_ID: eo,
  IS_FQDN: Vu,
  IS_FULL_WIDTH: Ku,
  IS_HALF_WIDTH: zu,
  IS_HASH: No,
  IS_HEXADECIMAL: d1,
  IS_HEX_COLOR: r1,
  IS_HSL: o2,
  IS_IBAN: f2,
  IS_IDENTITY_CARD: v2,
  IS_IN: ji,
  IS_INSTANCE: Qn,
  IS_INT: ms,
  IS_IP: s1,
  IS_ISBN: p1,
  IS_ISIN: y1,
  IS_ISO31661_ALPHA_2: T1,
  IS_ISO31661_ALPHA_3: w1,
  IS_ISO4217_CURRENCY_CODE: ss,
  IS_ISO8601: I1,
  IS_ISRC: g2,
  IS_ISSN: Do,
  IS_JSON: S1,
  IS_JWT: E1,
  IS_LATITUDE: Di,
  IS_LATLONG: xi,
  IS_LENGTH: uo,
  IS_LOCALE: _2,
  IS_LONGITUDE: Li,
  IS_LOWERCASE: C1,
  IS_MAC_ADDRESS: u1,
  IS_MAGNET_URI: S2,
  IS_MILITARY_TIME: Ro,
  IS_MIME_TYPE: E2,
  IS_MOBILE_PHONE: x1,
  IS_MONGO_ID: q1,
  IS_MULTIBYTE: H1,
  IS_NEGATIVE: nu,
  IS_NOT_EMPTY: Hi,
  IS_NOT_EMPTY_OBJECT: Bs,
  IS_NOT_IN: Wi,
  IS_NUMBER: ps,
  IS_NUMBER_STRING: Zo,
  IS_OBJECT: Ms,
  IS_OCTAL: C2,
  IS_OPTIONAL: Ni,
  IS_PASSPORT_NUMBER: x2,
  IS_PHONE_NUMBER: Mo,
  IS_PORT: c1,
  IS_POSITIVE: tu,
  IS_POSTAL_CODE: L2,
  IS_RFC_3339: B2,
  IS_RGB_COLOR: Z2,
  IS_SEM_VER: G2,
  IS_STRING: Is,
  IS_STRONG_PASSWORD: ts,
  IS_SURROGATE_PAIR: V1,
  IS_TAX_ID: us,
  IS_TIMEZONE: ns,
  IS_UPPERCASE: no,
  IS_URL: Y1,
  IS_UUID: X1,
  IS_VARIABLE_WIDTH: Qu,
  IsAlpha: ml,
  IsAlphanumeric: Al,
  IsArray: O8,
  IsAscii: Cl,
  IsBIC: Bc,
  IsBase32: Lc,
  IsBase58: g8,
  IsBase64: xl,
  IsBoolean: b8,
  IsBooleanString: Cc,
  IsBtcAddress: Zc,
  IsByteLength: Ll,
  IsCreditCard: Bl,
  IsCurrency: Zl,
  IsDataURI: Gc,
  IsDate: M8,
  IsDateString: Ec,
  IsDecimal: El,
  IsDefined: Z9,
  IsDivisibleBy: ul,
  IsEAN: Wc,
  IsEmail: Gl,
  IsEmpty: tl,
  IsEnum: P8,
  IsEthereumAddress: zc,
  IsFQDN: Wl,
  IsFirebasePushId: u3,
  IsFullWidth: zl,
  IsHSL: Qc,
  IsHalfWidth: Ql,
  IsHash: Ac,
  IsHexColor: af,
  IsHexadecimal: sf,
  IsIBAN: r6,
  IsIP: pf,
  IsISBN: If,
  IsISIN: bf,
  IsISO31661Alpha2: kf,
  IsISO31661Alpha3: jf,
  IsISO4217CurrencyCode: S8,
  IsISO8601: Rf,
  IsISRC: o6,
  IsISSN: Mc,
  IsIdentityCard: a6,
  IsIn: nl,
  IsInstance: q8,
  IsInt: C8,
  IsJSON: Nf,
  IsJWT: Df,
  IsLatLong: z9,
  IsLatitude: J9,
  IsLocale: f6,
  IsLongitude: X9,
  IsLowercase: Ff,
  IsMACAddress: cf,
  IsMagnetURI: v6,
  IsMilitaryTime: mc,
  IsMimeType: g6,
  IsMobilePhone: Uf,
  IsMongoId: Kf,
  IsMultibyte: Jf,
  IsNegative: sl,
  IsNotEmpty: rl,
  IsNotEmptyObject: U8,
  IsNotIn: dl,
  IsNumber: E8,
  IsNumberString: xc,
  IsObject: x8,
  IsOctal: _6,
  IsOptional: k9,
  IsPassportNumber: S6,
  IsPhoneNumber: yc,
  IsPort: yf,
  IsPositive: ol,
  IsPostalCode: E6,
  IsRFC3339: C6,
  IsRgbColor: x6,
  IsSemVer: F6,
  IsString: N8,
  IsStrongPassword: $8,
  IsSurrogatePair: e3,
  IsTaxId: _8,
  IsTimeZone: v8,
  IsUUID: i3,
  IsUppercase: l3,
  IsUrl: n3,
  IsVariableWidth: rf,
  Length: c3,
  MATCHES: po,
  MAX: au,
  MAX_DATE: fu,
  MAX_LENGTH: so,
  MIN: uu,
  MIN_DATE: su,
  MIN_LENGTH: fo,
  Matches: h3,
  Max: ll,
  MaxDate: $l,
  MaxLength: $3,
  MetadataStorage: t0,
  Min: fl,
  MinDate: cl,
  MinLength: v3,
  NOT_CONTAINS: yu,
  NOT_EQUALS: Ui,
  NotContains: hl,
  NotEquals: el,
  Validate: G9,
  ValidateBy: N,
  ValidateIf: j9,
  ValidateNested: V9,
  ValidatePromise: W9,
  ValidationError: Hn,
  ValidationTypes: Q,
  Validator: Pe,
  ValidatorConstraint: H9,
  arrayContains: Rs,
  arrayMaxSize: Ls,
  arrayMinSize: Ds,
  arrayNotContains: Cs,
  arrayNotEmpty: Os,
  arrayUnique: ws,
  buildMessage: C,
  contains: gu,
  equals: Bi,
  getFromContainer: pe,
  getMetadataStorage: ie,
  isAlpha: Au,
  isAlphanumeric: Mu,
  isArray: bs,
  isAscii: Ou,
  isBIC: Ko,
  isBase32: jo,
  isBase58: is,
  isBase64: Du,
  isBoolean: cs,
  isBooleanString: Uo,
  isBtcAddress: Jo,
  isByteLength: Lu,
  isCreditCard: Uu,
  isCurrency: ku,
  isDataURI: e2,
  isDate: vs,
  isDateString: Fo,
  isDecimal: Pu,
  isDefined: Ci,
  isDivisibleBy: eu,
  isEAN: n2,
  isEmail: ju,
  isEmpty: ki,
  isEnum: ys,
  isEthereumAddress: i2,
  isFQDN: Wu,
  isFirebasePushId: to,
  isFullWidth: Yu,
  isHSL: s2,
  isHalfWidth: Ju,
  isHash: Oo,
  isHexColor: n1,
  isHexadecimal: a1,
  isIBAN: c2,
  isIP: l1,
  isISBN: h1,
  isISIN: m1,
  isISO31661Alpha2: L1,
  isISO31661Alpha3: B1,
  isISO4217CurrencyCode: ls,
  isISO8601: s0,
  isISRC: y2,
  isISSN: To,
  isIdentityCard: p2,
  isIn: Vi,
  isInstance: qs,
  isInt: _s,
  isJSON: b1,
  isJWT: R1,
  isLatLong: hn,
  isLatitude: Ti,
  isLocale: I2,
  isLongitude: Fi,
  isLowercase: N1,
  isMACAddress: o1,
  isMagnetURI: b2,
  isMilitaryTime: Po,
  isMimeType: R2,
  isMobilePhone: D1,
  isMongoId: Z1,
  isMultibyte: G1,
  isNegative: du,
  isNotEmpty: Gi,
  isNotEmptyObject: Us,
  isNotIn: Ki,
  isNumber: hs,
  isNumberString: ko,
  isObject: y0,
  isOctal: N2,
  isPassportNumber: D2,
  isPhoneNumber: Eo,
  isPort: $1,
  isPositive: ru,
  isPostalCode: F2,
  isRFC3339: U2,
  isRgbColor: k2,
  isSemVer: j2,
  isString: As,
  isStrongPassword: rs,
  isSurrogatePair: W1,
  isTaxId: os,
  isTimeZone: ds,
  isURL: z1,
  isUUID: Q1,
  isUppercase: ao,
  isValidationOptions: Vn,
  isVariableWidth: e1,
  length: oo,
  matches: ho,
  max: iu,
  maxDate: cu,
  maxLength: lo,
  min: ou,
  minDate: lu,
  minLength: co,
  notContains: mu,
  notEquals: qi,
  registerDecorator: Ri,
  registerSchema: G8,
  useContainer: U9,
  validate: Z8,
  validateOrReject: k8,
  validateSync: H8
}, Symbol.toStringTag, { value: "Module" })), V8 = /* @__PURE__ */ I9(j8);
var ui;
function W8() {
  if (ui) return ce;
  ui = 1;
  var t = ce && ce.__decorate || function(d, a, i, u) {
    var o = arguments.length, s = o < 3 ? a : u === null ? u = Object.getOwnPropertyDescriptor(a, i) : u, c;
    if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(d, a, i, u);
    else for (var f = d.length - 1; f >= 0; f--) (c = d[f]) && (s = (o < 3 ? c(s) : o > 3 ? c(a, i, s) : c(a, i)) || s);
    return o > 3 && s && Object.defineProperty(a, i, s), s;
  };
  Object.defineProperty(ce, "__esModule", { value: !0 }), ce.MatchConstraint = ce.Match = void 0;
  const e = V8, r = (d, a) => (i, u) => (0, e.registerDecorator)({
    target: i.constructor,
    propertyName: u,
    options: a,
    constraints: [d],
    validator: n
  });
  ce.Match = r;
  let n = class {
    validate(a, i) {
      const [u] = (i == null ? void 0 : i.constraints) || [], o = (i == null ? void 0 : i.object)[u];
      return (0, e.equals)(a, o);
    }
    defaultMessage(a) {
      const [i] = (a == null ? void 0 : a.constraints) || [];
      return `${a == null ? void 0 : a.property} does not match the ${i}`;
    }
  };
  return ce.MatchConstraint = n, ce.MatchConstraint = n = t([
    (0, e.ValidatorConstraint)({ name: "Match" })
  ], n), ce;
}
var Un = {}, oi;
function K8() {
  return oi || (oi = 1, Object.defineProperty(Un, "__esModule", { value: !0 })), Un;
}
var un = {}, si;
function Y8() {
  if (si) return un;
  si = 1, Object.defineProperty(un, "__esModule", { value: !0 }), un.isPlural = r;
  const t = /* @__PURE__ */ new Set([
    "address",
    "athletics",
    "billiards",
    "bowels",
    "business",
    "chaos",
    "chess",
    "crossroads",
    "economics",
    "ethics",
    "gallows",
    "gas",
    "genetics",
    "glass",
    "grass",
    "gymnastics",
    "happiness",
    "kindness",
    "linguistics",
    "loneliness",
    "mathematics",
    "measles",
    "minus",
    "mumps",
    "news",
    "physics",
    "progress",
    "success",
    "tennis",
    "acoustics",
    "aerobics",
    "aerodynamics",
    "aeronautics",
    "classics",
    "electronics",
    "logistics",
    "mechanics",
    "obstetrics",
    "politics",
    "statistics",
    "thermodynamics",
    "bowls",
    "cards",
    "darts",
    "diabetes",
    "rabies",
    "draughts",
    "skittles",
    "rickets",
    "shingles",
    "iris",
    "lens",
    "status"
  ]), e = /* @__PURE__ */ new Set([
    "feet",
    "teeth",
    "geese",
    "men",
    "women",
    "mice",
    "dice",
    "oxen",
    "children",
    "people",
    "pence",
    "foci",
    "radii",
    "fungi",
    "nuclei",
    "cacti",
    "alumni",
    "phenomena",
    "criteria",
    "data",
    "memoranda",
    "bacteria",
    "strata",
    "curricula",
    "media",
    "stadia",
    "syllabi",
    "antennae",
    "lice",
    "genera",
    "stimuli"
  ]);
  function r(n) {
    const d = n.toLowerCase();
    return !t.has(d) && !d.endsWith("itis") && !d.endsWith("osis") && (d.endsWith("s") || e.has(d));
  }
  return un;
}
var Re = {}, li;
function z8() {
  if (li) return Re;
  li = 1, Object.defineProperty(Re, "__esModule", { value: !0 }), Re.EnumError = void 0, Re.createLookup = e, Re.createValues = r;
  class t extends Error {
    constructor(d) {
      super(d), Object.setPrototypeOf(this, t.prototype);
    }
  }
  Re.EnumError = t;
  function e(n, d, a) {
    const i = Object.entries(n).reduce((o, [s, c]) => Object.assign(Object.assign({}, o), { [c]: s }), {}), u = Object.values(n).join(", ");
    return (o) => {
      if (o == null)
        return o;
      const s = i[o.trim()];
      if (s === void 0) {
        if (d)
          return d;
        const c = `Enum value ${o.trim()} not found in [${u}].`;
        if (a === !0)
          throw new t(c);
        if (typeof a == "function")
          throw a(c);
      }
      return n[s];
    };
  }
  function r(n) {
    const d = Object.values(n).filter((a) => typeof a != "function");
    return () => d;
  }
  return Re;
}
var qn = {}, fi;
function J8() {
  return fi || (fi = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.env = void 0, t.forEnv = a, t.fromEnv = i;
    const e = bi(), r = Xe();
    t.env = {
      serialize: n,
      deserialize: d
    };
    function n(u) {
      const o = {};
      return Object.entries(u).forEach(([s, c]) => {
        c === void 0 ? o[s] = "u:" : c === null ? o[s] = "n:" : typeof c == "string" ? o[s] = `S:${c}` : typeof c == "boolean" ? o[s] = `B:${c}` : typeof c == "number" ? o[s] = `N:${c}` : c instanceof Date ? o[s] = `D:${c.toISOString()}` : o[s] = `X:${(0, r.json)(c, !1)}`;
      }), o;
    }
    function d(u) {
      const o = {};
      return Object.entries(u).forEach(([s, c]) => {
        if (c == null) {
          o[s] = c;
          return;
        }
        const [f, l] = (0, r.split)(c, 2);
        switch (f) {
          case "S:":
            o[s] = l;
            break;
          case "B:":
            o[s] = l === "true";
            break;
          case "N:":
            o[s] = Number(l);
            break;
          case "D:":
            o[s] = new Date(l);
            break;
          case "X:":
            o[s] = JSON.parse(l);
            break;
          case "u:":
            o[s] = void 0;
            break;
          case "n:":
            o[s] = null;
            break;
          default:
            o[s] = c;
            break;
        }
      }), o;
    }
    function a(u, o, s) {
      return t.env.serialize((0, e.flatten)(u, o, s));
    }
    function i(u, o, s) {
      return (0, e.grow)(t.env.deserialize(u), o, s);
    }
  }(qn)), qn;
}
var nt = {}, ci;
function X8() {
  if (ci) return nt;
  ci = 1, Object.defineProperty(nt, "__esModule", { value: !0 }), nt.noop = t, nt.debounce = e;
  function t() {
  }
  function e(r, n) {
    let d = null;
    return function(...a) {
      const i = a;
      d && clearTimeout(d), d = setTimeout(() => {
        r(...i), d = null;
      }, n);
    };
  }
  return nt;
}
var ue = {}, $i;
function Q8() {
  if ($i) return ue;
  $i = 1;
  var t = ue && ue.__asyncValues || function(u) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var o = u[Symbol.asyncIterator], s;
    return o ? o.call(u) : (u = typeof __values == "function" ? __values(u) : u[Symbol.iterator](), s = {}, c("next"), c("throw"), c("return"), s[Symbol.asyncIterator] = function() {
      return this;
    }, s);
    function c(l) {
      s[l] = u[l] && function(_) {
        return new Promise(function(p, $) {
          _ = u[l](_), f(p, $, _.done, _.value);
        });
      };
    }
    function f(l, _, p, $) {
      Promise.resolve($).then(function(h) {
        l({ value: h, done: p });
      }, _);
    }
  };
  Object.defineProperty(ue, "__esModule", { value: !0 }), ue.readBodyBuffer = e, ue.readBodyData = r, ue.readBodyJson = n, ue.parseUrl = d, ue.urlPathJoin = a, ue.urlQueryJoin = i;
  async function e(u, o) {
    var s, c, f, l;
    o = o ?? u;
    let _ = o.bodyBuffer;
    if (_ === void 0) {
      if (!u.readableLength)
        return;
      const g = [];
      try {
        for (var p = !0, $ = t(u), h; h = await $.next(), s = h.done, !s; p = !0) {
          l = h.value, p = !1;
          const A = l;
          g.push(A);
        }
      } catch (A) {
        c = { error: A };
      } finally {
        try {
          !p && !s && (f = $.return) && await f.call($);
        } finally {
          if (c) throw c.error;
        }
      }
      _ = Buffer.concat(g), o.bodyBuffer = _;
    }
    return _;
  }
  async function r(u, o) {
    o = o ?? u;
    let s = o.bodyData;
    if (s === void 0) {
      if (s = await e(u), !s)
        return;
      s = s.toString(), o.bodyData = s;
    }
    return s;
  }
  async function n(u, o) {
    o = o ?? u;
    let s = o.bodyJson;
    if (s === void 0) {
      const c = await r(u);
      if (c === void 0)
        return;
      s = JSON.parse(c), o.bodyJson = s;
    }
    return s;
  }
  function d(u) {
    const o = u.startsWith("https:") ? "https:" : "http:", s = u.indexOf("?");
    let c = u, f = "";
    s !== -1 && (c = u.substr(0, s), f = u.substr(s + 1));
    let l = c.indexOf("://");
    l = l === -1 ? 0 : l + 3;
    let _ = c.indexOf("/", l);
    _ = _ !== -1 ? _ : void 0;
    const p = c.substring(l, _);
    let $ = "";
    return _ !== void 0 && ($ = c.substr(_ + 1)), {
      protocol: o,
      base: c,
      host: p,
      path: $,
      query: f
    };
  }
  function a(u, ...o) {
    let s = u;
    for (const c of o)
      s.endsWith("/") && c.startsWith("/") ? s += c.substring(1) : s.endsWith("/") || c.startsWith("/") ? s += c : s += "/" + c;
    return s;
  }
  function i(...u) {
    return u.join("&");
  }
  return ue;
}
var Ke = {}, vi;
function e5() {
  if (vi) return Ke;
  vi = 1, Object.defineProperty(Ke, "__esModule", { value: !0 }), Ke.Interval = void 0, Ke.interval = i;
  const t = 1e3, r = 60 * (60 * t), n = 24 * r, d = 7 * n;
  class a {
    constructor(o) {
      this.milliseconds = 0, this.milliseconds = o ?? 0;
    }
    millis(o) {
      return this.milliseconds += o, this;
    }
    sec(o) {
      return this.milliseconds += o * t, this;
    }
    min(o) {
      return this.milliseconds += o * r, this;
    }
    hours(o) {
      return this.milliseconds += o * r, this;
    }
    days(o) {
      return this.milliseconds += o * n, this;
    }
    weeks(o) {
      return this.milliseconds += o * d, this;
    }
    value() {
      return this.milliseconds;
    }
    before(o) {
      var s;
      const c = (s = o == null ? void 0 : o.getDate()) !== null && s !== void 0 ? s : Date.now();
      return new Date(c - this.milliseconds);
    }
    after(o) {
      var s;
      const c = (s = o == null ? void 0 : o.getDate()) !== null && s !== void 0 ? s : Date.now();
      return new Date(c + this.milliseconds);
    }
  }
  Ke.Interval = a;
  function i(u) {
    return new a(u);
  }
  return Ke;
}
var Ye = {}, pi;
function t5() {
  if (pi) return Ye;
  pi = 1, Object.defineProperty(Ye, "__esModule", { value: !0 }), Ye.flushPromises = t, Ye.useFakeTimers = e, Ye.advanceTimersByTime = r;
  async function t(n = !1) {
    if (n)
      await new Promise((d) => process.nextTick(d));
    else
      return new Promise(jest.requireActual("timers").setImmediate);
  }
  function e(n = !1) {
    n ? jest.useFakeTimers({ legacyFakeTimers: !0 }) : (jest.useFakeTimers(), jest.setSystemTime(0));
  }
  async function r(n) {
    jest.advanceTimersByTime(n), await t();
  }
  return Ye;
}
var on = {}, hi;
function r5() {
  if (hi) return on;
  hi = 1, Object.defineProperty(on, "__esModule", { value: !0 }), on.pluralize = t;
  function t(e, r, n, d) {
    d = d || n;
    const a = e % 10, i = e % 100;
    return i >= 11 && i <= 14 || a === 0 ? d : a === 1 ? r : a <= 4 ? n : d;
  }
  return on;
}
var sn = {}, gi;
function n5() {
  if (gi) return sn;
  gi = 1, Object.defineProperty(sn, "__esModule", { value: !0 }), sn.onProcessExit = t;
  function t(e) {
    process.on("exit", () => console.log("EXIT")), process.on("SIGINT", async () => {
      await e(), process.exit();
    }), process.on("SIGTERM", async () => {
      await e(), process.exit();
    }), process.on("SIGUSR1", async () => {
      await e(), process.exit();
    }), process.on("SIGUSR2", async () => {
      await e(), process.exit();
    }), process.on("SIGQUIT", async () => {
      await e(), process.exit();
    });
  }
  return sn;
}
var oe = {}, yi;
function d5() {
  if (yi) return oe;
  yi = 1, Object.defineProperty(oe, "__esModule", { value: !0 }), oe.Deferred = oe.PromiseStatus = void 0, oe.promiseWithStatus = e, oe.resolveDelayed = r, oe.pause = n, oe.rejectDelayed = d;
  var t;
  (function(u) {
    u.pending = "pending", u.fulfilled = "fulfilled", u.rejected = "rejected";
  })(t || (oe.PromiseStatus = t = {}));
  function e(u) {
    const o = Promise.resolve(u);
    return o.status = t.pending, o.then((s) => (o.status = t.fulfilled, s)).catch(() => {
      o.status = t.rejected;
    }), o;
  }
  function r(u, o) {
    return new Promise((s) => {
      setTimeout(() => {
        s(o);
      }, u);
    });
  }
  function n(u) {
    return r(u);
  }
  function d(u, o) {
    return new Promise((s, c) => {
      setTimeout(() => {
        c(o);
      }, u);
    });
  }
  let a = 1;
  class i {
    constructor() {
      this._settled = !1, this._resolved = !1, this._rejected = !1, this._promise = new Promise((o, s) => {
        this.resolveFn = o, this.rejectFn = s;
      }), this.id = a++;
    }
    resolve(o) {
      this.resolveFn(o), this._resolved = !0, this._settled = !0;
    }
    reject(o) {
      this.rejectFn(o), this._rejected = !0, this._settled = !0;
    }
    get promise() {
      return this._promise;
    }
    get isSettled() {
      return this._settled;
    }
    get isRejected() {
      return this._rejected;
    }
    get isResolved() {
      return this._resolved;
    }
  }
  return oe.Deferred = i, oe;
}
var Zn = {}, mi;
function a5() {
  return mi || (mi = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.resolved = void 0, t.processTemplate = r;
    function e() {
      function n(a) {
        return Promise.all(a.map((i) => Array.isArray(i) ? n(i) : i));
      }
      function d(a, ...i) {
        return i.length === 1 && a.length === 2 && a[0] === "" && a[1] === "";
      }
      return async function(a, ...i) {
        return d(a, i) ? i[0] : n(i).then((u) => String.raw({ raw: a }, u));
      };
    }
    t.resolved = e();
    async function r(n, d = {}, a = {}) {
      const i = Object.assign(Object.assign(Object.assign({}, d), a), { resolved: t.resolved }), u = Object.keys(i), o = Object.values(i);
      return new Function(...u, "return resolved`" + n + "`")(...o);
    }
  }(Zn)), Zn;
}
var kn = {}, _i;
function i5() {
  return _i || (_i = 1, Object.defineProperty(kn, "__esModule", { value: !0 })), kn;
}
var ln = {}, Ii;
function u5() {
  if (Ii) return ln;
  Ii = 1, Object.defineProperty(ln, "__esModule", { value: !0 }), ln.uuid7 = r;
  let t = 0, e = 0;
  function r() {
    function n() {
      const a = d(), i = Math.random(), u = String(a) + String(~~(i * 9e4) + 1e4), o = u.length;
      return `${u.slice(0, 8)}-${u.slice(8, 12)}-4${u.slice(12, 15)}-${[8, 9, "a", "b"][~~(i * 3)]}${u.slice(15, 18)}-${u.slice(18, 24)}${u.slice(o - 12, o - (30 - o))}`;
    }
    function d() {
      const a = Date.now();
      return a !== t && (t = a, e = 1), BigInt(a) * BigInt(1e6) + BigInt(Math.min(e++, 999999));
    }
    return n();
  }
  return ln;
}
var fn = {}, Ai;
function o5() {
  if (Ai) return fn;
  Ai = 1, Object.defineProperty(fn, "__esModule", { value: !0 }), fn.createEmailAlias = t;
  function t(e, r) {
    const [n, d] = e.split("@");
    return n.includes("+") ? `${n}-${r}@${d}` : `${n}+${r}@${d}`;
  }
  return fn;
}
var Si;
function s5() {
  return Si || (Si = 1, function(t) {
    var e = be && be.__createBinding || (Object.create ? function(n, d, a, i) {
      i === void 0 && (i = a);
      var u = Object.getOwnPropertyDescriptor(d, a);
      (!u || ("get" in u ? !d.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
        return d[a];
      } }), Object.defineProperty(n, i, u);
    } : function(n, d, a, i) {
      i === void 0 && (i = a), n[i] = d[a];
    }), r = be && be.__exportStar || function(n, d) {
      for (var a in n) a !== "default" && !Object.prototype.hasOwnProperty.call(d, a) && e(d, n, a);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), r(b9(), t), r(bi(), t), r(M9(), t), r(E9(), t), r(R9(), t), r(P9(), t), r(W8(), t), r(K8(), t), r(Mi(), t), r(Y8(), t), r(z8(), t), r(J8(), t), r(X8(), t), r(Q8(), t), r(e5(), t), r(t5(), t), r(r5(), t), r(pn(), t), r(n5(), t), r(d5(), t), r(Xe(), t), r(a5(), t), r(i5(), t), r(u5(), t), r(o5(), t);
  }(be)), be;
}
var l5 = s5();
function g5(t, e, r = []) {
  const n = e0(t);
  return Je(() => {
    n.current = t;
  }, [t]), at(
    l5.debounce((...d) => {
      n.current(...d);
    }, e),
    [e, ...r]
  );
}
const f5 = typeof window < "u" ? _9 : Je;
function y5(t) {
  const e = (a) => !!(window != null && window.matchMedia(a).matches), [r, n] = $e(() => e(t));
  function d() {
    n(e(t));
  }
  return f5(() => {
    const a = window == null ? void 0 : window.matchMedia(t);
    return d(), a != null && a.addListener ? a.addListener(d) : a == null || a.addEventListener("change", d), () => {
      a != null && a.removeListener ? a.removeListener(d) : a == null || a.removeEventListener("change", d);
    };
  }, [t]), r;
}
const m5 = (t, e) => {
  const r = e0(!0);
  Je(() => {
    r.current ? r.current = !1 : t();
  }, e);
}, _5 = (t) => {
  const e = e0();
  return Je(() => {
    e.current = t;
  }), e.current;
}, I5 = (t, e = 500) => {
  const [r, n] = $e({
    value: t,
    settled: !0
  });
  Je(() => {
    if (!r.settled) {
      const a = setTimeout(() => {
        n((i) => ({
          ...i,
          settled: !0
        }));
      }, e);
      return () => clearTimeout(a);
    }
  }, [e, r]);
  const d = at((a) => {
    n(typeof a == "function" ? (i) => ({
      value: a(i.value),
      settled: !1
    }) : {
      value: a,
      settled: !1
    });
  }, []);
  return [r, d];
};
export {
  v5 as a,
  p5 as b,
  g5 as c,
  f5 as d,
  y5 as e,
  m5 as f,
  _5 as g,
  I5 as h,
  $5 as u
};
//# sourceMappingURL=use-settled-state-CVoOKoYe.js.map
